<template>
  <div @click="goToPriceGuardPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
            <g>
	<path class="st586" d="M784.4,365.8c6.7-29.5,10.1-61.9,10.1-96.2v-2.2c0-2-1.4-4.5-3.2-5.6c-1.8-1-3.2-0.2-3.2,1.8v2.2
		c0,33.7-3.3,65.6-9.9,94.6c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5C782.7,367.8,784.1,367.4,784.4,365.8z M768,231.4
		c1.1-0.9,0.9-3.4-0.4-5.5c-1.4-2.1-3.4-3.1-4.5-2.1c-5.2,4.2-8,11.6-8,20.8c0,40.8-5.2,106.2-16.7,153.6c-0.4,1.7,0.6,4.4,2.4,5.8
		c0.3,0.2,0.5,0.4,0.8,0.5c1.5,0.8,2.8,0.5,3.1-1c11.6-47.9,16.8-114.1,16.8-155.3C761.5,240.8,763.8,234.8,768,231.4z M818.2,281.1
		c0,2,1.4,4.5,3.2,5.6s3.2,0.2,3.2-1.8c0-22-15.6-49-34.8-60.1c-1.8-1-3.2-0.2-3.2,1.8c0,2,1.4,4.5,3.2,5.6
		C805.4,241.2,818.2,263.2,818.2,281.1z M818.8,324.8c-1.8-1.3-3.4-0.8-3.6,1.1c-4,34.6-11.7,79.3-19.7,113.8
		c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.8,2.8,0.5,3.1-1c8-34.7,15.8-79.6,19.8-114.5
		C821.8,328.7,820.5,326.1,818.8,324.8z M809.6,276.1c0-12.5-8.9-27.8-19.7-34.1c-10.9-6.3-19.7-1.2-19.7,11.3
		c0,4.5-0.1,9.9-0.4,15.9c-0.1,2,1.3,4.5,3.1,5.7c1.8,1.1,3.3,0.4,3.4-1.6c0.3-6.2,0.4-11.6,0.4-16.3c0-8.4,6-11.8,13.3-7.6
		s13.3,14.5,13.3,22.9v2.2c0,33.1-11.7,110.4-22.1,157.3c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.9,2.8,0.5,3.1-1.1
		c10.5-47.3,22.2-125.3,22.2-158.9V276.1z M770.4,307.4c-1.8-1.2-3.4-0.6-3.5,1.3c-3.1,35.1-8.1,77-12.5,104.4
		c-0.3,1.8,0.9,4.4,2.7,5.8c0.2,0.1,0.4,0.3,0.5,0.4c1.5,0.9,2.9,0.4,3.2-1.3c4.4-27.5,9.5-69.6,12.6-104.8
		C773.5,311.2,772.2,308.7,770.4,307.4z M869.9,310.9c0-35.1-17.1-76.5-44.6-108c-1.6-1.8-3.5-2.2-4.3-0.8c-0.8,1.4-0.1,4,1.5,5.8
		c25.3,29,41,67.1,41,99.3v2.2c0,52.1-6.6,100.1-19.7,142.5c-0.5,1.7,0.5,4.3,2.2,5.9c0.3,0.3,0.6,0.5,0.9,0.7
		c1.4,0.8,2.7,0.5,3.1-0.9c13.2-43,19.9-91.6,19.9-144.4V310.9z M789.8,172.9c-44.1-25.5-80-5-80,45.6c0,2,1.4,4.5,3.2,5.6
		c1.8,1,3.2,0.2,3.2-1.8c0-46.6,33-65.4,73.6-42c1.8,1,3.2,0.2,3.2-1.8S791.6,173.9,789.8,172.9z M712.8,237.2
		c-1.8-1.1-3.3-0.4-3.3,1.6c-1.2,37.9-5.9,73.8-13.9,106.8c-0.4,1.7,0.6,4.4,2.4,5.9c0.3,0.2,0.5,0.4,0.8,0.6c1.5,0.8,2.8,0.5,3.1-1
		c8.1-33.4,12.8-69.8,14-108.2C716,240.8,714.6,238.3,712.8,237.2z M789.8,155.6c-52.5-30.3-95.1-6-95.1,54.2
		c0,41-4,79.7-11.9,115.1c-0.4,1.8,0.7,4.4,2.4,5.8c1.7,1.5,3.5,1.2,3.9-0.6c8-35.9,12-75.2,12-116.7c0-56.1,39.8-78.8,88.7-50.5
		c48.9,28.2,88.7,96.8,88.7,152.9v2.2c0,47.6-5.4,92-16,132c-0.5,1.7,0.6,4.3,2.3,5.9c0.3,0.2,0.6,0.4,0.8,0.6
		c1.4,0.8,2.7,0.5,3.1-1c10.8-40.5,16.2-85.6,16.2-133.8v-2.2C884.9,259.5,842.3,185.9,789.8,155.6z M839.7,293.5
		c0-31.6-22.4-70.2-49.9-86.1c-27.5-15.9-49.9-3.1-49.9,28.4c0,2,1.4,4.5,3.2,5.6c1.8,1,3.2,0.2,3.2-1.8c0-27.5,19.5-38.6,43.4-24.8
		c24,13.8,43.4,47.4,43.4,74.9v2.2c0,45.2-9.6,108.3-23.4,153.4c-0.5,1.7,0.5,4.3,2.2,5.9c0.3,0.3,0.6,0.5,0.9,0.7
		c1.4,0.8,2.7,0.5,3.1-0.9c14-45.7,23.7-109.6,23.7-155.4V293.5z M742.7,264.3c-1.8-1.2-3.3-0.4-3.4,1.6
		c-1.7,40.6-6.9,79.9-15.5,116.9c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.8,2.8,0.5,3.1-1
		c8.7-37.4,13.9-77.1,15.7-118.1C745.8,268,744.4,265.5,742.7,264.3z M722.9,309.9c-1.8-1.3-3.4-0.9-3.7,1
		c-2.6,18.4-6.1,36.3-10.5,53.2c-0.4,1.7,0.6,4.3,2.3,5.9c0.3,0.2,0.5,0.4,0.8,0.6c1.4,0.8,2.8,0.5,3.1-1c4.4-17.2,8-35.3,10.6-53.9
		C725.8,313.8,724.6,311.3,722.9,309.9z M733.5,195c-5.7,8-8.7,19.1-8.7,32.2c0,23.2-1.2,46-3.6,67.6c-0.2,1.9,1.1,4.5,2.8,5.8
		c0.1,0.1,0.3,0.2,0.4,0.3c1.6,0.9,3,0.4,3.2-1.4c2.4-21.9,3.7-45,3.7-68.5c0-11.8,2.7-21.8,7.8-29c0.9-1.3,0.4-3.8-1.2-5.7
		C736.4,194.3,734.4,193.8,733.5,195z M751.6,182.4c-1.4,0.4-1.8,2.5-0.7,4.8c1,2.3,3.1,3.8,4.5,3.4c10-2.6,21.9-0.2,34.4,7
		c20.6,11.9,39.9,35.7,50.4,62.2c0.6,1.5,1.7,2.8,2.8,3.4c0.6,0.3,1.1,0.5,1.6,0.4c1.5-0.2,2-2.1,1.1-4.4
		c-11.7-29.4-33.1-55.9-56-69.1C776,182.2,762.8,179.5,751.6,182.4z M854.8,302.2c0-2-1.4-4.5-3.2-5.6c-1.8-1-3.2-0.2-3.2,1.8v2.2
		c0,53.6-7.2,102.5-21.4,145.4l-1.2,3.7c-0.5,1.6,0.4,4.3,2.1,5.9c0.3,0.3,0.7,0.6,1,0.7c1.4,0.8,2.6,0.5,3.1-0.8l1.2-3.7
		c14.4-43.5,21.7-93.1,21.7-147.4V302.2z"/>
              <g>
		<path class="st404" d="M768.4,374.2c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l3.5,122
			c12.4,189.1,76.9,271.4,180.7,447.2l2.5,1.5c103.8-55.9,168.3-63.8,180.7-238.6l3.5-117.9L768.4,374.2z"/>
                <path class="st402" d="M790.3,355.2c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5
			l-21.3,19.4l1.8,1.1c65.3,38.5,129.1,49.2,182.6,30.6l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9
			c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9L790.3,355.2z"/>
                <path class="st402" d="M792.8,356.6l-2.5-1.4c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4l-22,19l0.7,0.4
			c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4L792.8,356.6z"/>
                <path class="st402" d="M770.9,375.6l-3.5,117.9c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9
			L770.9,375.6z"/>

                <radialGradient id="SVGID_00000035519460546054439730000003828010013045398689_" cx="-840.9651"
                                cy="409.2891" r="226.9041"
                                gradientTransform="matrix(0.9742 0 0 0.9742 1407.2067 12.4875)"
                                gradientUnits="userSpaceOnUse">
			<stop offset="0" style="stop-color:#FFFFFF"/>
                  <stop offset="1" style="stop-color:#000000"/>
		</radialGradient>
                <path style="fill:url(#SVGID_00000035519460546054439730000003828010013045398689_);" d="M770.9,372.4
			c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l0.2,6.1c64.7,37.6,127.9,48,180.9,29.7
			l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9c-6.4,90.9-27,136.7-59.9,167.5c35.2-30.9,57.2-76.6,63.9-171.2
			l3.5-117.9L770.9,372.4z"/>
                <g>

				<linearGradient id="SVGID_00000119830630719570513890000016175687552344491677_" gradientUnits="userSpaceOnUse"
                        x1="-1234.8898" y1="519.6628" x2="-570.2414" y2="159.7008"
                        gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
          <stop offset="0.5457" style="stop-color:#CEB8D9"/>
          <stop offset="0.8201" style="stop-color:#EAE1EF"/>
          <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0;fill:url(#SVGID_00000119830630719570513890000016175687552344491677_);" d="M762.3,380.9
				c-64.1-36.3-126.8-98.2-179.3-177l-0.7-0.4c-52.5,18.2-115.2,7.7-179.3-30.1l-2.5-1.4l3.5,119.8
				c12.2,185.7,75.5,266.5,177.4,439.2l2.5,1.4c101.9-54.9,165.3-62.6,177.4-234.3l3.5-115.8L762.3,380.9z"/>

                  <linearGradient id="SVGID_00000129170045387584533460000003735830957933658012_"
                                  gradientUnits="userSpaceOnUse" x1="-1231.301" y1="518.9431" x2="-576.8375"
                                  y2="164.4971" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path
                      style="opacity:9.090909e-02;fill:url(#SVGID_00000129170045387584533460000003735830957933658012_);"
                      d="M402.8,175.8
				c0.1,0,2.4,1.4,2.4,1.4c42.5,24.6,84.4,37.1,123.2,37.3c18.4,0.1,36.1-2.7,52.8-8.3c0,0,0.7,0.4,0.7,0.4
				c52.2,78,114.2,139.2,177.7,175.5c0.1,0,2.4,1.3,2.4,1.4c0.1,0.1,0.1,4.2,0.2,4.2L759,498c-11.9,168.3-73.1,177.1-172.8,230.6
				c-0.1,0-2.4-1.2-2.5-1.2c-3.5-4.9-6.9-9.6-10.3-14.3c-10.1-16.9-19.7-32.9-29-48.2c-78.5-130.2-127.1-211.9-138-370.4
				c-0.1-0.9-1.1-33.4-1.2-34.4L402.8,175.8z"/>

                  <linearGradient id="SVGID_00000181062133632409417470000011774176061137814690_"
                                  gradientUnits="userSpaceOnUse" x1="-1227.7107" y1="518.23" x2="-583.4238"
                                  y2="169.2955" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.1818;fill:url(#SVGID_00000181062133632409417470000011774176061137814690_);" d="M405.2,179.6
				c0.1,0.1,2.3,1.3,2.4,1.3c41.7,23.6,82.8,35.7,120.9,35.8c18,0.1,35.4-2.6,51.8-8c0,0,0.7,0.3,0.7,0.3
				c51.8,77.1,113.1,137.7,176.1,174c0.1,0.1,2.3,1.3,2.4,1.4c0.2,0.1,0.3,3.9,0.5,4l-3.3,109.4c-11.7,165-70.6,174.9-168.2,227
				c-0.1,0.1-2.3-1-2.4-1c-3.6-4.1-7.2-8.2-10.8-12.1c-10-16.7-19.5-32.6-28.7-47.8c-78-129.4-126.4-210.6-137.6-366.7
				c-0.2-1.8-1.2-32.1-1.3-34.1L405.2,179.6z"/>

                  <linearGradient id="SVGID_00000066489984332805978560000014543211730771902906_"
                                  gradientUnits="userSpaceOnUse" x1="-1224.1189" y1="517.5236" x2="-589.9976"
                                  y2="174.0946" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.2727;fill:url(#SVGID_00000066489984332805978560000014543211730771902906_);" d="M407.6,183.4
				c0.2,0.1,2.2,1.2,2.3,1.3c40.9,22.6,81.1,34.2,118.6,34.3c17.7,0.1,34.7-2.5,50.7-7.6c0.1,0,0.6,0.3,0.7,0.3
				c51.4,76.2,112.1,136.2,174.5,172.5c0.2,0.1,2.2,1.3,2.4,1.4c0.3,0.2,0.5,3.6,0.8,3.8l-3.2,108.4
				C743,659.4,686.2,670.4,590.9,721c-0.2,0.1-2.2-0.8-2.4-0.7c-3.8-3.4-7.6-6.7-11.3-9.9c-9.9-16.5-19.3-32.2-28.4-47.4
				C471.2,534.5,423,453.8,411.5,299.9c-0.3-2.7-1.3-30.8-1.5-33.8L407.6,183.4z"/>

                  <linearGradient id="SVGID_00000019669498651515063450000016948023926545724565_"
                                  gradientUnits="userSpaceOnUse" x1="-1220.5264" y1="516.8241" x2="-596.5543"
                                  y2="178.8917" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.3636;fill:url(#SVGID_00000019669498651515063450000016948023926545724565_);" d="M410,187.2
				c0.2,0.1,2.1,1.1,2.3,1.2c40.1,21.7,79.5,32.7,116.3,32.8c17.3,0,33.9-2.4,49.7-7.2c0.1,0,0.6,0.2,0.7,0.2
				c51,75.3,111,134.6,172.9,171c0.3,0.2,2.1,1.2,2.3,1.4c0.4,0.3,0.7,3.3,1.2,3.6l-3.2,107.4C740.9,656,686.4,668,593.2,717.2
				c-0.3,0.1-2.1-0.6-2.4-0.5c-3.9-2.6-7.9-5.2-11.8-7.7c-9.8-16.4-19.1-31.9-28.2-46.9c-77-127.7-124.9-207.9-136.8-359.5
				c-0.4-3.7-1.3-29.5-1.6-33.5L410,187.2z"/>

                  <linearGradient id="SVGID_00000156548615614106094480000000694834835964293054_"
                                  gradientUnits="userSpaceOnUse" x1="-1216.9343" y1="516.132" x2="-603.0855"
                                  y2="183.6823" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.4545;fill:url(#SVGID_00000156548615614106094480000000694834835964293054_);" d="M412.4,191
				c0.3,0.1,2,1.1,2.3,1.2c39.2,20.7,77.8,31.3,114,31.3c16.9,0,33.2-2.2,48.7-6.9c0.1,0,0.6,0.2,0.7,0.2
				c50.6,74.4,110,133.1,171.3,169.5c0.3,0.2,2,1.2,2.3,1.4c0.5,0.3,1,3.1,1.5,3.4l-3.2,106.4c-11,155-63.3,168.2-154.3,216
				c-0.3,0.2-2-0.4-2.4-0.3c-4.1-1.9-8.2-3.7-12.4-5.5c-9.7-16.2-18.9-31.6-27.9-46.5c-76.5-126.8-124.2-206.6-136.4-355.9
				c-0.5-4.6-1.4-28.2-1.8-33.1L412.4,191z"/>

                  <linearGradient id="SVGID_00000045616482806559061670000006200995252694688438_"
                                  gradientUnits="userSpaceOnUse" x1="-1213.345" y1="515.4484" x2="-609.5721"
                                  y2="188.4556" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.5455;fill:url(#SVGID_00000045616482806559061670000006200995252694688438_);" d="M414.8,194.8
				c0.4,0.2,1.9,1,2.2,1.1c38.4,19.7,76.1,29.8,111.7,29.9c16.5,0,32.4-2.1,47.6-6.5c0.1,0,0.5,0.1,0.7,0.1
				c50.2,73.5,108.9,131.6,169.6,168c0.4,0.2,1.9,1.1,2.3,1.4c0.6,0.4,1.2,2.8,1.8,3.2l-3.1,105.4
				c-10.8,151.7-60.9,165.9-149.7,212.3c-0.4,0.2-1.9-0.2-2.4,0c-4.3-1.2-8.5-2.3-12.9-3.3c-9.6-16.1-18.8-31.3-27.6-46
				c-76-126-123.4-205.3-136-352.3c-0.6-5.5-1.5-26.9-1.9-32.8L414.8,194.8z"/>

                  <linearGradient id="SVGID_00000140701174317916694100000004534448669191959708_"
                                  gradientUnits="userSpaceOnUse" x1="-1209.8168" y1="514.8044" x2="-615.5168"
                                  y2="192.942" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.6364;fill:url(#SVGID_00000140701174317916694100000004534448669191959708_);" d="M417.2,198.7
				c0.4,0.2,1.8,0.9,2.2,1.1c37.6,18.8,74.5,28.3,109.4,28.4c16.1,0,31.7-2,46.6-6.1c0.1,0,0.5,0.1,0.6,0.1
				c49.8,72.6,107.9,130.1,168,166.5c0.5,0.3,1.8,1.1,2.3,1.4c0.7,0.5,1.4,2.5,2.1,3l-3.1,104.4c-10.6,148.4-58.5,163.7-145,208.6
				c-0.5,0.2-1.9,0-2.3,0.2c-4.4-0.4-8.9-0.8-13.4-1c-9.5-15.9-18.6-31-27.4-45.6c-75.4-125.1-122.7-203.9-135.6-348.6
				c-0.7-6.4-1.6-25.6-2.1-32.5L417.2,198.7z"/>

                  <linearGradient id="SVGID_00000006674412245030959520000006888649150597406397_"
                                  gradientUnits="userSpaceOnUse" x1="-1206.2933" y1="514.1691" x2="-621.4032"
                                  y2="197.4028" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.7273;fill:url(#SVGID_00000006674412245030959520000006888649150597406397_);" d="M419.6,202.5
				c0.5,0.2,1.7,0.8,2.2,1.1c36.7,17.8,72.8,26.8,107.1,26.9c15.7,0,31-1.9,45.5-5.8c0.1,0,0.5,0,0.6,0
				c49.5,71.7,106.8,128.6,166.4,165c0.5,0.3,1.7,1,2.2,1.4c0.8,0.5,1.6,2.2,2.5,2.7l-3.1,103.4c-10.4,145-56.1,161.5-140.4,205
				c-0.5,0.3-1.8,0.2-2.3,0.4c-4.6,0.3-9.2,0.7-13.9,1.2c-9.4-15.7-18.4-30.7-27.1-45.2c-74.9-124.3-121.9-202.6-135.2-345
				c-0.8-7.3-1.7-24.3-2.2-32.2L419.6,202.5z"/>

                  <linearGradient id="SVGID_00000078741172361775021920000016305354809048701831_"
                                  gradientUnits="userSpaceOnUse" x1="-1202.7688" y1="513.5386" x2="-627.2864"
                                  y2="201.8675" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.8182;fill:url(#SVGID_00000078741172361775021920000016305354809048701831_);" d="M422,206.3
				c0.6,0.2,1.6,0.8,2.1,1c35.9,16.8,71.1,25.4,104.8,25.4c15.3,0,30.2-1.8,44.5-5.4c0.2,0,0.5,0,0.6,0
				c49.1,70.8,105.8,127,164.8,163.5c0.6,0.4,1.6,1,2.2,1.4c0.9,0.6,1.8,2,2.8,2.5L740.8,497C730.7,638.7,687.2,656.3,605,698.3
				c-0.6,0.3-1.7,0.4-2.3,0.7c-4.7,1.1-9.5,2.2-14.4,3.4c-9.3-15.6-18.2-30.3-26.9-44.7C487,534.3,440.3,456.4,426.6,316.3
				c-0.9-8.2-1.8-23-2.4-31.8L422,206.3z"/>

                  <linearGradient id="SVGID_00000182490646042816118310000003247113031893043379_"
                                  gradientUnits="userSpaceOnUse" x1="-1199.2433" y1="512.9125" x2="-633.1666"
                                  y2="206.3354" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="opacity:0.9091;fill:url(#SVGID_00000182490646042816118310000003247113031893043379_);" d="M424.4,210.1
				c0.6,0.3,1.5,0.7,2.1,1C461.5,226.9,496,235,529,235c14.9,0,29.5-1.7,43.4-5c0.2,0,0.4,0,0.6-0.1
				c48.7,69.9,104.7,125.5,163.2,162c0.7,0.4,1.5,0.9,2.2,1.4c1,0.6,2.1,1.7,3.1,2.3l-3,101.4c-9.9,138.4-51.2,157-131.2,197.6
				c-0.7,0.3-1.6,0.6-2.3,0.9c-4.9,1.8-9.8,3.7-14.9,5.6c-9.2-15.4-18-30-26.6-44.3C489.7,534.2,443.1,456.9,429.1,319
				c-1-9.1-1.9-21.7-2.5-31.5L424.4,210.1z"/>

                  <linearGradient id="SVGID_00000134936805157642595510000015344770716848911265_"
                                  gradientUnits="userSpaceOnUse" x1="-1195.7172" y1="512.2904" x2="-639.0441"
                                  y2="210.806" gradientTransform="matrix(1 0 0 1 1603.9998 0)">
				<stop offset="0.404" style="stop-color:#C3A8D0"/>
                    <stop offset="0.5457" style="stop-color:#CEB8D9"/>
                    <stop offset="0.8201" style="stop-color:#EAE1EF"/>
                    <stop offset="1" style="stop-color:#FFFFFF"/>
			</linearGradient>
                  <path style="fill:url(#SVGID_00000134936805157642595510000015344770716848911265_);" d="M592,699.7
				c-9.1-15.2-17.8-29.7-26.3-43.8C486.9,525.1,439.3,446.2,429,290.6l-2.2-76.6c34.9,15.5,69.2,23.3,102.3,23.3
				c14.8,0,29.2-1.6,43-4.8c49.9,71.3,107.2,127.5,167.1,164l-3,100.4c-9.7,135-48.8,154.8-126.5,194
				C603.9,693.7,598.1,696.7,592,699.7z"/>
		</g>
                <path class="st409" d="M748.6,393c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5
			l-21.3,19.4l1.8,1.1c65.3,38.5,129.1,49.2,182.6,30.6l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9
			c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9L748.6,393z"/>
                <path class="st402" d="M751.1,394.4l-2.5-1.4c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4l-22,19l0.7,0.4
			c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4L751.1,394.4z"/>
                <path class="st402" d="M729.1,413.5l-3.5,117.9c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9
			L729.1,413.5z"/>

                <linearGradient id="SVGID_00000134217653593046735010000007812563709478468264_"
                                gradientUnits="userSpaceOnUse" x1="629.2128" y1="291.2595" x2="395.4393" y2="646.894">
			<stop offset="0" style="stop-color:#166250"/>
                  <stop offset="0.1797" style="stop-color:#196955"/>
                  <stop offset="0.4323" style="stop-color:#237B64"/>
                  <stop offset="0.7265" style="stop-color:#32997C"/>
                  <stop offset="1" style="stop-color:#44BB98"/>
		</linearGradient>
                <path style="opacity:0.7;fill:url(#SVGID_00000134217653593046735010000007812563709478468264_);" d="M530.7,688.5
			c-80.6-133.7-121.1-200.9-130.9-347.6l-2.2-77c51.7,23.4,101.3,30.9,146,22c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4
			c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5C539.3,702.6,535,695.5,530.7,688.5z"/>

                <linearGradient id="SVGID_00000098210681526701133460000012973131674500435847_"
                                gradientUnits="userSpaceOnUse" x1="441.328" y1="497.8589" x2="744.7236" y2="497.8589">
			<stop offset="0" style="stop-color:#166250"/>
                  <stop offset="0.1797" style="stop-color:#196955"/>
                  <stop offset="0.4323" style="stop-color:#237B64"/>
                  <stop offset="0.7265" style="stop-color:#32997C"/>
                  <stop offset="1" style="stop-color:#44BB98"/>
		</linearGradient>
                <path style="opacity:0.1;fill:url(#SVGID_00000098210681526701133460000012973131674500435847_);" d="M543.7,285.8
			c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5V285.8z"/>

                <radialGradient id="SVGID_00000139252571065866727240000001287576153138664585_" cx="-883.7821"
                                cy="448.1624" r="226.9041"
                                gradientTransform="matrix(0.9742 0 0 0.9742 1407.2067 12.4875)"
                                gradientUnits="userSpaceOnUse">
			<stop offset="0" style="stop-color:#FFFFFF"/>
                  <stop offset="1" style="stop-color:#000000"/>
		</radialGradient>
                <path style="fill:url(#SVGID_00000139252571065866727240000001287576153138664585_);" d="M729.2,410.2
			c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l0.2,6.1c64.7,37.6,127.9,48,180.9,29.7
			l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9c-6.4,90.9-27,136.7-59.9,167.5c35.2-30.9,57.2-76.6,63.9-171.2
			l3.5-117.9L729.2,410.2z"/>
                <path class="st603" d="M530.7,688.5c-80.6-133.7-121.1-200.9-130.9-347.6l-2.2-77c51.7,23.4,101.3,30.9,146,22
			c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5
			C539.3,702.6,535,695.5,530.7,688.5z"/>
                <path class="st404" d="M726.6,412.1c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l3.5,122
			c12.4,189.1,76.9,271.4,180.7,447.2l2.5,1.5c103.8-55.9,168.3-63.8,180.7-238.6l3.5-117.9L726.6,412.1z M687.5,506.9
			c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5c-4.4-7.3-8.7-14.4-12.9-21.4c-80.6-133.7-121.1-200.9-130.9-347.6
			l-2.2-77c51.7,23.4,101.3,30.9,146,22c44.7,60.5,94.3,110.3,146,146.7L687.5,506.9z"/>

                <radialGradient id="SVGID_00000112612924435005604920000014917156105305870728_" cx="-886.4156"
                                cy="457.7703" r="176.6032"
                                gradientTransform="matrix(0.9742 0 0 0.9742 1407.2067 12.4875)"
                                gradientUnits="userSpaceOnUse">
			<stop offset="0" style="stop-color:#FFFFFF"/>
                  <stop offset="1" style="stop-color:#000000"/>
		</radialGradient>
                <path style="fill:url(#SVGID_00000112612924435005604920000014917156105305870728_);" d="M543.7,285.8c-44.7,8.9-94.3,1.4-146-22
			l0.1,4.7c50.5,22.2,98.9,29.2,142.6,20.5c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-5.5,75.7-20.5,115.4-46.8,142.9
			c28.3-27.6,44.4-67.4,50.1-146.2l2.2-74.4C637.9,396.1,588.3,346.3,543.7,285.8z"/>
	</g>
              <g>
		<g class="st401">
			<g>
				<g>
					<path class="st605" d="M205.1,611.2l42.2-24.4c3.4-2,8.9-2,12.3,0l128.6,74.7c3.4,2,3.3,5.2,0,7.1L346,693.1
						c-3.4,2-8.9,2-12.3,0l-128.6-74.7C201.7,616.4,201.7,613.2,205.1,611.2L205.1,611.2z"/>
				</g>
			</g>
		</g>
                <g>
			<g>
				<g class="st417">
					<g>
						<path class="st402"
                  d="M197.5,482.8l40.8-23.7c1.3-0.8,3.1-0.7,5.1,0.5l-40.8,23.7C200.6,482.1,198.8,482,197.5,482.8z"/>
					</g>
          <g>
						<path class="st409"
                  d="M372.6,665.6l-40.8,23.7c1.3-0.7,2.1-2.3,2.1-4.6l40.8-23.7C374.7,663.3,373.9,664.9,372.6,665.6z"/>
					</g>
          <g>
						<polygon class="st409" points="334.2,567.5 375,543.8 374.7,661.1 333.9,684.7 						"/>
					</g>
          <g>
						<polygon class="st402" points="202.5,483.3 243.3,459.6 367.9,531.5 327.1,555.2 						"/>
					</g>
          <g>
						<path class="st402"
                  d="M327.1,555.2l40.8-23.7c3.9,2.3,7.1,7.8,7.1,12.3l-40.8,23.7C334.3,563,331.1,557.5,327.1,555.2z"/>
					</g>
          <g>
						<path class="st404" d="M327.1,555.2c3.9,2.3,7.1,7.8,7.1,12.3l-0.3,117.2c0,4.5-3.2,6.3-7.1,4.1l-124.6-71.9
							c-3.9-2.3-7.1-7.8-7.1-12.3l0.3-117.2c0-4.5,3.2-6.3,7.1-4.1L327.1,555.2z"/>
					</g>
				</g>
			</g>
                  <g>
				<g class="st417">
					<g>
						<path class="st405" d="M258.2,553.2c-8.1-4.7-14.7-0.9-14.7,8.4c0,5.9,2.6,12.6,6.6,17.9l1.1-6.6c0.3-1.6,1.6-2.1,3.1-1.2
							l7.8,4.5c1.6,0.9,2.9,2.9,3.1,4.9l1,7.8c4-0.7,6.6-4.4,6.6-10.3C272.8,569.3,266.3,557.9,258.2,553.2L258.2,553.2z"/>
            <path class="st405" d="M262,576.2l-7.8-4.5c-1.6-0.9-2.9-0.4-3.1,1.2l-1.1,6.6l-3.5,21.9c-0.3,2,1.2,4.9,3.1,6l16.8,9.7
							c2,1.1,3.4,0,3.1-2.4l-3.4-25.8l-1-7.8C264.9,579.2,263.6,577.1,262,576.2L262,576.2z"/>
					</g>
				</g>
			</g>
                  <g>
				<g class="st417">
					<g>
						<polygon class="st606" points="245.3,474.4 257.5,467.3 257.5,483.4 245.3,490.5 						"/>
					</g>
          <g>
						<path class="st606"
                  d="M256.5,449.9l12.2-7.1c-6.9,4-11.1,12.5-11.2,24.5l-12.2,7.1C245.3,462.3,249.6,453.9,256.5,449.9z"/>
					</g>
          <g>
						<polygon class="st607" points="333.6,525.3 345.8,518.2 345.7,534.3 333.5,541.4 						"/>
					</g>
          <g>
						<path class="st607"
                  d="M248.4,435.5l12.2-7.1c9.5-5.4,22.1-4.2,35.4,3.5l-12.2,7.1C270.4,431.4,257.9,430.1,248.4,435.5z"/>
					</g>
          <g>
						<path class="st607" d="M283.7,439l12.2-7.1c13.3,7.7,25.8,20.9,35.2,37.2c9.4,16.3,14.6,33.8,14.6,49l-12.2,7.1
							c0-15.3-5.1-32.7-14.6-49C309.6,459.9,297,446.7,283.7,439z"/>
					</g>
          <g>
						<path class="st405" d="M283.7,439c13.3,7.7,25.8,20.9,35.2,37.2c9.4,16.3,14.6,33.8,14.6,49l0,16.1l-11.7-6.8l0-16.1
							c0.1-24.2-17-53.9-38.1-66.1c-21.1-12.2-38.3-2.4-38.4,21.9l0,16.1l-11.7-6.8l0-16.1c0-15.3,5.3-26.7,14.8-32.1
							C257.9,430.1,270.4,431.4,283.7,439z"/>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g class="st417">
				<g>
					<polygon class="st608" points="474.3,463 479.6,461.3 479.8,461.3 474.5,463.1 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000021091012669550497980000002442216190549425077_" class="st417" d="M472.1,449l5.3-1.8
							c-1.8,0.6-3,2.5-3.1,5.2c-0.1,3.9,2.2,7.8,5.3,8.8l-5.3,1.8c-3-1-5.4-4.9-5.3-8.8C469.1,451.6,470.4,449.6,472.1,449z"/>
					</defs>
          <clipPath id="SVGID_00000047745049773000807560000004615766510637104013_">
						<use xlink:href="#SVGID_00000021091012669550497980000002442216190549425077_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000047745049773000807560000004615766510637104013_);enable-background:new    ;">
						<path class="st459"
                  d="M472.1,449l5.3-1.8c-0.7,0.2-1.3,0.6-1.8,1.2l-5.3,1.8C470.9,449.7,471.5,449.2,472.1,449"/>
            <path class="st460"
                  d="M470.4,450.2l5.3-1.8c-0.1,0.1-0.2,0.3-0.3,0.4l-5.3,1.8C470.2,450.5,470.3,450.4,470.4,450.2"/>
            <path class="st461"
                  d="M470.1,450.7l5.3-1.8c-0.1,0.1-0.1,0.2-0.2,0.3l-5.3,1.8C469.9,450.9,470,450.8,470.1,450.7"/>
            <path class="st462"
                  d="M469.9,451l5.3-1.8c-0.1,0.1-0.1,0.2-0.2,0.3l-5.3,1.8C469.7,451.2,469.8,451.1,469.9,451"/>
            <path class="st463"
                  d="M469.7,451.3l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.6,451.5,469.6,451.4,469.7,451.3"/>
            <path class="st457"
                  d="M469.6,451.6l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.5,451.8,469.5,451.7,469.6,451.6"/>
            <path class="st456"
                  d="M469.4,451.9l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.4,452.1,469.4,452,469.4,451.9"/>
            <path class="st455"
                  d="M469.3,452.2l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.3,452.4,469.3,452.3,469.3,452.2"/>
            <path class="st610"
                  d="M469.3,452.5l5.3-1.8c0,0.1,0,0.2-0.1,0.3l-5.3,1.8C469.2,452.7,469.2,452.6,469.3,452.5"/>
            <path class="st611"
                  d="M469.2,452.8l5.3-1.8c0,0.1,0,0.2-0.1,0.3l-5.3,1.8C469.2,453,469.2,452.9,469.2,452.8"/>
            <path class="st612"
                  d="M469.1,453.1l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469.1,453.3,469.1,453.2,469.1,453.1"/>
            <path class="st613"
                  d="M469.1,453.3l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469.1,453.5,469.1,453.4,469.1,453.3"/>
            <path class="st614" d="M469.1,453.6l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,453.8,469.1,453.7,469.1,453.6"/>
            <path class="st615" d="M469,453.9l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.1,469,454,469,453.9"/>
            <path class="st616" d="M469,454.2l5.3-1.8c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.5,469,454.4,469,454.2
							C469,454.3,469,454.3,469,454.2"/>
            <path class="st617" d="M469,454.6l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.8,469,454.7,469,454.6"/>
            <path class="st618" d="M469,454.9l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,455.1,469,455,469,454.9"/>
            <path class="st619" d="M469,455.2l5.3-1.8c0,0.1,0,0.2,0,0.4l-5.3,1.8C469.1,455.5,469.1,455.3,469,455.2"/>
            <path class="st620"
                  d="M469.1,455.6l5.3-1.8c0,0.1,0,0.2,0,0.4l-5.3,1.8C469.1,455.8,469.1,455.7,469.1,455.6"/>
            <path class="st621"
                  d="M469.1,455.9l5.3-1.8c0,0.1,0,0.3,0.1,0.4l-5.3,1.8C469.2,456.2,469.1,456.1,469.1,455.9"/>
            <path class="st622"
                  d="M469.2,456.3l5.3-1.8c0,0.1,0.1,0.3,0.1,0.4l-5.3,1.8C469.3,456.6,469.2,456.5,469.2,456.3"/>
            <path class="st623"
                  d="M469.3,456.8l5.3-1.8c0,0.2,0.1,0.3,0.1,0.5l-5.3,1.8C469.4,457.1,469.3,457,469.3,456.8"/>
            <path class="st624"
                  d="M469.4,457.3l5.3-1.8c0.1,0.2,0.1,0.4,0.2,0.7l-5.3,1.8C469.6,457.7,469.5,457.5,469.4,457.3"/>
            <path class="st625"
                  d="M469.6,457.9l5.3-1.8c0.3,0.7,0.6,1.4,1,2l-5.3,1.8C470.2,459.3,469.9,458.7,469.6,457.9"/>
            <path class="st624"
                  d="M470.6,459.9l5.3-1.8c0.1,0.2,0.3,0.4,0.4,0.6l-5.3,1.8C470.9,460.3,470.7,460.1,470.6,459.9"/>
            <path class="st623"
                  d="M471,460.5l5.3-1.8c0.1,0.1,0.2,0.3,0.3,0.4l-5.3,1.8C471.2,460.8,471.1,460.7,471,460.5"/>
            <path class="st622"
                  d="M471.4,461l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3l-5.3,1.8C471.6,461.2,471.5,461.1,471.4,461"/>
            <path class="st621"
                  d="M471.7,461.3l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3l-5.3,1.8C471.8,461.5,471.7,461.4,471.7,461.3"/>
            <path class="st620"
                  d="M471.9,461.6l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.2l-5.3,1.8C472.1,461.7,472,461.7,471.9,461.6"/>
            <path class="st619"
                  d="M472.2,461.8l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.4,462,472.3,461.9,472.2,461.8"/>
            <path class="st618"
                  d="M472.4,462l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.6,462.1,472.5,462.1,472.4,462"/>
            <path class="st617"
                  d="M472.7,462.2l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.8,462.3,472.8,462.3,472.7,462.2"/>
            <path class="st616"
                  d="M472.9,462.4l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.1l-5.3,1.8C473.1,462.5,473,462.4,472.9,462.4"/>
            <path class="st615"
                  d="M473.2,462.5l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.3,462.6,473.2,462.6,473.2,462.5"/>
            <path class="st614"
                  d="M473.4,462.7l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.5,462.7,473.5,462.7,473.4,462.7"/>
            <path class="st613"
                  d="M473.6,462.8l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.8,462.8,473.7,462.8,473.6,462.8"/>
            <path class="st612"
                  d="M473.9,462.9l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C474,462.9,473.9,462.9,473.9,462.9"/>
            <path class="st611" d="M474.1,463l5.3-1.8c0.1,0,0.1,0,0.2,0.1l-5.3,1.8C474.2,463,474.2,463,474.1,463"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000086660132027587354870000008980238082251648932_" class="st417" d="M488.5,461.4l-5.3,1.8
							c-2.6,0.9-5.6,0.9-8.7-0.1l5.3-1.8C482.9,462.3,485.9,462.3,488.5,461.4z"/>
					</defs>
          <clipPath id="SVGID_00000019656100368551129390000005734460661595885740_">
						<use xlink:href="#SVGID_00000086660132027587354870000008980238082251648932_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000019656100368551129390000005734460661595885740_);enable-background:new    ;">
						<path class="st611" d="M474.5,463.1l5.3-1.8c0,0,0,0,0,0L474.5,463.1C474.5,463.1,474.5,463.1,474.5,463.1"/>
            <path class="st610"
                  d="M474.5,463.1l5.3-1.8c0.3,0.1,0.6,0.2,0.9,0.2l-5.3,1.8C475.1,463.3,474.8,463.2,474.5,463.1"/>
            <path class="st455"
                  d="M475.4,463.4l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C476,463.5,475.7,463.4,475.4,463.4"/>
            <path class="st456"
                  d="M476.3,463.6l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C476.9,463.7,476.6,463.6,476.3,463.6"/>
            <path class="st457"
                  d="M477.2,463.7l5.3-1.8c0.3,0,0.6,0.1,1,0.1l-5.3,1.8C477.8,463.8,477.5,463.8,477.2,463.7"/>
            <path class="st463" d="M478.2,463.8l5.3-1.8c0.3,0,0.7,0,1,0l-5.3,1.8C478.8,463.8,478.5,463.8,478.2,463.8"/>
            <path class="st462"
                  d="M479.2,463.8l5.3-1.8c0.4,0,0.7,0,1.1,0l-5.3,1.8C479.9,463.8,479.5,463.8,479.2,463.8"/>
            <path class="st461"
                  d="M480.2,463.8l5.3-1.8c0.4,0,0.8-0.1,1.3-0.2l-5.3,1.8C481.1,463.7,480.7,463.8,480.2,463.8"/>
            <path class="st460"
                  d="M481.5,463.6l5.3-1.8c0.5-0.1,1-0.2,1.5-0.4l-5.3,1.8C482.5,463.4,482,463.5,481.5,463.6"/>
            <path class="st459" d="M483,463.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C483.1,463.2,483.1,463.2,483,463.2"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000114051439071818773620000012608572968290134969_" class="st417" d="M482.2,461.3l-5.3,1.8
							c-0.8,0.3-1.6,0.3-2.5,0l5.3-1.8C480.5,461.6,481.4,461.6,482.2,461.3z"/>
					</defs>
          <clipPath id="SVGID_00000154400431527281858590000008640803491004312218_">
						<use xlink:href="#SVGID_00000114051439071818773620000012608572968290134969_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000154400431527281858590000008640803491004312218_);enable-background:new    ;">
						<path class="st611" d="M474.4,463.1l5.3-1.8c0,0,0,0,0,0L474.4,463.1C474.4,463.1,474.4,463.1,474.4,463.1"/>
            <path class="st610"
                  d="M474.4,463.1l5.3-1.8c0.1,0,0.2,0,0.2,0.1l-5.3,1.8C474.6,463.1,474.5,463.1,474.4,463.1"/>
            <path class="st455"
                  d="M474.7,463.1l5.3-1.8c0.1,0,0.2,0,0.3,0.1l-5.3,1.8C474.8,463.2,474.7,463.2,474.7,463.1"/>
            <path class="st456" d="M474.9,463.2l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.1,463.2,475,463.2,474.9,463.2"/>
            <path class="st457"
                  d="M475.2,463.2l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.4,463.3,475.3,463.3,475.2,463.2"/>
            <path class="st463"
                  d="M475.4,463.3l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.6,463.3,475.5,463.3,475.4,463.3"/>
            <path class="st462"
                  d="M475.7,463.3l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.9,463.3,475.8,463.3,475.7,463.3"/>
            <path class="st461" d="M476,463.3l5.3-1.8c0.1,0,0.2,0,0.4,0l-5.3,1.8C476.3,463.2,476.2,463.3,476,463.3"/>
            <path class="st460"
                  d="M476.4,463.2l5.3-1.8c0.2,0,0.3-0.1,0.4-0.1l-5.3,1.8C476.7,463.1,476.6,463.2,476.4,463.2"/>
            <path class="st459" d="M476.9,463.1l5.3-1.8c0,0,0,0,0,0L476.9,463.1C476.9,463.1,476.9,463.1,476.9,463.1"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000152233772595064132700000003764262048990774425_" class="st417" d="M455.9,431.8l5.3-1.8
							c3-0.2,9.3-0.8,14.3-0.4l-5.3,1.8C465.2,431,458.9,431.5,455.9,431.8z"/>
					</defs>
          <clipPath id="SVGID_00000063634383345063811370000006635483819495527855_">
						<use xlink:href="#SVGID_00000152233772595064132700000003764262048990774425_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000063634383345063811370000006635483819495527855_);enable-background:new    ;">
						<path class="st462"
                  d="M455.9,431.8l5.3-1.8c2.3-0.2,6.5-0.5,10.5-0.5l-5.3,1.8C462.4,431.2,458.2,431.6,455.9,431.8"/>
            <path class="st463"
                  d="M466.4,431.2l5.3-1.8c1.3,0,2.6,0,3.8,0.1l-5.3,1.8C469,431.2,467.7,431.2,466.4,431.2"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000096061034555108869080000002813535797489323178_" class="st417" d="M470.2,431.3l5.3-1.8
							c1.6,0,3.2,0.2,4.9,0.8l-5.3,1.8C473.5,431.5,471.8,431.3,470.2,431.3z"/>
					</defs>
          <clipPath id="SVGID_00000101069934846068598600000010441756820184986526_">
						<use xlink:href="#SVGID_00000096061034555108869080000002813535797489323178_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000101069934846068598600000010441756820184986526_);enable-background:new    ;">
						<path class="st462"
                  d="M470.2,431.3l5.3-1.8c0.1,0,0.2,0,0.2,0l-5.3,1.8C470.4,431.3,470.3,431.3,470.2,431.3"/>
            <path class="st463" d="M470.5,431.3l5.3-1.8c0.3,0,0.7,0,1,0l-5.3,1.8C471.1,431.3,470.8,431.3,470.5,431.3"/>
            <path class="st457"
                  d="M471.5,431.3l5.3-1.8c0.3,0,0.6,0.1,0.9,0.1l-5.3,1.8C472.1,431.4,471.8,431.4,471.5,431.3"/>
            <path class="st456"
                  d="M472.4,431.4l5.3-1.8c0.3,0,0.6,0.1,0.9,0.1l-5.3,1.8C473,431.5,472.7,431.5,472.4,431.4"/>
            <path class="st455"
                  d="M473.3,431.6l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C473.9,431.7,473.6,431.6,473.3,431.6"/>
            <path class="st610"
                  d="M474.2,431.8l5.3-1.8c0.3,0.1,0.6,0.2,0.9,0.2L475,432C474.7,431.9,474.5,431.9,474.2,431.8"/>
            <path class="st611" d="M475,432l5.3-1.8c0.1,0,0.1,0,0.2,0.1l-5.3,1.8C475.1,432.1,475.1,432,475,432"/>
					</g>
				</g>
        <g>
					<polygon class="st630" points="477.6,433.1 482.9,431.3 482.4,448.8 477.1,450.5 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000149361727746133923360000012826819687795099792_" class="st417" d="M475.2,432.1l5.3-1.8
							c0.8,0.3,1.6,0.6,2.4,1l-5.3,1.8C476.8,432.7,476,432.3,475.2,432.1z"/>
					</defs>
          <clipPath id="SVGID_00000113314299025296647640000013082143265746429860_">
						<use xlink:href="#SVGID_00000149361727746133923360000012826819687795099792_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000113314299025296647640000013082143265746429860_);enable-background:new    ;">
						<path class="st611"
                  d="M475.2,432.1l5.3-1.8c0.2,0.1,0.4,0.1,0.7,0.2l-5.3,1.8C475.6,432.2,475.4,432.1,475.2,432.1"/>
            <path class="st612"
                  d="M475.8,432.3l5.3-1.8c0.3,0.1,0.5,0.2,0.8,0.3l-5.3,1.8C476.4,432.5,476.1,432.4,475.8,432.3"/>
            <path class="st613"
                  d="M476.7,432.6l5.3-1.8c0.3,0.1,0.5,0.2,0.8,0.4l-5.3,1.8C477.2,432.9,476.9,432.8,476.7,432.6"/>
            <path class="st614" d="M477.5,433l5.3-1.8c0,0,0.1,0,0.1,0L477.5,433C477.5,433,477.5,433,477.5,433"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000109744442028154281880000009257130239630960793_" class="st417" d="M492.8,459c-1.3,1.1-2.7,1.9-4.3,2.4
							l-5.3,1.8c1.6-0.5,3-1.4,4.3-2.5C489.3,460.2,491,459.5,492.8,459z"/>
					</defs>
          <clipPath id="SVGID_00000149380875278490882170000011778429085620809354_">
						<use xlink:href="#SVGID_00000109744442028154281880000009257130239630960793_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000149380875278490882170000011778429085620809354_);enable-background:new    ;">
						<path class="st459"
                  d="M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000047762229156646663830000018435665673527025066_" class="st417" d="M492.8,459c-1.8,0.6-3.5,1.2-5.3,1.8
							c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2
							c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2C492.3,459.1,492.6,459,492.8,459z"/>
					</defs>
          <clipPath id="SVGID_00000178175449698002588860000018001381002577934003_">
						<use xlink:href="#SVGID_00000047762229156646663830000018435665673527025066_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000178175449698002588860000018001381002577934003_);enable-background:new    ;">
						<path class="st459"
                  d="M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000135682722256356029830000007401042989813471398_" class="st417" d="M479.7,485.8l-5.3,1.8
							c3.2-1.1,14.3-5.1,16.9-9.7c0.4-0.8,0.8-2.6,1.1-4.9l5.3-1.8c-0.3,2.4-0.7,4.2-1.1,4.9C494,480.7,482.9,484.7,479.7,485.8z"/>
					</defs>
          <clipPath id="SVGID_00000145738029119061177970000000703833195619669688_">
						<use xlink:href="#SVGID_00000135682722256356029830000007401042989813471398_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000145738029119061177970000000703833195619669688_);enable-background:new    ;">
						<path class="st613"
                  d="M492.4,472.9l5.3-1.8c0,0.2-0.1,0.5-0.1,0.7l-5.3,1.8C492.4,473.4,492.4,473.1,492.4,472.9"/>
            <path class="st612"
                  d="M492.4,473.6l5.3-1.8c-0.1,0.5-0.1,1-0.2,1.4l-5.3,1.8C492.2,474.6,492.3,474.1,492.4,473.6"/>
            <path class="st611"
                  d="M492.1,475l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C492,475.6,492.1,475.3,492.1,475"/>
            <path class="st610"
                  d="M492,475.9l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C491.9,476.3,491.9,476.1,492,475.9"/>
            <path class="st455"
                  d="M491.8,476.5l5.3-1.8c0,0.2-0.1,0.3-0.1,0.4l-5.3,1.8C491.7,476.8,491.8,476.7,491.8,476.5"/>
            <path class="st456"
                  d="M491.7,477l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C491.6,477.2,491.7,477.1,491.7,477"/>
            <path class="st457"
                  d="M491.6,477.3l5.3-1.8c0,0.1-0.1,0.2-0.1,0.2l-5.3,1.8C491.5,477.4,491.6,477.4,491.6,477.3"/>
            <path class="st463"
                  d="M491.5,477.5l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2l-5.3,1.8C491.5,477.6,491.5,477.6,491.5,477.5"/>
            <path class="st462" d="M491.4,477.7l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0
							C491.4,477.8,491.4,477.7,491.4,477.7"/>
            <path class="st461"
                  d="M491.3,477.9l5.3-1.8c-0.1,0.2-0.2,0.3-0.3,0.5l-5.3,1.8C491.1,478.2,491.2,478,491.3,477.9"/>
            <path class="st460"
                  d="M491,478.3l5.3-1.8c-0.1,0.2-0.3,0.4-0.5,0.6l-5.3,1.8C490.7,478.7,490.9,478.5,491,478.3"/>
            <path class="st459"
                  d="M490.6,479l5.3-1.8c-3.6,4.2-13.2,7.6-16.1,8.6l-5.3,1.8C477.4,486.6,487,483.1,490.6,479"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000135690390796587055990000007440627254212039837_" class="st417" d="M492.6,472l5.3-1.8
							c0,0.5-0.1,0.8-0.1,0.9l-5.3,1.8C492.5,472.8,492.5,472.5,492.6,472z"/>
					</defs>
          <clipPath id="SVGID_00000149383568500957194130000008234311117607446712_">
						<use xlink:href="#SVGID_00000135690390796587055990000007440627254212039837_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000149383568500957194130000008234311117607446712_);enable-background:new    ;">
						<path class="st613"
                  d="M492.6,472l5.3-1.8c0,0.3-0.1,0.6-0.1,0.7l-5.3,1.8C492.5,472.6,492.5,472.4,492.6,472"/>
            <path class="st612" d="M492.5,472.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C492.5,472.9,492.5,472.8,492.5,472.8"/>
            <path class="st611" d="M492.5,472.9l5.3-1.8c0,0,0,0,0,0L492.5,472.9C492.4,472.9,492.5,472.9,492.5,472.9"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000062893400298170640160000011152189797669328269_" class="st417" d="M493.2,463.1l5.3-1.8
							c-0.1,0.9-0.1,1.8-0.2,2.6l-5.3,1.8C493.1,464.8,493.2,464,493.2,463.1z"/>
					</defs>
          <clipPath id="SVGID_00000098207833105497014800000001294015453190614675_">
						<use xlink:href="#SVGID_00000062893400298170640160000011152189797669328269_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000098207833105497014800000001294015453190614675_);enable-background:new    ;">
						<path class="st614"
                  d="M493.2,463.1l5.3-1.8c0,0.6-0.1,1.3-0.1,1.8l-5.3,1.8C493.1,464.3,493.2,463.7,493.2,463.1"/>
            <path class="st615"
                  d="M493.1,464.9l5.3-1.8c0,0.3,0,0.5,0,0.7l-5.3,1.8C493.1,465.4,493.1,465.2,493.1,464.9"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000079480582311559967130000017965379340953453952_" class="st417" d="M493.2,464.5l5.3-1.8
							c-0.2,2.7-0.4,5.3-0.6,7.5l-5.3,1.8C492.8,469.8,493,467.2,493.2,464.5z"/>
					</defs>
          <clipPath id="SVGID_00000049196939396024968610000015250193026209864618_">
						<use xlink:href="#SVGID_00000079480582311559967130000017965379340953453952_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000049196939396024968610000015250193026209864618_);enable-background:new    ;">
						<path class="st615"
                  d="M493.2,464.5l5.3-1.8c0,0.4,0,0.8-0.1,1.2l-5.3,1.8C493.1,465.3,493.2,464.9,493.2,464.5"/>
            <path class="st614"
                  d="M493.1,465.7l5.3-1.8c-0.1,1.8-0.3,3.5-0.4,5l-5.3,1.8C492.9,469.2,493,467.5,493.1,465.7"/>
            <path class="st613"
                  d="M492.7,470.7l5.3-1.8c0,0.4-0.1,0.9-0.1,1.3l-5.3,1.8C492.6,471.6,492.7,471.2,492.7,470.7"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000117663745993353763980000001998283979059760284_" class="st417" d="M499,445.3
							c-0.5,5.9-2.8,10.7-6.2,13.7c-1.8,0.6-3.5,1.2-5.3,1.8c3.5-2.9,5.8-7.7,6.2-13.7C495.3,446.5,497.4,445.8,499,445.3z"/>
					</defs>
          <clipPath id="SVGID_00000090288965016491813540000006486016577002739115_">
						<use xlink:href="#SVGID_00000117663745993353763980000001998283979059760284_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000090288965016491813540000006486016577002739115_);enable-background:new    ;">
						<path class="st614"
                  d="M493.7,447.1l5.3-1.8c0,0.2,0,0.4,0,0.5l-5.3,1.8C493.7,447.4,493.7,447.2,493.7,447.1"/>
            <path class="st613"
                  d="M493.7,447.6l5.3-1.8c0,0.3-0.1,0.6-0.1,1l-5.3,1.8C493.6,448.2,493.7,447.9,493.7,447.6"/>
            <path class="st612"
                  d="M493.6,448.5l5.3-1.8c0,0.3-0.1,0.6-0.1,0.9l-5.3,1.8C493.5,449.2,493.5,448.9,493.6,448.5"/>
            <path class="st611"
                  d="M493.4,449.5l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C493.3,450.1,493.4,449.8,493.4,449.5"/>
            <path class="st610"
                  d="M493.2,450.4l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C493.1,451.1,493.2,450.7,493.2,450.4"/>
            <path class="st455"
                  d="M493,451.4l5.3-1.8c-0.1,0.3-0.2,0.6-0.3,0.9l-5.3,1.8C492.8,452,492.9,451.7,493,451.4"/>
            <path class="st456"
                  d="M492.8,452.3l5.3-1.8c-0.1,0.3-0.2,0.6-0.3,1l-5.3,1.8C492.5,453,492.7,452.6,492.8,452.3"/>
            <path class="st457"
                  d="M492.4,453.3l5.3-1.8c-0.1,0.3-0.2,0.7-0.4,1l-5.3,1.8C492.2,453.9,492.3,453.6,492.4,453.3"/>
            <path class="st463" d="M492,454.3l5.3-1.8c-0.1,0.3-0.3,0.7-0.5,1l-5.3,1.8C491.8,455,491.9,454.6,492,454.3"/>
            <path class="st462"
                  d="M491.6,455.3l5.3-1.8c-0.2,0.4-0.4,0.7-0.6,1.1l-5.3,1.8C491.2,456,491.4,455.7,491.6,455.3"/>
            <path class="st461"
                  d="M491,456.4l5.3-1.8c-0.2,0.4-0.5,0.8-0.7,1.2l-5.3,1.8C490.6,457.2,490.8,456.8,491,456.4"/>
            <path class="st460"
                  d="M490.3,457.6l5.3-1.8c-0.3,0.5-0.7,1-1.1,1.4l-5.3,1.8C489.6,458.5,490,458,490.3,457.6"/>
            <path class="st459"
                  d="M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459"/>
					</g>
				</g>
        <g>
					<polygon class="st639" points="493.7,447.1 499,445.3 498.5,461.3 493.2,463.1 					"/>
				</g>
        <g>
					<path class="st640" d="M475.2,432.1c0.8,0.3,1.6,0.6,2.4,1l-0.5,17.5c-0.7-0.7-1.5-1.2-2.4-1.5c-3-1-5.6,1.3-5.7,5.2
						s2.2,7.8,5.3,8.8l0.2,0c10.1,3.2,18.3-4.2,19.3-16l-0.5,16c-0.1,0.9-0.1,1.8-0.2,2.6c0-0.4,0.1-0.7,0.1-1.1
						c-0.2,2.7-0.4,5.3-0.6,7.5c0,0.5-0.1,0.8-0.1,0.9c-0.3,2.4-0.7,4.2-1.1,4.9c-3,5.3-17,9.8-17.8,10c-0.4-0.4-7.3-7.2-12.2-13.4
						c-1.9-2.4-3.1-4.5-4-6c-0.3-0.6-0.5-1-0.8-1.6c-0.2-0.6-0.4-1.3-0.6-2.2c-0.3-1.6-0.4-4.3-0.5-7.1c-0.1-2.1-0.1-5.5-0.1-7.1
						c0-0.5,0-1.4,0-1.9c0.2-8.3,0.4-16.4,0.4-16.8c3-0.2,9.3-0.8,14.3-0.4C471.8,431.3,473.5,431.5,475.2,432.1z"/>
				</g>
        <g>
					<polygon class="st641" points="493.8,446.1 499.1,444.3 499,445.3 493.7,447.1 					"/>
				</g>
        <g>
					<path class="st640" d="M481.4,411.3l13.1,11.8l-0.7,23l0,0.9c-1,11.8-9.2,19.3-19.4,16c3,1,5.5-1.3,5.7-5l1.1-38.3L481.4,411.3
						z"/>
				</g>
        <g>
					<polygon class="st630" points="494.4,423.1 499.7,421.3 499.1,444.3 493.8,446.1 					"/>
				</g>
        <g>
					<polygon class="st642" points="481.4,411.3 486.7,409.5 499.7,421.3 494.4,423.1 					"/>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000129207497170354622850000003959158603521672354_" class="st417" d="M612.9,492.4l5.3-1.8
							c0.1,0,0.2,0,0.3-0.1c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.5,0.3,0.8,0.5c0.4,0.4,0.7,0.9,0.8,1.5c0.1,0.6,0,1.1-0.2,1.6l-5.3,1.8
							c0.2-0.5,0.3-1,0.2-1.6c-0.1-0.6-0.4-1.1-0.8-1.5c-0.3-0.3-0.5-0.4-0.8-0.5c-0.2-0.1-0.3-0.1-0.5-0.1
							C613.1,492.3,613,492.3,612.9,492.4z"/>
					</defs>
          <clipPath id="SVGID_00000062902331056771801590000009517735164455290760_">
						<use xlink:href="#SVGID_00000129207497170354622850000003959158603521672354_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000062902331056771801590000009517735164455290760_);enable-background:new    ;">
						<path class="st644" d="M612.9,492.4l5.3-1.8c0,0,0,0,0,0L612.9,492.4C612.9,492.4,612.9,492.4,612.9,492.4"/>
            <path class="st645" d="M612.9,492.4l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C613,492.3,613,492.3,612.9,492.4"/>
            <path class="st646" d="M613.1,492.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C613.2,492.3,613.1,492.3,613.1,492.3"/>
            <path class="st647" d="M613.2,492.3l5.3-1.8c0,0,0,0,0,0c0,0,0.1,0,0.1,0l-5.3,1.8C613.3,492.3,613.3,492.3,613.2,492.3
							C613.2,492.3,613.2,492.3,613.2,492.3"/>
            <path class="st648"
                  d="M613.3,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.3,492.3C613.4,492.3,613.3,492.3,613.3,492.3"/>
            <path class="st649"
                  d="M613.4,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.4,492.3C613.5,492.3,613.4,492.3,613.4,492.3"/>
            <path class="st650"
                  d="M613.5,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.5,492.3C613.5,492.3,613.5,492.3,613.5,492.3"/>
            <path class="st651" d="M613.6,492.3l5.3-1.8c0,0,0,0,0.1,0L613.6,492.3C613.6,492.3,613.6,492.3,613.6,492.3"/>
            <path class="st652" d="M613.6,492.3l5.3-1.8c0,0,0,0,0.1,0L613.6,492.3C613.7,492.4,613.6,492.4,613.6,492.3"/>
            <path class="st653" d="M613.7,492.4l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L613.7,492.4C613.7,492.4,613.7,492.4,613.7,492.4
							C613.7,492.4,613.7,492.4,613.7,492.4"/>
            <path class="st654" d="M613.8,492.4l5.3-1.8c0,0,0,0,0.1,0L613.8,492.4C613.8,492.4,613.8,492.4,613.8,492.4"/>
            <path class="st655" d="M613.8,492.4l5.3-1.8c0,0,0,0,0.1,0L613.8,492.4C613.9,492.4,613.8,492.4,613.8,492.4"/>
            <path class="st656" d="M613.9,492.4l5.3-1.8c0,0,0,0,0.1,0L613.9,492.4C613.9,492.5,613.9,492.5,613.9,492.4"/>
            <path class="st657" d="M614,492.5l5.3-1.8c0,0,0,0,0.1,0L614,492.5C614,492.5,614,492.5,614,492.5"/>
            <path class="st658" d="M614,492.5l5.3-1.8c0,0,0,0,0.1,0L614,492.5C614.1,492.5,614,492.5,614,492.5"/>
            <path class="st659" d="M614.1,492.6l5.3-1.8c0,0,0,0,0.1,0L614.1,492.6C614.1,492.6,614.1,492.6,614.1,492.6"/>
            <path class="st660"
                  d="M614.2,492.6l5.3-1.8c0,0,0.1,0,0.1,0.1L614.2,492.6C614.2,492.6,614.2,492.6,614.2,492.6"/>
            <path class="st661"
                  d="M614.2,492.7l5.3-1.8c0,0,0.1,0,0.1,0.1L614.2,492.7C614.3,492.7,614.3,492.7,614.2,492.7"/>
            <path class="st662"
                  d="M614.3,492.7l5.3-1.8c0,0,0.1,0.1,0.1,0.1L614.3,492.7C614.4,492.8,614.3,492.8,614.3,492.7"/>
            <path class="st663" d="M614.4,492.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0l-5.3,1.8C614.5,492.9,614.5,492.9,614.4,492.8
							C614.5,492.9,614.4,492.8,614.4,492.8"/>
            <path class="st664" d="M614.5,492.9l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C614.6,493,614.6,493,614.5,492.9"/>
            <path class="st665" d="M614.6,493l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C614.7,493.1,614.7,493.1,614.6,493"/>
            <path class="st666"
                  d="M614.7,493.2l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C614.8,493.3,614.8,493.2,614.7,493.2"/>
            <path class="st667"
                  d="M614.8,493.4l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.5l-5.3,1.8C615,493.7,615,493.5,614.8,493.4"/>
            <path class="st666" d="M615.1,493.9l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C615.2,494,615.1,494,615.1,493.9"/>
            <path class="st665" d="M615.2,494.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,494.2,615.2,494.1,615.2,494.1"/>
            <path class="st664" d="M615.2,494.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,494.3,615.2,494.3,615.2,494.2"/>
            <path class="st663" d="M615.2,494.4l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l-5.3,1.8C615.3,494.5,615.3,494.5,615.2,494.4
							C615.3,494.4,615.2,494.4,615.2,494.4"/>
            <path class="st662" d="M615.3,494.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.6,615.3,494.5,615.3,494.5"/>
            <path class="st661" d="M615.3,494.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.7,615.3,494.7,615.3,494.6"/>
            <path class="st660" d="M615.3,494.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.8,615.3,494.8,615.3,494.7"/>
            <path class="st659" d="M615.3,494.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.9,615.3,494.9,615.3,494.9"/>
            <path class="st658" d="M615.3,495l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,495,615.3,495,615.3,495"/>
            <path class="st657" d="M615.3,495.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,495.1,615.3,495.1,615.3,495.1"/>
            <path class="st656"
                  d="M615.3,495.2l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.2C615.3,495.2,615.3,495.2,615.3,495.2"/>
            <path class="st655"
                  d="M615.3,495.3l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.3C615.3,495.3,615.3,495.3,615.3,495.3"/>
            <path class="st654"
                  d="M615.3,495.4l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.4C615.3,495.4,615.3,495.4,615.3,495.4"/>
            <path class="st653"
                  d="M615.3,495.5l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.5C615.2,495.5,615.3,495.5,615.3,495.5"/>
            <path class="st652" d="M615.2,495.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.6,615.2,495.6,615.2,495.6"/>
            <path class="st651" d="M615.2,495.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.8,615.2,495.7,615.2,495.7"/>
            <path class="st650" d="M615.2,495.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.9,615.2,495.8,615.2,495.8"/>
            <path class="st649" d="M615.2,495.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.1,496,615.1,495.9,615.2,495.9"/>
            <path class="st648" d="M615.1,496l5.3-1.8c0,0,0,0,0,0L615.1,496C615.1,496,615.1,496,615.1,496"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000168094042691763501220000011571280251279237013_" class="st417" d="M632.3,514.6l-5.3,1.8
							c-0.2,0.1-0.4,0.1-0.6,0.2c-1.1,0.3-2.4,0.2-3.7-0.2c-1.3-0.4-2.5-1.1-3.6-2.1c-1.1-1-2.1-2.2-2.9-3.5
							c-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9c0.1-2.1,0.5-3.9,1.4-5.4l5.3-1.8c-0.8,1.5-1.3,3.3-1.4,5.4
							c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.3,0.4,2.5,0.5,3.7,0.2
							C631.9,514.7,632.1,514.7,632.3,514.6z"/>
					</defs>
          <clipPath id="SVGID_00000107552001414080755420000012161764324362981304_">
						<use xlink:href="#SVGID_00000168094042691763501220000011571280251279237013_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000107552001414080755420000012161764324362981304_);enable-background:new    ;">
						<path class="st646" d="M615.1,496l5.3-1.8c0,0,0,0,0,0L615.1,496C615.1,496.1,615.1,496,615.1,496"/>
            <path class="st647"
                  d="M615.1,496.1l5.3-1.8c-0.1,0.2-0.2,0.3-0.3,0.5l-5.3,1.8C614.9,496.4,615,496.2,615.1,496.1"/>
            <path class="st648"
                  d="M614.8,496.6l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C614.7,496.9,614.7,496.8,614.8,496.6"/>
            <path class="st649"
                  d="M614.6,497.1l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C614.5,497.4,614.5,497.2,614.6,497.1"/>
            <path class="st650"
                  d="M614.4,497.5l5.3-1.8c-0.1,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C614.3,497.8,614.4,497.7,614.4,497.5"/>
            <path class="st651"
                  d="M614.3,498l5.3-1.8c0,0.1-0.1,0.3-0.1,0.4l-5.3,1.8C614.2,498.3,614.2,498.2,614.3,498"/>
            <path class="st652"
                  d="M614.1,498.5l5.3-1.8c0,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C614.1,498.8,614.1,498.6,614.1,498.5"/>
            <path class="st653" d="M614,498.9l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C614,499.2,614,499.1,614,498.9"/>
            <path class="st654"
                  d="M613.9,499.4l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C613.9,499.7,613.9,499.5,613.9,499.4"/>
            <path class="st655"
                  d="M613.9,499.8l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C613.8,500.2,613.8,500,613.9,499.8"/>
            <path class="st656"
                  d="M613.8,500.3l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C613.8,500.7,613.8,500.5,613.8,500.3"/>
            <path class="st657" d="M613.8,500.8l5.3-1.8c0,0.2,0,0.4,0,0.5l-5.3,1.8C613.7,501.2,613.7,501,613.8,500.8"/>
            <path class="st658" d="M613.7,501.4l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.4,0,0.5l-5.3,1.8C613.7,501.8,613.7,501.6,613.7,501.4
							C613.7,501.4,613.7,501.4,613.7,501.4"/>
            <path class="st659"
                  d="M613.7,501.9l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C613.7,502.3,613.7,502.1,613.7,501.9"/>
            <path class="st660"
                  d="M613.7,502.5l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C613.8,502.9,613.7,502.7,613.7,502.5"/>
            <path class="st661"
                  d="M613.8,503.1l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C613.8,503.4,613.8,503.2,613.8,503.1"/>
            <path class="st662"
                  d="M613.8,503.6l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C613.9,504,613.8,503.8,613.8,503.6"/>
            <path class="st663"
                  d="M613.9,504.2l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C614,504.6,613.9,504.4,613.9,504.2"/>
            <path class="st664" d="M614,504.8l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7l-5.3,1.8C614.1,505.3,614,505.1,614,504.8"/>
            <path class="st665" d="M614.1,505.5l5.3-1.8c0.1,0.3,0.1,0.5,0.2,0.8c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1
							C614.3,506,614.2,505.8,614.1,505.5"/>
            <path class="st666"
                  d="M614.4,506.3l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C614.6,507.1,614.5,506.7,614.4,506.3"/>
            <path class="st667" d="M614.7,507.5l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.2c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8
							c-0.1-0.1-0.1-0.2-0.2-0.3C615.6,509.7,615.1,508.6,614.7,507.5"/>
            <path class="st666"
                  d="M616.4,511l5.3-1.8c0.2,0.4,0.5,0.7,0.7,1l-5.3,1.8C616.9,511.7,616.7,511.4,616.4,511"/>
            <path class="st665"
                  d="M617.2,512.1l5.3-1.8c0.2,0.3,0.4,0.5,0.6,0.7l-5.3,1.8C617.6,512.6,617.4,512.3,617.2,512.1"/>
            <path class="st664"
                  d="M617.8,512.8l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C618.1,513.2,617.9,513,617.8,512.8"/>
            <path class="st663"
                  d="M618.3,513.4l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.5l-5.3,1.8C618.6,513.7,618.5,513.6,618.3,513.4"/>
            <path class="st662" d="M618.8,513.9l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1l-5.3,1.8c0,0-0.1-0.1-0.1-0.1
							C619,514.1,618.9,514,618.8,513.9"/>
            <path class="st661"
                  d="M619.2,514.3l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C619.5,514.5,619.4,514.4,619.2,514.3"/>
            <path class="st660"
                  d="M619.6,514.6l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C619.9,514.8,619.8,514.7,619.6,514.6"/>
            <path class="st659"
                  d="M620,514.9l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C620.3,515.1,620.1,515,620,514.9"/>
            <path class="st658"
                  d="M620.4,515.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C620.6,515.3,620.5,515.3,620.4,515.2"/>
            <path class="st657"
                  d="M620.8,515.4l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621,515.6,620.9,515.5,620.8,515.4"/>
            <path class="st656"
                  d="M621.1,515.6l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621.4,515.8,621.3,515.7,621.1,515.6"/>
            <path class="st655"
                  d="M621.5,515.8l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621.8,516,621.7,515.9,621.5,515.8"/>
            <path class="st654"
                  d="M621.9,516l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C622.2,516.1,622.1,516.1,621.9,516"/>
            <path class="st653" d="M622.4,516.2l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0
							C622.6,516.3,622.5,516.2,622.4,516.2"/>
            <path class="st652"
                  d="M622.8,516.3l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C623.1,516.4,622.9,516.4,622.8,516.3"/>
            <path class="st651"
                  d="M623.2,516.5l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C623.5,516.5,623.4,516.5,623.2,516.5"/>
            <path class="st650"
                  d="M623.7,516.6l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C624,516.6,623.8,516.6,623.7,516.6"/>
            <path class="st649"
                  d="M624.1,516.6l5.3-1.8c0.2,0,0.3,0,0.4,0l-5.3,1.8C624.4,516.7,624.3,516.7,624.1,516.6"/>
            <path class="st648"
                  d="M624.6,516.7l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C624.9,516.7,624.7,516.7,624.6,516.7"/>
            <path class="st647" d="M625,516.7l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C625.4,516.7,625.2,516.7,625,516.7"/>
            <path class="st646"
                  d="M625.5,516.7l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C625.9,516.6,625.7,516.7,625.5,516.7"/>
            <path class="st645" d="M626.1,516.6l5.3-1.8c0.1,0,0.2,0,0.3-0.1c0.2,0,0.4-0.1,0.5-0.1l-5.3,1.8c-0.2,0.1-0.4,0.1-0.5,0.1
							C626.3,516.6,626.2,516.6,626.1,516.6"/>
            <path class="st644" d="M626.9,516.4l5.3-1.8c0,0,0.1,0,0.1,0L626.9,516.4C627,516.4,626.9,516.4,626.9,516.4"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000132782784030628559600000004675830065832954800_" class="st417" d="M619.2,492.4l5.3-1.8
							c-0.1,0-0.3,0.1-0.4,0.1l-5.3,1.8C619,492.5,619.1,492.5,619.2,492.4z"/>
					</defs>
          <clipPath id="SVGID_00000181076275087896651990000001101155434638831776_">
						<use xlink:href="#SVGID_00000132782784030628559600000004675830065832954800_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000181076275087896651990000001101155434638831776_);enable-background:new    ;">
						<path class="st644"
                  d="M619.2,492.4l5.3-1.8c-0.1,0-0.3,0.1-0.4,0.1l-5.3,1.8C619,492.5,619.1,492.5,619.2,492.4"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000114031729839878173550000012990982679381937085_" class="st417" d="M617.5,488.2l5.3-1.8
							c1.9-0.6,3.9-0.6,6,0.1l-5.3,1.8C621.4,487.6,619.4,487.6,617.5,488.2z"/>
					</defs>
          <clipPath id="SVGID_00000134947610107001600470000012297033906149646482_">
						<use xlink:href="#SVGID_00000114031729839878173550000012990982679381937085_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000134947610107001600470000012297033906149646482_);enable-background:new    ;">
						<path class="st644" d="M617.5,488.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C617.6,488.2,617.5,488.2,617.5,488.2"/>
            <path class="st645"
                  d="M617.6,488.2l5.3-1.8c0.4-0.1,0.7-0.2,1.1-0.3l-5.3,1.8C618.4,488,618,488.1,617.6,488.2"/>
            <path class="st646"
                  d="M618.7,487.9l5.3-1.8c0.3-0.1,0.6-0.1,0.9-0.1l-5.3,1.8C619.3,487.8,619,487.8,618.7,487.9"/>
            <path class="st647"
                  d="M619.6,487.8l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C620.1,487.7,619.9,487.8,619.6,487.8"/>
            <path class="st648"
                  d="M620.3,487.7l5.3-1.8c0.2,0,0.4,0,0.7,0l-5.3,1.8C620.8,487.8,620.6,487.7,620.3,487.7"/>
            <path class="st649" d="M621,487.8l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C621.4,487.8,621.2,487.8,621,487.8"/>
            <path class="st650"
                  d="M621.7,487.8l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C622.1,487.9,621.9,487.9,621.7,487.8"/>
            <path class="st651"
                  d="M622.3,487.9l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C622.7,488,622.5,488,622.3,487.9"/>
            <path class="st652"
                  d="M622.8,488.1l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C623.2,488.2,623,488.1,622.8,488.1"/>
            <path class="st653" d="M623.4,488.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C623.5,488.3,623.5,488.2,623.4,488.2"/>
					</g>
				</g>
        <g>
					<path class="st671" d="M623.5,488.3c1.7,0.6,3.4,1.5,4.9,2.9c1.5,1.3,2.8,2.9,3.9,4.8c1.1,1.8,1.9,3.8,2.5,6
						c0.6,2.2,0.9,4.4,0.8,6.6c-0.1,2.2-0.5,4.2-1.2,6c-0.7,1.7-1.7,3.2-2.8,4.2c-1.2,1.1-2.5,1.8-4.1,2.2c-1.6,0.3-3.2,0.2-5-0.3
						c-1.7-0.6-3.4-1.5-4.9-2.8c-1.5-1.3-2.8-2.9-3.9-4.7c-1.1-1.8-2-3.8-2.6-6c-0.6-2.2-0.9-4.4-0.8-6.6c0.1-2.8,0.7-5.2,1.8-7.3
						c0.2-0.5,0.6-0.7,1-0.7c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.5,0.3,0.8,0.5c0.4,0.4,0.7,0.9,0.8,1.5c0.1,0.6,0,1.1-0.2,1.6
						c-0.8,1.5-1.3,3.3-1.4,5.4c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1
						c1.3,0.4,2.5,0.5,3.7,0.2c1.1-0.3,2.1-0.8,3-1.6c0.9-0.8,1.6-1.8,2.1-3.1c0.5-1.3,0.8-2.7,0.9-4.4c0-1.6-0.2-3.3-0.6-4.9
						s-1.1-3.1-1.9-4.4c-0.8-1.4-1.8-2.5-2.9-3.5c-1.1-1-2.3-1.7-3.6-2.1c-1.6-0.5-3.2-0.5-4.6,0.1c-0.3,0.1-0.5,0.1-0.8,0
						c-0.2-0.1-0.3-0.1-0.5-0.3c-0.4-0.3-0.8-0.8-1-1.4c-0.2-0.6-0.3-1.2-0.1-1.7c0.1-0.5,0.4-0.8,0.8-1
						C619.3,487.6,621.4,487.6,623.5,488.3z"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000063599483011043737950000000139128218140693648_" class="st417" d="M633.8,518.8l-5.3,1.8
							c1.2-0.4,2.2-1,3.2-1.9c1.2-1.1,2.1-2.5,2.8-4.2c0.7-1.7,1.1-3.7,1.2-6c0.1-2.2-0.2-4.4-0.8-6.6c-0.6-2.2-1.4-4.2-2.5-6
							c-1.1-1.8-2.4-3.4-3.9-4.8c-1.5-1.3-3.1-2.3-4.9-2.9l5.3-1.8c1.7,0.6,3.4,1.5,4.9,2.9c1.5,1.3,2.8,2.9,3.9,4.8
							c1.1,1.8,1.9,3.8,2.5,6c0.6,2.2,0.9,4.4,0.8,6.6c-0.1,2.2-0.5,4.2-1.2,6c-0.7,1.7-1.7,3.2-2.8,4.2
							C636,517.8,634.9,518.4,633.8,518.8z"/>
					</defs>
          <clipPath id="SVGID_00000171719178324069841150000008126227724445730732_">
						<use xlink:href="#SVGID_00000063599483011043737950000000139128218140693648_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000171719178324069841150000008126227724445730732_);enable-background:new    ;">
						<path class="st653"
                  d="M623.5,488.3l5.3-1.8c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8C623.9,488.4,623.7,488.3,623.5,488.3"/>
            <path class="st654"
                  d="M624,488.4l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C624.4,488.6,624.2,488.5,624,488.4"/>
            <path class="st655"
                  d="M624.6,488.7l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2l-5.3,1.8C625,488.8,624.8,488.7,624.6,488.7"/>
            <path class="st656"
                  d="M625.1,488.9l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C625.5,489.1,625.3,489,625.1,488.9"/>
            <path class="st657"
                  d="M625.7,489.2l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C626,489.4,625.9,489.3,625.7,489.2"/>
            <path class="st658"
                  d="M626.2,489.5l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C626.6,489.7,626.4,489.6,626.2,489.5"/>
            <path class="st659"
                  d="M626.7,489.8l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.4l-5.3,1.8C627.1,490.1,626.9,489.9,626.7,489.8"/>
            <path class="st660"
                  d="M627.3,490.2l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C627.6,490.4,627.4,490.3,627.3,490.2"/>
            <path class="st661"
                  d="M627.8,490.6l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C628.2,490.9,628,490.7,627.8,490.6"/>
            <path class="st662" d="M628.3,491l5.3-1.8c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.3,0.3,0.5,0.5l-5.3,1.8c-0.2-0.2-0.3-0.3-0.5-0.5
							C628.4,491.1,628.4,491.1,628.3,491"/>
            <path class="st663"
                  d="M628.9,491.6l5.3-1.8c0.2,0.2,0.5,0.4,0.7,0.7l-5.3,1.8C629.4,492,629.2,491.8,628.9,491.6"/>
            <path class="st664"
                  d="M629.6,492.3l5.3-1.8c0.2,0.3,0.5,0.5,0.7,0.8l-5.3,1.8C630.1,492.8,629.9,492.5,629.6,492.3"/>
            <path class="st665"
                  d="M630.3,493.1l5.3-1.8c0.3,0.3,0.5,0.6,0.8,1l-5.3,1.8C630.9,493.7,630.6,493.4,630.3,493.1"/>
            <path class="st666"
                  d="M631.1,494l5.3-1.8c0.3,0.4,0.6,0.9,0.9,1.4l-5.3,1.8C631.7,494.9,631.4,494.5,631.1,494"/>
            <path class="st667" d="M632,495.4l5.3-1.8c0.1,0.2,0.2,0.3,0.3,0.5c0.8,1.3,1.4,2.7,1.9,4.1l-5.3,1.8
							c-0.5-1.5-1.2-2.8-1.9-4.1C632.3,495.7,632.2,495.6,632,495.4"/>
            <path class="st666"
                  d="M634.3,500l5.3-1.8c0.2,0.5,0.4,1.1,0.5,1.6l-5.3,1.8C634.7,501.1,634.5,500.6,634.3,500"/>
            <path class="st665" d="M634.8,501.6l5.3-1.8c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.1,0.6,0.2,0.8l-5.3,1.8c-0.1-0.3-0.1-0.6-0.2-0.8
							C634.9,501.8,634.8,501.7,634.8,501.6"/>
            <path class="st664"
                  d="M635.1,502.7l5.3-1.8c0.1,0.3,0.1,0.6,0.2,1l-5.3,1.8C635.2,503.4,635.2,503,635.1,502.7"/>
            <path class="st663"
                  d="M635.3,503.7l5.3-1.8c0.1,0.3,0.1,0.6,0.1,0.9l-5.3,1.8C635.4,504.3,635.4,504,635.3,503.7"/>
            <path class="st662"
                  d="M635.5,504.6l5.3-1.8c0,0.3,0.1,0.6,0.1,0.8l-5.3,1.8C635.5,505.1,635.5,504.8,635.5,504.6"/>
            <path class="st661"
                  d="M635.6,505.4l5.3-1.8c0,0.3,0.1,0.5,0.1,0.8l-5.3,1.8C635.6,505.9,635.6,505.7,635.6,505.4"/>
            <path class="st660"
                  d="M635.6,506.2l5.3-1.8c0,0.3,0,0.5,0,0.8l-5.3,1.8C635.7,506.7,635.7,506.5,635.6,506.2"/>
            <path class="st659" d="M635.7,507l5.3-1.8c0,0.3,0,0.5,0,0.8l-5.3,1.8C635.7,507.5,635.7,507.3,635.7,507"/>
            <path class="st658" d="M635.7,507.8l5.3-1.8c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1
							C635.7,508.3,635.7,508,635.7,507.8"/>
            <path class="st657"
                  d="M635.7,508.6l5.3-1.8c0,0.3,0,0.5,0,0.7l-5.3,1.8C635.7,509.1,635.7,508.8,635.7,508.6"/>
            <path class="st656"
                  d="M635.7,509.3l5.3-1.8c0,0.2,0,0.5-0.1,0.7l-5.3,1.8C635.6,509.8,635.6,509.5,635.7,509.3"/>
            <path class="st655" d="M635.6,510l5.3-1.8c0,0.2,0,0.4-0.1,0.7l-5.3,1.8C635.5,510.4,635.6,510.2,635.6,510"/>
            <path class="st654"
                  d="M635.5,510.7l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.5,511.1,635.5,510.9,635.5,510.7"/>
            <path class="st653"
                  d="M635.4,511.3l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.3,511.7,635.4,511.5,635.4,511.3"/>
            <path class="st652"
                  d="M635.3,511.9l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.2,512.4,635.2,512.2,635.3,511.9"/>
            <path class="st651"
                  d="M635.1,512.6l5.3-1.8c-0.1,0.2-0.1,0.4-0.2,0.6l-5.3,1.8C635,513,635.1,512.8,635.1,512.6"/>
            <path class="st650"
                  d="M635,513.2l5.3-1.8c-0.1,0.2-0.1,0.4-0.2,0.6l-5.3,1.8C634.8,513.6,634.9,513.4,635,513.2"/>
            <path class="st649" d="M634.8,513.8l5.3-1.8c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0
							C634.6,514.3,634.7,514,634.8,513.8"/>
            <path class="st648"
                  d="M634.5,514.5l5.3-1.8c-0.1,0.3-0.2,0.5-0.4,0.8l-5.3,1.8C634.3,515,634.4,514.7,634.5,514.5"/>
            <path class="st647"
                  d="M634.2,515.3l5.3-1.8c-0.1,0.3-0.3,0.5-0.4,0.8l-5.3,1.8C633.9,515.8,634,515.5,634.2,515.3"/>
            <path class="st646"
                  d="M633.8,516l5.3-1.8c-0.2,0.3-0.3,0.5-0.5,0.8l-5.3,1.8C633.4,516.6,633.6,516.3,633.8,516"/>
            <path class="st645"
                  d="M633.3,516.8l5.3-1.8c-0.2,0.3-0.5,0.6-0.7,0.9l-5.3,1.8C632.8,517.5,633,517.2,633.3,516.8"/>
            <path class="st644" d="M632.6,517.8l5.3-1.8c-0.3,0.3-0.6,0.7-0.9,0.9c-0.9,0.9-2,1.5-3.2,1.9l-5.3,1.8c1.2-0.4,2.2-1,3.2-1.9
							C632,518.4,632.3,518.1,632.6,517.8"/>
					</g>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000039830806908572362550000015036273077569078956_" class="st417" d="M602.7,510.4l-5.3,1.8
							c0.2-0.1,0.3-0.1,0.4-0.3c0.3-0.3,0.5-0.8,0.5-1.4l5.3-1.8c0,0.6-0.2,1.1-0.5,1.4C603,510.2,602.9,510.3,602.7,510.4z"/>
					</defs>
          <clipPath id="SVGID_00000077298283285638824790000010376499410890252178_">
						<use xlink:href="#SVGID_00000039830806908572362550000015036273077569078956_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000077298283285638824790000010376499410890252178_);enable-background:new    ;">
						<polyline class="st658" points="598.4,510.5 603.7,508.7 603.7,508.7 598.4,510.5 598.4,510.5 						"/>
            <path class="st657" d="M598.4,510.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.6,598.4,510.5,598.4,510.5"/>
            <path class="st656" d="M598.4,510.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.7,598.4,510.6,598.4,510.6"/>
            <path class="st655" d="M598.4,510.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.8,598.4,510.7,598.4,510.7"/>
            <path class="st654"
                  d="M598.4,510.8l5.3-1.8c0,0,0,0.1,0,0.1L598.4,510.8C598.3,510.9,598.4,510.9,598.4,510.8"/>
            <path class="st653" d="M598.3,510.9l5.3-1.8c0,0,0,0.1,0,0.1L598.3,510.9C598.3,511,598.3,511,598.3,510.9"/>
            <path class="st652" d="M598.3,511l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511C598.3,511.1,598.3,511,598.3,511"/>
            <path class="st651"
                  d="M598.3,511.1l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511.1C598.3,511.2,598.3,511.1,598.3,511.1"/>
            <path class="st650"
                  d="M598.3,511.2l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511.2C598.3,511.2,598.3,511.2,598.3,511.2"/>
            <path class="st649"
                  d="M598.2,511.3l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.3C598.2,511.3,598.2,511.3,598.2,511.3"/>
            <path class="st648"
                  d="M598.2,511.4l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.4C598.2,511.4,598.2,511.4,598.2,511.4"/>
            <path class="st647"
                  d="M598.2,511.4l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.4C598.1,511.5,598.2,511.5,598.2,511.4"/>
            <path class="st646"
                  d="M598.1,511.5l5.3-1.8c0,0,0,0.1-0.1,0.1L598.1,511.5C598.1,511.6,598.1,511.6,598.1,511.5"/>
            <path class="st645" d="M598.1,511.6l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C598,511.7,598,511.7,598.1,511.6"/>
            <path class="st644" d="M598,511.8l5.3-1.8c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3l-5.3,1.8c0.2-0.1,0.3-0.1,0.4-0.3
							C597.9,511.8,597.9,511.8,598,511.8"/>
					</g>
				</g>
        <g>
					<polygon class="st674" points="598.5,507.9 603.7,506.1 603.7,508.7 598.4,510.5 					"/>
				</g>
        <g>
					<polygon class="st674" points="598.5,507.3 603.8,505.6 603.7,506.1 598.5,507.9 					"/>
				</g>
        <g>
					<path class="st671" d="M598.6,503.1l-0.1,4.2l0,0.6l-0.1,2.5c0,0.6-0.2,1.1-0.5,1.4c-0.3,0.3-0.7,0.4-1.2,0.2
						c-0.5-0.2-0.9-0.5-1.2-1c-0.3-0.5-0.5-1.1-0.4-1.7l0.1-2.5l0-0.6l0.1-4.2L598.6,503.1z"/>
				</g>
        <g>
					<polygon class="st674" points="598.6,503.1 603.9,501.4 603.8,505.6 598.5,507.3 					"/>
				</g>
        <g>
					<polygon class="st655" points="595.3,502 600.6,500.3 603.9,501.4 598.6,503.1 					"/>
				</g>
			</g>
      <g class="st417">
				<g>
					<polygon class="st674" points="598.7,499 604,497.3 603.9,499.4 598.7,501.2 					"/>
				</g>
        <g>
					<polygon class="st674" points="598.8,497 604.1,495.2 604,497.3 598.7,499 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000089574599315423773790000011216563751677216669_" class="st417" d="M596.8,479.7l5.3-1.8
							c0.2-0.1,0.5-0.1,0.8,0l-5.3,1.8C597.3,479.6,597.1,479.6,596.8,479.7z"/>
					</defs>
          <clipPath id="SVGID_00000160148084411026225880000013327060818211428521_">
						<use xlink:href="#SVGID_00000089574599315423773790000011216563751677216669_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000160148084411026225880000013327060818211428521_);enable-background:new    ;">
						<path class="st644" d="M596.8,479.7l5.3-1.8c0,0,0,0,0,0L596.8,479.7C596.8,479.7,596.8,479.7,596.8,479.7"/>
            <path class="st645" d="M596.8,479.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C596.9,479.6,596.9,479.7,596.8,479.7"/>
            <path class="st646" d="M597,479.6l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597,479.6,597,479.6,597,479.6"/>
            <path class="st647"
                  d="M597.1,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.1,479.6C597.1,479.6,597.1,479.6,597.1,479.6"/>
            <path class="st648"
                  d="M597.2,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.2,479.6C597.2,479.6,597.2,479.6,597.2,479.6"/>
            <path class="st649"
                  d="M597.3,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.3,479.6C597.3,479.6,597.3,479.6,597.3,479.6"/>
            <path class="st650"
                  d="M597.3,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.3,479.6C597.4,479.6,597.4,479.6,597.3,479.6"/>
            <path class="st651"
                  d="M597.4,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.4,479.6C597.5,479.7,597.5,479.6,597.4,479.6"/>
            <path class="st652"
                  d="M597.5,479.7l5.3-1.8c0,0,0.1,0,0.1,0L597.5,479.7C597.6,479.7,597.6,479.7,597.5,479.7"/>
            <path class="st653" d="M597.6,479.7l5.3-1.8c0,0,0,0,0,0L597.6,479.7C597.6,479.7,597.6,479.7,597.6,479.7"/>
					</g>
				</g>
        <g>
					<polygon class="st674" points="599.2,482.4 604.5,480.6 604.1,495.2 598.8,497 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000133514726964279219070000010949542666360762039_" class="st417" d="M597.6,479.7l5.3-1.8
							c0.4,0.1,0.8,0.5,1.1,1l-5.3,1.8C598.5,480.2,598.1,479.8,597.6,479.7z"/>
					</defs>
          <clipPath id="SVGID_00000165928078289281796680000005467570382223767179_">
						<use xlink:href="#SVGID_00000133514726964279219070000010949542666360762039_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000165928078289281796680000005467570382223767179_);enable-background:new    ;">
						<path class="st653" d="M597.6,479.7l5.3-1.8c0,0,0,0,0.1,0L597.6,479.7C597.7,479.7,597.7,479.7,597.6,479.7"/>
            <path class="st654" d="M597.7,479.7l5.3-1.8c0,0,0,0,0.1,0L597.7,479.7C597.7,479.7,597.7,479.7,597.7,479.7"/>
            <path class="st655" d="M597.8,479.7l5.3-1.8c0,0,0,0,0.1,0L597.8,479.7C597.8,479.8,597.8,479.8,597.8,479.7"/>
            <path class="st656" d="M597.8,479.8l5.3-1.8c0,0,0,0,0.1,0L597.8,479.8C597.9,479.8,597.9,479.8,597.8,479.8"/>
            <path class="st657" d="M597.9,479.8l5.3-1.8c0,0,0,0,0.1,0L597.9,479.8C598,479.8,597.9,479.8,597.9,479.8"/>
            <path class="st658" d="M598,479.8l5.3-1.8c0,0,0,0,0.1,0L598,479.8C598,479.9,598,479.9,598,479.8"/>
            <path class="st659" d="M598,479.9l5.3-1.8c0,0,0,0,0.1,0L598,479.9C598.1,479.9,598.1,479.9,598,479.9"/>
            <path class="st660" d="M598.1,479.9l5.3-1.8c0,0,0,0,0.1,0.1L598.1,479.9C598.2,480,598.1,480,598.1,479.9"/>
            <path class="st661" d="M598.2,480l5.3-1.8c0,0,0,0,0.1,0.1L598.2,480C598.2,480,598.2,480,598.2,480"/>
            <path class="st662" d="M598.2,480l5.3-1.8c0,0,0,0,0.1,0.1L598.2,480C598.3,480.1,598.3,480.1,598.2,480"/>
            <path class="st663"
                  d="M598.3,480.1l5.3-1.8c0,0,0.1,0.1,0.1,0.1L598.3,480.1C598.4,480.2,598.3,480.1,598.3,480.1"/>
            <path class="st664"
                  d="M598.4,480.2l5.3-1.8c0,0,0.1,0.1,0.1,0.1L598.4,480.2C598.5,480.3,598.4,480.2,598.4,480.2"/>
            <path class="st665"
                  d="M598.5,480.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.5,480.4,598.5,480.3,598.5,480.3"/>
            <path class="st666"
                  d="M598.6,480.4l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C598.7,480.5,598.6,480.5,598.6,480.4"/>
            <path class="st667"
                  d="M598.7,480.6l5.3-1.8c0,0,0,0.1,0,0.1L598.7,480.6C598.7,480.7,598.7,480.6,598.7,480.6"/>
					</g>
				</g>
        <g>
					<path class="st671" d="M597.6,479.7c0.4,0.1,0.8,0.5,1.1,1c0.3,0.5,0.4,1.1,0.4,1.7l-0.4,14.6l-0.1,2l-0.1,2.2l-3.3-1.1
						l0.1-2.2l0.1-2l0.4-14.6c0-0.6,0.2-1.1,0.5-1.4C596.7,479.6,597.1,479.5,597.6,479.7z"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000019667339594492453590000003519155608054967463_" class="st417" d="M598.8,480.7l5.3-1.8
							c0.3,0.5,0.4,1.1,0.4,1.7l-5.3,1.8C599.2,481.8,599.1,481.2,598.8,480.7z"/>
					</defs>
          <clipPath id="SVGID_00000061430114595752432400000005906143538047538057_">
						<use xlink:href="#SVGID_00000019667339594492453590000003519155608054967463_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000061430114595752432400000005906143538047538057_);enable-background:new    ;">
						<path class="st667"
                  d="M598.8,480.7l5.3-1.8c0.1,0.2,0.2,0.3,0.2,0.5l-5.3,1.8C598.9,481,598.9,480.9,598.8,480.7"/>
            <path class="st666" d="M599,481.2l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C599,481.3,599,481.3,599,481.2"/>
            <path class="st665" d="M599.1,481.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.1,481.5,599.1,481.4,599.1,481.4"/>
            <path class="st664" d="M599.1,481.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.1,481.6,599.1,481.6,599.1,481.5"/>
            <path class="st663" d="M599.1,481.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,481.8,599.1,481.7,599.1,481.7"/>
            <path class="st662" d="M599.2,481.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,481.9,599.2,481.8,599.2,481.8"/>
            <path class="st661" d="M599.2,481.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482,599.2,482,599.2,481.9"/>
            <path class="st660" d="M599.2,482.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.1,599.2,482.1,599.2,482.1"/>
            <path class="st659" d="M599.2,482.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.3,599.2,482.2,599.2,482.2"/>
            <path class="st658" d="M599.2,482.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.4,599.2,482.3,599.2,482.3"/>
					</g>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000038404880807425324500000002517481041474823614_" class="st417" d="M596.8,471.1l5.3-1.8
							c0.3-0.1,0.7-0.1,1.1,0l-5.3,1.8C597.5,471,597.1,471,596.8,471.1z"/>
					</defs>
          <clipPath id="SVGID_00000052809302343135985410000001696324287678190527_">
						<use xlink:href="#SVGID_00000038404880807425324500000002517481041474823614_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000052809302343135985410000001696324287678190527_);enable-background:new    ;">
						<path class="st644" d="M596.8,471.1l5.3-1.8c0,0,0,0,0,0L596.8,471.1C596.8,471.1,596.8,471.1,596.8,471.1"/>
            <path class="st645" d="M596.8,471.1l5.3-1.8c0.1,0,0.1,0,0.2,0L597,471C596.9,471,596.8,471.1,596.8,471.1"/>
            <path class="st646" d="M597,471l5.3-1.8c0,0,0.1,0,0.2,0l-5.3,1.8C597.1,471,597,471,597,471"/>
            <path class="st647" d="M597.1,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.2,471,597.2,471,597.1,471"/>
            <path class="st648" d="M597.3,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.3,471,597.3,471,597.3,471"/>
            <path class="st649" d="M597.4,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.5,471,597.4,471,597.4,471"/>
            <path class="st650" d="M597.5,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.6,471,597.5,471,597.5,471"/>
            <path class="st651" d="M597.6,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.7,471.1,597.7,471,597.6,471"/>
            <path class="st652" d="M597.8,471.1l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.8,471.1,597.8,471.1,597.8,471.1"/>
            <path class="st653" d="M597.9,471.1l5.3-1.8c0,0,0,0,0,0L597.9,471.1C597.9,471.1,597.9,471.1,597.9,471.1"/>
					</g>
				</g>
        <g>
					<path class="st671" d="M597.9,471.1c0.6,0.2,1.2,0.7,1.7,1.5c0.5,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.5-0.8,2
						c-0.5,0.5-1.1,0.6-1.7,0.4c-0.7-0.2-1.3-0.7-1.7-1.5c-0.5-0.8-0.7-1.6-0.6-2.4c0-0.9,0.3-1.5,0.8-2
						C596.6,471,597.2,470.9,597.9,471.1z"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000065063102388052859840000016903077010704873134_" class="st417" d="M604.1,475.6l-5.3,1.8
							c0.2-0.1,0.5-0.2,0.7-0.4c0.5-0.5,0.8-1.1,0.8-2c0-0.9-0.2-1.7-0.7-2.5c-0.5-0.8-1-1.2-1.7-1.5l5.3-1.8
							c0.6,0.2,1.2,0.7,1.7,1.5c0.5,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.5-0.8,2C604.5,475.4,604.3,475.5,604.1,475.6z"/>
					</defs>
          <clipPath id="SVGID_00000173868232858261225670000013318379702494306453_">
						<use xlink:href="#SVGID_00000065063102388052859840000016903077010704873134_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000173868232858261225670000013318379702494306453_);enable-background:new    ;">
						<path class="st653" d="M597.9,471.1l5.3-1.8c0,0,0.1,0,0.1,0L597.9,471.1C598,471.1,597.9,471.1,597.9,471.1"/>
            <path class="st654" d="M598,471.1l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C598.1,471.2,598,471.2,598,471.1"/>
            <path class="st655" d="M598.1,471.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C598.2,471.2,598.1,471.2,598.1,471.2"/>
            <path class="st656"
                  d="M598.2,471.2l5.3-1.8c0,0,0.1,0,0.1,0.1L598.2,471.2C598.3,471.3,598.2,471.2,598.2,471.2"/>
            <path class="st657"
                  d="M598.3,471.3l5.3-1.8c0,0,0.1,0,0.1,0.1L598.3,471.3C598.4,471.3,598.3,471.3,598.3,471.3"/>
            <path class="st658"
                  d="M598.4,471.3l5.3-1.8c0,0,0.1,0,0.1,0.1L598.4,471.3C598.5,471.4,598.4,471.4,598.4,471.3"/>
            <path class="st659"
                  d="M598.5,471.4l5.3-1.8c0,0,0.1,0,0.1,0.1L598.5,471.4C598.6,471.4,598.5,471.4,598.5,471.4"/>
            <path class="st660"
                  d="M598.6,471.5l5.3-1.8c0,0,0.1,0,0.1,0.1L598.6,471.5C598.7,471.5,598.6,471.5,598.6,471.5"/>
            <path class="st661"
                  d="M598.7,471.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.8,471.6,598.7,471.6,598.7,471.5"/>
            <path class="st662"
                  d="M598.8,471.6l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.9,471.7,598.8,471.7,598.8,471.6"/>
            <path class="st663"
                  d="M598.9,471.7l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C599,471.8,598.9,471.8,598.9,471.7"/>
            <path class="st664" d="M599,471.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C599.1,471.9,599.1,471.9,599,471.8"/>
            <path class="st665"
                  d="M599.1,472l5.3-1.8c0.1,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C599.2,472.1,599.2,472,599.1,472"/>
            <path class="st666"
                  d="M599.3,472.2l5.3-1.8c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8C599.4,472.4,599.4,472.3,599.3,472.2"/>
            <path class="st667" d="M599.5,472.5l5.3-1.8c0,0,0,0.1,0.1,0.1c0.2,0.3,0.3,0.5,0.4,0.8l-5.3,1.8c-0.1-0.3-0.2-0.6-0.4-0.8
							C599.5,472.5,599.5,472.5,599.5,472.5"/>
            <path class="st666" d="M600,473.4l5.3-1.8c0,0.1,0.1,0.2,0.1,0.3l-5.3,1.8C600,473.6,600,473.5,600,473.4"/>
            <path class="st665" d="M600,473.7l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C600.1,473.8,600.1,473.7,600,473.7"/>
            <path class="st664" d="M600.1,473.9l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.1,474,600.1,473.9,600.1,473.9"/>
            <path class="st663"
                  d="M600.1,474.1l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.2,600.2,474.1,600.1,474.1"/>
            <path class="st662"
                  d="M600.2,474.2l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.3,600.2,474.3,600.2,474.2"/>
            <path class="st661"
                  d="M600.2,474.4l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.5,600.2,474.4,600.2,474.4"/>
            <path class="st660"
                  d="M600.2,474.6l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.7,600.2,474.6,600.2,474.6"/>
            <path class="st659"
                  d="M600.2,474.7l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.8,600.2,474.8,600.2,474.7"/>
            <path class="st658" d="M600.2,474.9l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0
							C600.2,475,600.2,474.9,600.2,474.9"/>
            <path class="st657" d="M600.2,475l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.1,600.2,475.1,600.2,475"/>
            <path class="st656" d="M600.2,475.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.3,600.2,475.2,600.2,475.2"/>
            <path class="st655" d="M600.2,475.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.4,600.2,475.4,600.2,475.3"/>
            <path class="st654" d="M600.2,475.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.5,600.2,475.5,600.2,475.4"/>
            <path class="st653" d="M600.2,475.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.6,600.2,475.6,600.2,475.6"/>
            <path class="st652" d="M600.1,475.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.8,600.1,475.7,600.1,475.7"/>
            <path class="st651" d="M600.1,475.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.9,600.1,475.8,600.1,475.8"/>
            <path class="st650" d="M600.1,475.9l5.3-1.8c0,0,0,0.1,0,0.1L600,476C600.1,476,600.1,476,600.1,475.9"/>
            <path class="st649" d="M600,476l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600,476.1,600,476.1,600,476"/>
            <path class="st648" d="M600,476.2l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C600,476.2,600,476.2,600,476.2"/>
            <path class="st647"
                  d="M599.9,476.3l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C599.9,476.4,599.9,476.3,599.9,476.3"/>
            <path class="st646"
                  d="M599.9,476.4l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2l-5.3,1.8C599.8,476.5,599.8,476.5,599.9,476.4"/>
            <path class="st645"
                  d="M599.8,476.6l5.3-1.8c0,0.1-0.1,0.1-0.2,0.2l-5.3,1.8C599.7,476.7,599.7,476.7,599.8,476.6"/>
            <path class="st644" d="M599.6,476.8l5.3-1.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.3-0.7,0.4l-5.3,1.8
							c0.2-0.1,0.5-0.2,0.7-0.4C599.5,476.9,599.6,476.9,599.6,476.8"/>
					</g>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000109710921183913761160000003713375258898373258_" class="st417" d="M549,469.6l5.3-1.8
							c-0.9,0.3-1.7,0.8-2.4,1.4c-0.9,0.8-1.6,1.8-2.1,3.1c-0.5,1.3-0.8,2.8-0.9,4.4c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4
							c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.5,0.5,3,0.5,4.3,0.1l-5.3,1.8c-1.3,0.4-2.8,0.4-4.3-0.1
							c-1.3-0.4-2.5-1.1-3.6-2.1c-1.1-1-2.1-2.2-2.9-3.5c-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9s0.3-3.1,0.9-4.4
							c0.5-1.3,1.2-2.3,2.1-3.1C547.3,470.4,548.1,469.9,549,469.6z"/>
					</defs>
          <clipPath id="SVGID_00000111149983663625220790000005779819152401151113_">
						<use xlink:href="#SVGID_00000109710921183913761160000003713375258898373258_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000111149983663625220790000005779819152401151113_);enable-background:new    ;">
						<path class="st644" d="M549,469.6l5.3-1.8c-0.9,0.3-1.7,0.8-2.4,1.4c-0.2,0.2-0.5,0.5-0.7,0.7l-5.3,1.8
							c0.2-0.3,0.4-0.5,0.7-0.7C547.3,470.4,548.1,469.9,549,469.6"/>
            <path class="st645"
                  d="M545.9,471.7l5.3-1.8c-0.2,0.2-0.4,0.4-0.5,0.7l-5.3,1.8C545.6,472.2,545.8,471.9,545.9,471.7"/>
            <path class="st646"
                  d="M545.4,472.4l5.3-1.8c-0.1,0.2-0.3,0.4-0.4,0.6l-5.3,1.8C545.2,472.8,545.3,472.6,545.4,472.4"/>
            <path class="st647"
                  d="M545.1,473l5.3-1.8c-0.1,0.2-0.2,0.4-0.3,0.6l-5.3,1.8C544.9,473.4,545,473.2,545.1,473"/>
            <path class="st648" d="M544.8,473.6l5.3-1.8c-0.1,0.2-0.2,0.4-0.2,0.5c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0
							C544.6,474,544.7,473.8,544.8,473.6"/>
            <path class="st649"
                  d="M544.5,474.2l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C544.4,474.5,544.4,474.3,544.5,474.2"/>
            <path class="st650"
                  d="M544.3,474.7l5.3-1.8c-0.1,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C544.2,475,544.3,474.8,544.3,474.7"/>
            <path class="st651"
                  d="M544.2,475.1l5.3-1.8c0,0.1-0.1,0.3-0.1,0.4l-5.3,1.8C544.1,475.4,544.1,475.3,544.2,475.1"/>
            <path class="st652" d="M544,475.6l5.3-1.8c0,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C544,475.9,544,475.7,544,475.6"/>
            <path class="st653"
                  d="M543.9,476l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C543.9,476.3,543.9,476.2,543.9,476"/>
            <path class="st654"
                  d="M543.8,476.5l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C543.8,476.8,543.8,476.6,543.8,476.5"/>
            <path class="st655" d="M543.8,477l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C543.7,477.3,543.7,477.1,543.8,477"/>
            <path class="st656"
                  d="M543.7,477.4l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C543.7,477.8,543.7,477.6,543.7,477.4"/>
            <path class="st657" d="M543.7,478l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.6,478.3,543.7,478.1,543.7,478"/>
            <path class="st658" d="M543.6,478.5l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.4,0,0.5l-5.3,1.8C543.6,478.9,543.6,478.7,543.6,478.5
							C543.6,478.5,543.6,478.5,543.6,478.5"/>
            <path class="st659"
                  d="M543.6,479.1l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.6,479.5,543.6,479.3,543.6,479.1"/>
            <path class="st660" d="M543.6,479.7l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.7,480,543.6,479.8,543.6,479.7"/>
            <path class="st661"
                  d="M543.7,480.2l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C543.7,480.6,543.7,480.4,543.7,480.2"/>
            <path class="st662"
                  d="M543.7,480.8l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C543.8,481.2,543.7,481,543.7,480.8"/>
            <path class="st663"
                  d="M543.8,481.4l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C543.9,481.8,543.8,481.6,543.8,481.4"/>
            <path class="st664"
                  d="M543.9,482.1l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7l-5.3,1.8C544,482.5,544,482.3,543.9,482.1"/>
            <path class="st665" d="M544.1,482.7l5.3-1.8c0.1,0.2,0.1,0.5,0.2,0.7c0,0,0,0.1,0,0.1l-5.3,1.8c0,0,0-0.1,0-0.1
							C544.2,483.2,544.1,483,544.1,482.7"/>
            <path class="st666"
                  d="M544.3,483.5l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C544.5,484.3,544.4,483.9,544.3,483.5"/>
            <path class="st667" d="M544.6,484.7l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.1c0.1,0.1,0.2,0.3,0.3,0.4l-5.3,1.8
							c-0.1-0.1-0.2-0.3-0.3-0.4C545.5,486.9,545.1,485.8,544.6,484.7"/>
            <path class="st666"
                  d="M546.4,488.3l5.3-1.8c0.2,0.3,0.4,0.7,0.7,1l-5.3,1.8C546.9,489,546.6,488.7,546.4,488.3"/>
            <path class="st665"
                  d="M547.1,489.3l5.3-1.8c0.2,0.2,0.4,0.5,0.6,0.7l-5.3,1.8C547.5,489.8,547.3,489.5,547.1,489.3"/>
            <path class="st664"
                  d="M547.7,490l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C548,490.4,547.8,490.2,547.7,490"/>
            <path class="st663"
                  d="M548.2,490.6l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.5l-5.3,1.8C548.5,491,548.4,490.8,548.2,490.6"/>
            <path class="st662" d="M548.7,491.1l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l-5.3,1.8
							c-0.1-0.1-0.1-0.1-0.2-0.2C548.9,491.3,548.8,491.2,548.7,491.1"/>
            <path class="st661"
                  d="M549.2,491.5l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C549.4,491.8,549.3,491.7,549.2,491.5"/>
            <path class="st660"
                  d="M549.6,491.9l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C549.8,492.1,549.7,492,549.6,491.9"/>
            <path class="st659"
                  d="M549.9,492.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C550.2,492.3,550.1,492.2,549.9,492.2"/>
            <path class="st658"
                  d="M550.3,492.4l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C550.5,492.6,550.4,492.5,550.3,492.4"/>
            <path class="st657"
                  d="M550.7,492.6l5.3-1.8c0.1,0.1,0.2,0.1,0.4,0.2l-5.3,1.8C550.9,492.8,550.8,492.7,550.7,492.6"/>
            <path class="st656"
                  d="M551,492.9l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C551.3,493,551.2,492.9,551,492.9"/>
            <path class="st655"
                  d="M551.4,493.1l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C551.7,493.2,551.6,493.1,551.4,493.1"/>
            <path class="st654"
                  d="M551.8,493.2l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C552.1,493.4,552,493.3,551.8,493.2"/>
            <path class="st653" d="M552.2,493.4l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0
							C552.5,493.5,552.4,493.4,552.2,493.4"/>
            <path class="st652"
                  d="M552.7,493.6l5.3-1.8c0.2,0,0.3,0.1,0.5,0.1l-5.3,1.8C553,493.6,552.8,493.6,552.7,493.6"/>
            <path class="st651"
                  d="M553.1,493.7l5.3-1.8c0.2,0,0.3,0.1,0.4,0.1l-5.3,1.8C553.4,493.8,553.3,493.7,553.1,493.7"/>
            <path class="st650"
                  d="M553.6,493.8l5.3-1.8c0.2,0,0.3,0.1,0.5,0.1l-5.3,1.8C553.9,493.8,553.7,493.8,553.6,493.8"/>
            <path class="st649" d="M554,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C554.3,493.9,554.2,493.9,554,493.9"/>
            <path class="st648"
                  d="M554.5,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C554.8,493.9,554.7,493.9,554.5,493.9"/>
            <path class="st647" d="M555,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C555.3,493.9,555.2,493.9,555,493.9"/>
            <path class="st646"
                  d="M555.5,493.9l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C555.9,493.9,555.7,493.9,555.5,493.9"/>
            <path class="st645"
                  d="M556.1,493.8l5.3-1.8c0.3,0,0.5-0.1,0.7-0.2l-5.3,1.8C556.6,493.7,556.3,493.8,556.1,493.8"/>
            <path class="st644"
                  d="M556.8,493.6l5.3-1.8c0,0,0.1,0,0.1,0L556.8,493.6C556.9,493.6,556.9,493.6,556.8,493.6"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000162313597939621197340000004726270063768230530_" class="st417" d="M563.6,496.1l-5.3,1.8
							c0.2-0.1,0.5-0.2,0.7-0.3l5.3-1.8C564.1,495.9,563.8,496,563.6,496.1z"/>
					</defs>
          <clipPath id="SVGID_00000146459087778951772580000016529581961424921761_">
						<use xlink:href="#SVGID_00000162313597939621197340000004726270063768230530_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000146459087778951772580000016529581961424921761_);enable-background:new    ;">
						<path class="st644"
                  d="M559,497.6l5.3-1.8c-0.2,0.1-0.5,0.2-0.7,0.3l-5.3,1.8C558.6,497.8,558.8,497.7,559,497.6"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000104668710927422217650000015234498523817113784_" class="st417" d="M557.6,493.3l5.3-1.8
							c0.2-0.1,0.5-0.1,0.7,0c0.1,0,0.3,0.1,0.4,0.2c0.4,0.3,0.8,0.7,1,1.3l-5.3,1.8c-0.2-0.6-0.5-1.1-1-1.3
							c-0.1-0.1-0.3-0.2-0.4-0.2C558.1,493.3,557.8,493.3,557.6,493.3z"/>
					</defs>
          <clipPath id="SVGID_00000153673285402916632260000015235835904128222099_">
						<use xlink:href="#SVGID_00000104668710927422217650000015234498523817113784_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000153673285402916632260000015235835904128222099_);enable-background:new    ;">
						<path class="st644" d="M557.6,493.3l5.3-1.8c0,0,0,0,0,0L557.6,493.3C557.6,493.3,557.6,493.3,557.6,493.3"/>
            <path class="st645"
                  d="M557.6,493.3l5.3-1.8c0.1,0,0.1,0,0.2,0l-5.3,1.8C557.7,493.3,557.7,493.3,557.6,493.3"/>
            <path class="st646" d="M557.8,493.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C557.8,493.3,557.8,493.3,557.8,493.3"/>
            <path class="st647"
                  d="M557.9,493.3l5.3-1.8c0,0,0.1,0,0.1,0L557.9,493.3C557.9,493.3,557.9,493.3,557.9,493.3"/>
            <path class="st648" d="M558,493.3l5.3-1.8c0,0,0.1,0,0.1,0L558,493.3C558,493.3,558,493.3,558,493.3"/>
            <path class="st649" d="M558,493.3l5.3-1.8c0,0,0,0,0.1,0L558,493.3C558.1,493.3,558.1,493.3,558,493.3"/>
            <path class="st650" d="M558.1,493.3l5.3-1.8c0,0,0,0,0.1,0L558.1,493.3C558.2,493.3,558.1,493.3,558.1,493.3"/>
            <path class="st651" d="M558.2,493.3l5.3-1.8c0,0,0,0,0.1,0L558.2,493.3C558.2,493.3,558.2,493.3,558.2,493.3"/>
            <path class="st652" d="M558.3,493.3l5.3-1.8c0,0,0,0,0.1,0L558.3,493.3C558.3,493.3,558.3,493.3,558.3,493.3"/>
            <path class="st653" d="M558.3,493.3l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L558.3,493.3C558.4,493.3,558.3,493.3,558.3,493.3
							C558.3,493.3,558.3,493.3,558.3,493.3"/>
            <path class="st654" d="M558.4,493.4l5.3-1.8c0,0,0,0,0.1,0L558.4,493.4C558.4,493.4,558.4,493.4,558.4,493.4"/>
            <path class="st655" d="M558.4,493.4l5.3-1.8c0,0,0,0,0.1,0L558.4,493.4C558.5,493.4,558.5,493.4,558.4,493.4"/>
            <path class="st656" d="M558.5,493.4l5.3-1.8c0,0,0,0,0.1,0L558.5,493.4C558.5,493.4,558.5,493.4,558.5,493.4"/>
            <path class="st657" d="M558.6,493.4l5.3-1.8c0,0,0,0,0.1,0L558.6,493.4C558.6,493.5,558.6,493.5,558.6,493.4"/>
            <path class="st658" d="M558.6,493.5l5.3-1.8c0,0,0,0,0.1,0L558.6,493.5C558.7,493.5,558.7,493.5,558.6,493.5"/>
            <path class="st659" d="M558.7,493.5l5.3-1.8c0,0,0,0,0,0L558.7,493.5C558.7,493.5,558.7,493.5,558.7,493.5"/>
            <polyline class="st658"
                      points="558.7,493.5 564,491.8 564,491.8 564,491.8 558.7,493.5 558.7,493.5 558.7,493.5 						"/>
            <path class="st659"
                  d="M558.7,493.5l5.3-1.8c0,0,0.1,0,0.1,0.1L558.7,493.5C558.8,493.6,558.7,493.6,558.7,493.5"/>
            <path class="st660"
                  d="M558.8,493.6l5.3-1.8c0,0,0,0,0.1,0.1L558.8,493.6C558.8,493.6,558.8,493.6,558.8,493.6"/>
            <path class="st661"
                  d="M558.9,493.6l5.3-1.8c0,0,0,0,0.1,0.1L558.9,493.6C558.9,493.7,558.9,493.7,558.9,493.6"/>
            <path class="st662" d="M558.9,493.7l5.3-1.8c0,0,0,0,0.1,0.1L558.9,493.7C559,493.7,559,493.7,558.9,493.7"/>
            <path class="st663" d="M559,493.8l5.3-1.8c0,0,0.1,0,0.1,0.1L559,493.8C559.1,493.8,559,493.8,559,493.8"/>
            <path class="st664"
                  d="M559.1,493.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1L559.1,493.8C559.1,493.9,559.1,493.9,559.1,493.8"/>
            <path class="st665" d="M559.2,493.9l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C559.2,494,559.2,494,559.2,493.9"/>
            <path class="st666"
                  d="M559.3,494l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C559.3,494.2,559.3,494.1,559.3,494"/>
            <path class="st667"
                  d="M559.4,494.2l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C559.6,494.6,559.5,494.4,559.4,494.2"/>
            <path class="st666" d="M559.7,494.8l5.3-1.8c0,0,0,0,0,0L559.7,494.8C559.7,494.9,559.7,494.9,559.7,494.8"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000084517231654846081970000004328518718239633285_" class="st417" d="M559.7,494.9l5.3-1.8
							c0.3,0.6,0.3,1.1,0.2,1.7c-0.1,0.5-0.4,0.9-0.8,1l-5.3,1.8c0.4-0.2,0.7-0.5,0.8-1C560,496,559.9,495.5,559.7,494.9z"/>
					</defs>
          <clipPath id="SVGID_00000122685801732222491960000018221241352908784805_">
						<use xlink:href="#SVGID_00000084517231654846081970000004328518718239633285_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000122685801732222491960000018221241352908784805_);enable-background:new    ;">
						<path class="st667"
                  d="M559.7,494.9l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C559.8,495,559.7,495,559.7,494.9"/>
            <path class="st666"
                  d="M559.8,495.1l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C559.8,495.2,559.8,495.2,559.8,495.1"/>
            <path class="st665" d="M559.8,495.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.4,559.8,495.3,559.8,495.3"/>
            <path class="st664" d="M559.9,495.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.5,559.9,495.4,559.9,495.4"/>
            <path class="st663" d="M559.9,495.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.6,559.9,495.6,559.9,495.5"/>
            <path class="st662"
                  d="M559.9,495.6l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.6C559.9,495.7,559.9,495.7,559.9,495.6"/>
            <path class="st661"
                  d="M559.9,495.7l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.7C559.9,495.8,559.9,495.7,559.9,495.7"/>
            <path class="st660"
                  d="M559.9,495.8l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.8C559.9,495.9,559.9,495.8,559.9,495.8"/>
            <path class="st659"
                  d="M559.9,495.9l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.9C559.9,495.9,559.9,495.9,559.9,495.9"/>
            <path class="st658" d="M559.9,496l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496C559.9,496,559.9,496,559.9,496"/>
            <path class="st657"
                  d="M559.9,496.1l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.1C559.9,496.1,559.9,496.1,559.9,496.1"/>
            <path class="st656"
                  d="M559.9,496.1l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.1C559.9,496.2,559.9,496.2,559.9,496.1"/>
            <path class="st655"
                  d="M559.9,496.2l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.2C559.9,496.3,559.9,496.2,559.9,496.2"/>
            <path class="st654"
                  d="M559.9,496.3l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.3C559.9,496.4,559.9,496.3,559.9,496.3"/>
            <path class="st653"
                  d="M559.9,496.4l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.4C559.9,496.5,559.9,496.4,559.9,496.4"/>
            <path class="st652" d="M559.9,496.5l5.3-1.8c0,0,0,0,0,0.1c0,0,0,0,0,0L559.9,496.5C559.9,496.6,559.9,496.6,559.9,496.5
							C559.9,496.5,559.9,496.5,559.9,496.5"/>
            <path class="st651"
                  d="M559.9,496.6l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.6C559.8,496.6,559.9,496.6,559.9,496.6"/>
            <path class="st650"
                  d="M559.8,496.7l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.7C559.8,496.7,559.8,496.7,559.8,496.7"/>
            <path class="st649"
                  d="M559.8,496.8l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.8C559.8,496.8,559.8,496.8,559.8,496.8"/>
            <path class="st648"
                  d="M559.8,496.8l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.8C559.7,496.9,559.8,496.9,559.8,496.8"/>
            <path class="st647" d="M559.7,496.9l5.3-1.8c0,0,0,0.1,0,0.1L559.7,496.9C559.7,497,559.7,497,559.7,496.9"/>
            <path class="st646" d="M559.7,497l5.3-1.8c0,0,0,0.1-0.1,0.1L559.7,497C559.7,497.1,559.7,497,559.7,497"/>
            <path class="st645"
                  d="M559.6,497.1l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C559.6,497.2,559.6,497.1,559.6,497.1"/>
            <path class="st644"
                  d="M559.5,497.2l5.3-1.8c-0.1,0.2-0.3,0.3-0.5,0.4l-5.3,1.8C559.2,497.5,559.4,497.4,559.5,497.2"/>
					</g>
				</g>
        <g>
					<polygon class="st674" points="565.2,499.7 570.5,498 570.4,500.1 565.1,501.9 					"/>
				</g>
        <g>
					<polygon class="st674" points="565.2,497.7 570.5,495.9 570.5,498 565.2,499.7 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000002369324235466255060000014154721740621522855_" class="st417" d="M547.6,465.3l5.3-1.8
							c0.3-0.1,0.6-0.2,0.9-0.3c1.6-0.4,3.2-0.2,5,0.3c1.8,0.6,3.5,1.6,5.1,3.1c1.6,1.5,2.9,3.2,4.1,5.2l-5.3,1.8
							c-1.1-2-2.5-3.7-4.1-5.2c-1.6-1.5-3.3-2.5-5.1-3.1c-1.7-0.6-3.4-0.7-5-0.3C548.2,465.2,547.9,465.2,547.6,465.3z"/>
					</defs>
          <clipPath id="SVGID_00000010991601335330899570000012515327831327792302_">
						<use xlink:href="#SVGID_00000002369324235466255060000014154721740621522855_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000010991601335330899570000012515327831327792302_);enable-background:new    ;">
						<path class="st644" d="M547.6,465.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C547.6,465.3,547.6,465.3,547.6,465.3"/>
            <path class="st645" d="M547.7,465.3l5.3-1.8c0.3-0.1,0.5-0.2,0.8-0.2c0.1,0,0.2,0,0.3-0.1l-5.3,1.8c-0.1,0-0.2,0-0.3,0.1
							C548.2,465.2,547.9,465.2,547.7,465.3"/>
            <path class="st646" d="M548.8,465l5.3-1.8c0.3,0,0.5-0.1,0.8-0.1l-5.3,1.8C549.3,464.9,549,465,548.8,465"/>
            <path class="st647" d="M549.6,464.9l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C550,464.9,549.8,464.9,549.6,464.9"/>
            <path class="st648"
                  d="M550.3,464.9l5.3-1.8c0.2,0,0.4,0,0.6,0l-5.3,1.8C550.7,464.9,550.5,464.9,550.3,464.9"/>
            <path class="st649"
                  d="M550.9,464.9l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C551.3,464.9,551.1,464.9,550.9,464.9"/>
            <path class="st650" d="M551.5,465l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C551.9,465,551.7,465,551.5,465"/>
            <path class="st651"
                  d="M552.1,465.1l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C552.5,465.2,552.3,465.1,552.1,465.1"/>
            <path class="st652"
                  d="M552.7,465.2l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C553.1,465.3,552.9,465.3,552.7,465.2"/>
            <path class="st653" d="M553.3,465.4l5.3-1.8c0,0,0.1,0,0.1,0c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8c-0.2-0.1-0.3-0.1-0.5-0.2
							C553.4,465.4,553.4,465.4,553.3,465.4"/>
            <path class="st654"
                  d="M553.9,465.6l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C554.3,465.7,554.1,465.6,553.9,465.6"/>
            <path class="st655"
                  d="M554.5,465.8l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2L555,466C554.8,466,554.7,465.9,554.5,465.8"/>
            <path class="st656" d="M555,466l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C555.4,466.2,555.2,466.1,555,466"/>
            <path class="st657"
                  d="M555.5,466.3l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C555.9,466.5,555.7,466.4,555.5,466.3"/>
            <path class="st658"
                  d="M556,466.6l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C556.4,466.8,556.2,466.7,556,466.6"/>
            <path class="st659"
                  d="M556.5,466.9l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.4l-5.3,1.8C556.9,467.2,556.7,467,556.5,466.9"/>
            <path class="st660"
                  d="M557.1,467.3l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C557.4,467.5,557.2,467.4,557.1,467.3"/>
            <path class="st661"
                  d="M557.6,467.7l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.5l-5.3,1.8C558,468,557.8,467.8,557.6,467.7"/>
            <path class="st662" d="M558.1,468.1l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.4c0.1,0,0.1,0.1,0.2,0.1l-5.3,1.8c-0.1,0-0.1-0.1-0.2-0.1
							C558.4,468.4,558.3,468.3,558.1,468.1"/>
            <path class="st663"
                  d="M558.7,468.7l5.3-1.8c0.2,0.2,0.5,0.5,0.7,0.7l-5.3,1.8C559.2,469.1,558.9,468.9,558.7,468.7"/>
            <path class="st664"
                  d="M559.4,469.4l5.3-1.8c0.3,0.3,0.5,0.6,0.8,0.8l-5.3,1.8C559.9,469.9,559.7,469.6,559.4,469.4"/>
            <path class="st665"
                  d="M560.2,470.2l5.3-1.8c0.3,0.3,0.6,0.7,0.8,1l-5.3,1.8C560.7,470.9,560.5,470.5,560.2,470.2"/>
            <path class="st666"
                  d="M561,471.2l5.3-1.8c0.3,0.5,0.7,0.9,1,1.4l-5.3,1.8C561.7,472.2,561.4,471.7,561,471.2"/>
            <path class="st667" d="M562,472.7l5.3-1.8c0.2,0.3,0.4,0.7,0.6,1l-5.3,1.8C562.4,473.3,562.2,473,562,472.7"/>
					</g>
				</g>
        <g>
					<polygon class="st674" points="566,472.5 571.3,470.7 570.5,495.9 565.2,497.7 					"/>
				</g>
        <g>
					<polygon class="st674" points="566,471.7 571.3,469.9 571.3,470.7 566,472.5 					"/>
				</g>
        <g>
					<polygon class="st655" points="562.8,467.3 568.1,465.5 571.4,466.6 566.1,468.3 					"/>
				</g>
        <g>
					<polygon class="st674" points="566.1,468.3 571.4,466.6 571.3,469.9 566,471.7 					"/>
				</g>
        <g>
					<path class="st671" d="M566.1,468.3l-0.1,3.4l0,0.8l-0.7,25.2l-0.1,2.1l-0.1,2.1l-3.3-1.1l0.1-2.1l0.1-2.1l0.3-12
						c0-1.7-0.2-3.3-0.6-4.9c-0.5-1.6-1.1-3.1-1.9-4.4c-0.8-1.3-1.8-2.5-2.9-3.5c-1.1-1-2.3-1.7-3.6-2.1c-1.3-0.4-2.5-0.5-3.7-0.2
						c-1.1,0.3-2.2,0.8-3,1.6c-0.9,0.8-1.6,1.8-2.1,3.1c-0.5,1.3-0.8,2.8-0.9,4.4s0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4
						c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.7,0.6,3.4,0.5,4.8-0.1c0.3-0.1,0.6-0.2,0.9-0.1c0.1,0,0.3,0.1,0.4,0.2
						c0.4,0.3,0.8,0.7,1,1.3c0.3,0.6,0.3,1.1,0.2,1.7c-0.1,0.5-0.4,0.9-0.8,1c-2,0.9-4.2,0.9-6.6,0.2c-1.7-0.6-3.4-1.5-4.9-2.9
						c-1.5-1.3-2.8-2.9-3.9-4.8c-1.1-1.8-1.9-3.8-2.5-6c-0.6-2.2-0.9-4.4-0.8-6.6c0.1-2.2,0.5-4.2,1.2-6c0.7-1.8,1.7-3.2,2.9-4.3
						c1.2-1.1,2.6-1.8,4.1-2.2c1.6-0.4,3.2-0.2,5,0.3c1.8,0.6,3.5,1.6,5.1,3.1c1.6,1.5,2.9,3.2,4.1,5.2l0.1-2.2l0-0.8l0.1-3.4
						L566.1,468.3z"/>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000002354942247218208750000000503410145361130390_" class="st417" d="M587.8,505.5l-5.3,1.8
							c0.1,0,0.3-0.1,0.4-0.2l5.3-1.8C588.1,505.4,587.9,505.5,587.8,505.5z"/>
					</defs>
          <clipPath id="SVGID_00000150099889067352153020000009778269164117629066_">
						<use xlink:href="#SVGID_00000002354942247218208750000000503410145361130390_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000150099889067352153020000009778269164117629066_);enable-background:new    ;">
						<path class="st644"
                  d="M582.9,507l5.3-1.8c-0.1,0.1-0.3,0.2-0.4,0.2l-5.3,1.8C582.7,507.2,582.8,507.1,582.9,507"/>
					</g>
				</g>
        <g>
					<polygon class="st674" points="579.7,497 585,495.2 584.9,497.5 579.7,499.2 					"/>
				</g>
        <g>
					<polygon class="st655" points="576.3,495.9 581.6,494.1 585,495.2 579.7,497 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000168099220707274926710000010670436460649875877_" class="st417" d="M579.7,499.2l5.3-1.8
							c0,0.8,0.2,1.6,0.6,2.3s1,1.2,1.6,1.4c0.5,0.1,0.9,0.5,1.2,1l-5.3,1.8c-0.3-0.6-0.7-0.9-1.2-1c-0.6-0.2-1.2-0.7-1.6-1.4
							S579.6,500.1,579.7,499.2z"/>
					</defs>
          <clipPath id="SVGID_00000005265855133241219400000006682045101463137725_">
						<use xlink:href="#SVGID_00000168099220707274926710000010670436460649875877_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000005265855133241219400000006682045101463137725_);enable-background:new    ;">
						<path class="st658" d="M579.7,499.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C579.7,499.3,579.7,499.3,579.7,499.2"/>
            <path class="st659"
                  d="M579.7,499.4l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.5,579.7,499.4,579.7,499.4"/>
            <path class="st660"
                  d="M579.7,499.5l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.6,579.7,499.6,579.7,499.5"/>
            <path class="st661"
                  d="M579.7,499.7l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.8,579.7,499.7,579.7,499.7"/>
            <path class="st662"
                  d="M579.7,499.8l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.9,579.7,499.9,579.7,499.8"/>
            <path class="st663" d="M579.7,500l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,500.1,579.7,500,579.7,500"/>
            <path class="st664"
                  d="M579.7,500.1l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,500.3,579.7,500.2,579.7,500.1"/>
            <path class="st665"
                  d="M579.8,500.3l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C579.8,500.4,579.8,500.4,579.8,500.3"/>
            <path class="st666"
                  d="M579.8,500.5l5.3-1.8c0,0.1,0.1,0.2,0.1,0.2l-5.3,1.8C579.9,500.7,579.8,500.6,579.8,500.5"/>
            <path class="st667" d="M579.9,500.8l5.3-1.8c0.1,0.3,0.2,0.5,0.4,0.8c0,0,0,0.1,0.1,0.1l-5.3,1.8c0,0,0-0.1-0.1-0.1
							C580.1,501.3,580,501,579.9,500.8"/>
            <path class="st666"
                  d="M580.3,501.6l5.3-1.8c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8C580.4,501.8,580.4,501.7,580.3,501.6"/>
            <path class="st665"
                  d="M580.5,501.9l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C580.6,502,580.5,501.9,580.5,501.9"/>
            <path class="st664" d="M580.6,502l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.7,502.1,580.7,502.1,580.6,502"/>
            <path class="st663"
                  d="M580.7,502.2l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.8,502.2,580.8,502.2,580.7,502.2"/>
            <path class="st662"
                  d="M580.8,502.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.9,502.3,580.9,502.3,580.8,502.3"/>
            <path class="st661" d="M581,502.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1L581,502.4C581,502.4,581,502.4,581,502.4"/>
            <path class="st660" d="M581,502.5l5.3-1.8c0,0,0.1,0,0.1,0.1L581,502.5C581.1,502.5,581.1,502.5,581,502.5"/>
            <path class="st659"
                  d="M581.1,502.5l5.3-1.8c0,0,0.1,0,0.1,0.1L581.1,502.5C581.2,502.6,581.2,502.5,581.1,502.5"/>
            <path class="st658"
                  d="M581.2,502.6l5.3-1.8c0,0,0.1,0,0.1,0.1L581.2,502.6C581.3,502.6,581.3,502.6,581.2,502.6"/>
            <path class="st657"
                  d="M581.3,502.7l5.3-1.8c0,0,0.1,0,0.1,0.1L581.3,502.7C581.4,502.7,581.4,502.7,581.3,502.7"/>
            <path class="st656"
                  d="M581.4,502.7l5.3-1.8c0,0,0.1,0,0.1,0.1l-5.3,1.8C581.5,502.7,581.5,502.7,581.4,502.7"/>
            <path class="st655" d="M581.5,502.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C581.6,502.8,581.6,502.8,581.5,502.8"/>
            <path class="st654" d="M581.6,502.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C581.7,502.8,581.7,502.8,581.6,502.8"/>
            <path class="st653" d="M581.8,502.9l5.3-1.8c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l-5.3,1.8C581.9,502.9,581.9,502.9,581.8,502.9
							C581.8,502.9,581.8,502.9,581.8,502.9"/>
            <path class="st654" d="M581.9,502.9l5.3-1.8c0,0,0.1,0,0.1,0L581.9,502.9C582,502.9,581.9,502.9,581.9,502.9"/>
            <path class="st655" d="M582,502.9l5.3-1.8c0,0,0,0,0.1,0L582,502.9C582,503,582,503,582,502.9"/>
            <path class="st656" d="M582.1,503l5.3-1.8c0,0,0,0,0.1,0L582.1,503C582.1,503,582.1,503,582.1,503"/>
            <path class="st657" d="M582.1,503l5.3-1.8c0,0,0,0,0.1,0L582.1,503C582.2,503,582.2,503,582.1,503"/>
            <path class="st658" d="M582.2,503l5.3-1.8c0,0,0,0,0.1,0L582.2,503C582.3,503.1,582.2,503.1,582.2,503"/>
            <path class="st659" d="M582.3,503.1l5.3-1.8c0,0,0,0,0.1,0L582.3,503.1C582.3,503.1,582.3,503.1,582.3,503.1"/>
            <path class="st660"
                  d="M582.3,503.1l5.3-1.8c0,0,0,0,0.1,0.1L582.3,503.1C582.4,503.2,582.4,503.2,582.3,503.1"/>
            <path class="st661"
                  d="M582.4,503.2l5.3-1.8c0,0,0,0,0.1,0.1L582.4,503.2C582.5,503.2,582.4,503.2,582.4,503.2"/>
            <path class="st662"
                  d="M582.5,503.2l5.3-1.8c0,0,0,0,0.1,0.1L582.5,503.2C582.5,503.3,582.5,503.3,582.5,503.2"/>
            <path class="st663"
                  d="M582.6,503.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1L582.6,503.3C582.6,503.4,582.6,503.3,582.6,503.3"/>
            <path class="st664"
                  d="M582.6,503.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1L582.6,503.4C582.7,503.5,582.7,503.4,582.6,503.4"/>
            <path class="st665"
                  d="M582.7,503.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C582.8,503.6,582.8,503.5,582.7,503.5"/>
            <path class="st666"
                  d="M582.8,503.6l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C582.9,503.8,582.9,503.7,582.8,503.6"/>
            <path class="st667" d="M583,503.8l5.3-1.8c0,0,0,0.1,0.1,0.1l-5.3,1.8C583,503.9,583,503.9,583,503.8"/>
					</g>
				</g>
        <g>
					<path class="st671" d="M579.7,497l-0.1,2.2c0,0.8,0.2,1.6,0.6,2.3s1,1.2,1.6,1.4c0.5,0.1,0.9,0.5,1.2,1
						c0.3,0.5,0.5,1.1,0.5,1.7c0,0.6-0.2,1.1-0.6,1.4c-0.4,0.3-0.8,0.4-1.2,0.2c-1.6-0.5-2.9-1.7-4-3.4c-1-1.7-1.5-3.5-1.5-5.4
						l0.1-2.5L579.7,497z"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000008838716792707577020000006731609015933970323_" class="st417" d="M583,503.9l5.3-1.8
							c0.3,0.5,0.5,1.1,0.5,1.7c0,0.6-0.2,1.1-0.6,1.4l-5.3,1.8c0.4-0.3,0.5-0.8,0.6-1.4C583.5,505,583.4,504.5,583,503.9z"/>
					</defs>
          <clipPath id="SVGID_00000145026283879352087750000003303715176152285591_">
						<use xlink:href="#SVGID_00000008838716792707577020000006731609015933970323_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000145026283879352087750000003303715176152285591_);enable-background:new    ;">
						<path class="st667"
                  d="M583,503.9l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C583.3,504.3,583.2,504.1,583,503.9"/>
            <path class="st666"
                  d="M583.3,504.6l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C583.4,504.7,583.4,504.6,583.3,504.6"/>
            <path class="st665" d="M583.4,504.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.4,504.8,583.4,504.8,583.4,504.7"/>
            <path class="st664" d="M583.4,504.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.4,505,583.4,504.9,583.4,504.9"/>
            <path class="st663" d="M583.5,505l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.1,583.5,505,583.5,505"/>
            <path class="st662" d="M583.5,505.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.2,583.5,505.2,583.5,505.1"/>
            <path class="st661" d="M583.5,505.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.3,583.5,505.3,583.5,505.2"/>
            <path class="st660" d="M583.5,505.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.4,583.5,505.4,583.5,505.3"/>
            <path class="st659" d="M583.5,505.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.5,583.5,505.5,583.5,505.4"/>
            <path class="st658" d="M583.5,505.5l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0l-5.3,1.8C583.5,505.6,583.5,505.6,583.5,505.5
							C583.5,505.6,583.5,505.6,583.5,505.5"/>
            <path class="st657" d="M583.5,505.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.7,583.5,505.7,583.5,505.6"/>
            <path class="st656" d="M583.5,505.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.8,583.5,505.8,583.5,505.7"/>
            <path class="st655"
                  d="M583.5,505.9l5.3-1.8c0,0,0,0.1,0,0.1L583.5,505.9C583.5,505.9,583.5,505.9,583.5,505.9"/>
            <path class="st654" d="M583.5,505.9l5.3-1.8c0,0,0,0.1,0,0.1L583.5,505.9C583.5,506,583.5,506,583.5,505.9"/>
            <path class="st653" d="M583.5,506l5.3-1.8c0,0,0,0.1,0,0.1L583.5,506C583.5,506.1,583.5,506.1,583.5,506"/>
            <path class="st652"
                  d="M583.4,506.1l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.1C583.4,506.2,583.4,506.2,583.4,506.1"/>
            <path class="st651"
                  d="M583.4,506.2l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.2C583.4,506.3,583.4,506.2,583.4,506.2"/>
            <path class="st650"
                  d="M583.4,506.3l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.3C583.4,506.4,583.4,506.3,583.4,506.3"/>
            <path class="st649"
                  d="M583.4,506.4l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.4C583.4,506.4,583.4,506.4,583.4,506.4"/>
            <path class="st648"
                  d="M583.3,506.5l5.3-1.8c0,0,0,0.1,0,0.1L583.3,506.5C583.3,506.5,583.3,506.5,583.3,506.5"/>
            <path class="st647"
                  d="M583.3,506.5l5.3-1.8c0,0,0,0.1,0,0.1L583.3,506.5C583.3,506.6,583.3,506.6,583.3,506.5"/>
            <path class="st646"
                  d="M583.3,506.6l5.3-1.8c0,0,0,0.1-0.1,0.1L583.3,506.6C583.2,506.7,583.2,506.7,583.3,506.6"/>
            <path class="st645"
                  d="M583.2,506.7l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C583.1,506.8,583.2,506.8,583.2,506.7"/>
            <path class="st644"
                  d="M583.1,506.9l5.3-1.8c-0.1,0.1-0.1,0.1-0.2,0.2l-5.3,1.8C583,507,583.1,506.9,583.1,506.9"/>
					</g>
				</g>
			</g>
      <g class="st417">
				<g>
					<polygon class="st674" points="579.9,491.8 585.1,490 585.1,493.3 579.8,495.1 					"/>
				</g>
        <g>
					<polygon class="st674" points="579.9,490.9 585.2,489.1 585.1,490 579.9,491.8 					"/>
				</g>
        <g>
					<polygon class="st674" points="580.8,459.8 586.1,458.1 585.2,489.1 579.9,490.9 					"/>
				</g>
        <g>
					<polygon class="st674" points="580.8,457.8 586.1,456.1 586.1,458.1 580.8,459.8 					"/>
				</g>
        <g>
					<polygon class="st671" points="580.9,455.7 580.8,457.8 580.8,459.8 579.9,490.9 579.9,491.8 579.8,495.1 576.4,494
						576.4,490.7 576.5,489.8 577.4,458.7 577.4,456.7 577.5,454.5 					"/>
				</g>
        <g>
					<polygon class="st674" points="580.9,455.7 586.2,453.9 586.1,456.1 580.8,457.8 					"/>
				</g>
        <g>
					<polygon class="st655" points="577.5,454.5 582.8,452.8 586.2,453.9 580.9,455.7 					"/>
				</g>
			</g>
      <g class="st417">
				<g class="st417">
					<defs>
						<path id="SVGID_00000113328961384275997610000004466838121637650566_" class="st417" d="M513,457.9l5.3-1.8
							c-0.1,0-0.2,0.1-0.2,0.1c-1.4,0.5-2.6,1.5-3.5,2.9c-0.7,1.1-1.2,2.5-1.5,4.1c0,0.3-0.1,0.6-0.1,0.9c0,0.3-0.1,0.6-0.1,1
							c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.4,0.5,2.8,0.5,4.2,0.1
							c0.1,0,0.1,0,0.2-0.1l-5.3,1.8c-0.1,0-0.1,0-0.2,0.1c-1.3,0.4-2.7,0.4-4.2-0.1c-1.3-0.4-2.5-1.1-3.6-2.1
							c-1.1-1-2.1-2.2-2.9-3.5c-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.1-0.9
							c0.3-1.6,0.8-2.9,1.5-4.1c0.9-1.4,2.1-2.4,3.5-2.9C512.8,458,512.9,457.9,513,457.9z"/>
					</defs>
          <clipPath id="SVGID_00000128445405116303302950000011194566396625565600_">
						<use xlink:href="#SVGID_00000113328961384275997610000004466838121637650566_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000128445405116303302950000011194566396625565600_);enable-background:new    ;">
						<path class="st644" d="M513,457.9l5.3-1.8c-0.1,0-0.2,0.1-0.2,0.1c-1.1,0.4-2,1.1-2.8,2.1l-5.3,1.8c0.8-1,1.7-1.6,2.8-2.1
							C512.8,458,512.9,457.9,513,457.9"/>
            <path class="st645"
                  d="M509.9,460.1l5.3-1.8c-0.2,0.2-0.4,0.5-0.5,0.7l-5.3,1.8C509.5,460.5,509.7,460.3,509.9,460.1"/>
            <path class="st646" d="M509.4,460.8l5.3-1.8c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4l-5.3,1.8c0.1-0.1,0.2-0.3,0.2-0.4
							C509.3,460.9,509.3,460.8,509.4,460.8"/>
            <path class="st647"
                  d="M509,461.3l5.3-1.8c-0.1,0.2-0.2,0.4-0.3,0.6l-5.3,1.8C508.8,461.7,508.9,461.5,509,461.3"/>
            <path class="st648"
                  d="M508.7,461.9l5.3-1.8c-0.1,0.2-0.2,0.3-0.2,0.5l-5.3,1.8C508.6,462.2,508.6,462.1,508.7,461.9"/>
            <path class="st649"
                  d="M508.5,462.4l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C508.4,462.7,508.4,462.6,508.5,462.4"/>
            <path class="st650"
                  d="M508.3,462.9l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C508.2,463.3,508.2,463.1,508.3,462.9"/>
            <path class="st651"
                  d="M508.1,463.4l5.3-1.8c-0.1,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C508,463.8,508.1,463.6,508.1,463.4"/>
            <path class="st652" d="M508,463.9l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C507.9,464.3,508,464.1,508,463.9"/>
            <path class="st653"
                  d="M507.9,464.4l5.3-1.8c0,0.2-0.1,0.4-0.1,0.5l-5.3,1.8C507.8,464.8,507.8,464.6,507.9,464.4"/>
            <path class="st654" d="M507.8,465l5.3-1.8c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3l-5.3,1.8C507.7,465.2,507.7,465.1,507.8,465
							C507.8,465,507.8,465,507.8,465"/>
            <path class="st655"
                  d="M507.7,465.3l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C507.7,465.6,507.7,465.5,507.7,465.3"/>
            <path class="st656" d="M507.7,465.8l5.3-1.8c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.5l-5.3,1.8c0-0.2,0-0.3,0-0.5
							C507.7,465.9,507.7,465.8,507.7,465.8"/>
            <path class="st657"
                  d="M507.6,466.4l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C507.6,466.7,507.6,466.5,507.6,466.4"/>
            <path class="st658" d="M507.6,466.8l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.3,0,0.5l-5.3,1.8C507.6,467.2,507.6,467.1,507.6,466.8
							C507.6,466.9,507.6,466.9,507.6,466.8"/>
            <path class="st659"
                  d="M507.6,467.4l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C507.6,467.8,507.6,467.6,507.6,467.4"/>
            <path class="st660" d="M507.6,468l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C507.6,468.3,507.6,468.1,507.6,468"/>
            <path class="st661"
                  d="M507.6,468.5l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C507.7,468.9,507.6,468.7,507.6,468.5"/>
            <path class="st662"
                  d="M507.7,469.1l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C507.7,469.5,507.7,469.3,507.7,469.1"/>
            <path class="st663"
                  d="M507.8,469.7l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C507.8,470.1,507.8,469.9,507.8,469.7"/>
            <path class="st664"
                  d="M507.9,470.3l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7L508,471C508,470.8,507.9,470.6,507.9,470.3"/>
            <path class="st665" d="M508,471l5.3-1.8c0.1,0.2,0.1,0.5,0.2,0.7c0,0,0,0.1,0,0.1l-5.3,1.8c0,0,0-0.1,0-0.1
							C508.1,471.5,508.1,471.3,508,471"/>
            <path class="st666"
                  d="M508.2,471.8l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C508.5,472.7,508.3,472.2,508.2,471.8"/>
            <path class="st667" d="M508.6,473l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.1c0.1,0.1,0.2,0.3,0.2,0.4l-5.3,1.8
							c-0.1-0.1-0.2-0.3-0.2-0.4C509.5,475.2,509,474.2,508.6,473"/>
            <path class="st666"
                  d="M510.3,476.6l5.3-1.8c0.2,0.4,0.5,0.7,0.7,1l-5.3,1.8C510.8,477.2,510.5,476.9,510.3,476.6"/>
            <path class="st665"
                  d="M511,477.6l5.3-1.8c0.2,0.2,0.4,0.5,0.6,0.7l-5.3,1.8C511.4,478.1,511.2,477.8,511,477.6"/>
            <path class="st664"
                  d="M511.6,478.3l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C512,478.7,511.8,478.5,511.6,478.3"/>
            <path class="st663"
                  d="M512.1,478.9l5.3-1.8c0.2,0.2,0.3,0.3,0.5,0.5l-5.3,1.8C512.5,479.2,512.3,479.1,512.1,478.9"/>
            <path class="st662" d="M512.7,479.4l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l-5.3,1.8
							c-0.1-0.1-0.1-0.1-0.2-0.2C512.9,479.6,512.8,479.5,512.7,479.4"/>
            <path class="st661"
                  d="M513.1,479.8l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C513.4,480.1,513.3,480,513.1,479.8"/>
            <path class="st660"
                  d="M513.5,480.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C513.8,480.4,513.6,480.3,513.5,480.2"/>
            <path class="st659"
                  d="M513.9,480.5l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C514.1,480.6,514,480.5,513.9,480.5"/>
            <path class="st658"
                  d="M514.3,480.7l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C514.5,480.9,514.4,480.8,514.3,480.7"/>
            <path class="st657"
                  d="M514.6,480.9l5.3-1.8c0.1,0.1,0.2,0.1,0.4,0.2l-5.3,1.8C514.9,481.1,514.8,481,514.6,480.9"/>
            <path class="st656"
                  d="M515,481.2l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C515.3,481.3,515.1,481.2,515,481.2"/>
            <path class="st655"
                  d="M515.4,481.3l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C515.6,481.5,515.5,481.4,515.4,481.3"/>
            <path class="st654"
                  d="M515.8,481.5l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C516.1,481.6,515.9,481.6,515.8,481.5"/>
            <path class="st653" d="M516.2,481.7l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0
							C516.4,481.8,516.3,481.7,516.2,481.7"/>
            <path class="st652"
                  d="M516.6,481.8l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1L517,482C516.9,481.9,516.8,481.9,516.6,481.8"/>
            <path class="st651" d="M517,482l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C517.3,482,517.2,482,517,482"/>
            <path class="st650"
                  d="M517.5,482.1l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C517.8,482.1,517.6,482.1,517.5,482.1"/>
            <path class="st649"
                  d="M517.9,482.1l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C518.2,482.2,518.1,482.1,517.9,482.1"/>
            <path class="st648"
                  d="M518.4,482.2l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C518.7,482.2,518.5,482.2,518.4,482.2"/>
            <path class="st647" d="M518.9,482.2l5.3-1.8c0.2,0,0.4,0,0.5,0l-5.3,1.8C519.2,482.2,519,482.2,518.9,482.2"/>
            <path class="st646"
                  d="M519.4,482.2l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C519.8,482.1,519.6,482.1,519.4,482.2"/>
            <path class="st645" d="M520,482.1l5.3-1.8c0.2,0,0.5-0.1,0.7-0.2c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0
							C520.5,482,520.3,482,520,482.1"/>
            <path class="st644"
                  d="M520.8,481.9l5.3-1.8c0,0,0.1,0,0.1,0L520.8,481.9C520.9,481.9,520.9,481.9,520.8,481.9"/>
					</g>
				</g>
        <g>
					<polygon class="st655" points="510.4,463.3 515.7,461.5 517.3,462 512.1,463.8 					"/>
				</g>
        <g>
					<polygon class="st655" points="512.1,463.8 517.3,462 517.7,462.2 512.4,463.9 					"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000139291023086495528140000017100630031508840872_" class="st417" d="M511.4,453.7l5.3-1.8
							c1.9-0.6,3.8-0.6,5.9,0.1l-5.3,1.8C515.3,453.1,513.3,453.1,511.4,453.7z"/>
					</defs>
          <clipPath id="SVGID_00000020359518521689053870000002437204660727012747_">
						<use xlink:href="#SVGID_00000139291023086495528140000017100630031508840872_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000020359518521689053870000002437204660727012747_);enable-background:new    ;">
						<path class="st644" d="M511.4,453.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C511.5,453.7,511.5,453.7,511.4,453.7"/>
            <path class="st645"
                  d="M511.6,453.6l5.3-1.8c0.3-0.1,0.7-0.2,1-0.3l-5.3,1.8C512.2,453.4,511.9,453.5,511.6,453.6"/>
            <path class="st646"
                  d="M512.6,453.4l5.3-1.8c0.3-0.1,0.5-0.1,0.8-0.1l-5.3,1.8C513.1,453.3,512.9,453.3,512.6,453.4"/>
            <path class="st647"
                  d="M513.4,453.3l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C513.9,453.2,513.7,453.2,513.4,453.3"/>
            <path class="st648"
                  d="M514.1,453.2l5.3-1.8c0.2,0,0.4,0,0.7,0l-5.3,1.8C514.6,453.2,514.4,453.2,514.1,453.2"/>
            <path class="st649"
                  d="M514.8,453.3l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C515.2,453.3,515,453.3,514.8,453.3"/>
            <path class="st650"
                  d="M515.4,453.3l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C515.8,453.4,515.6,453.3,515.4,453.3"/>
            <path class="st651"
                  d="M516,453.4l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C516.4,453.5,516.2,453.5,516,453.4"/>
            <path class="st652"
                  d="M516.6,453.6l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C517,453.7,516.8,453.6,516.6,453.6"/>
            <path class="st653" d="M517.2,453.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C517.3,453.8,517.3,453.7,517.2,453.7"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000042725338237357358330000006146199930772278955_" class="st417" d="M525.9,476.8l5.3-1.8
							c0.1,0,0.2,0,0.2-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.5,0.2,0.7,0.4l-5.3,1.8c-0.2-0.2-0.5-0.4-0.7-0.4
							c-0.2-0.1-0.4-0.1-0.6-0.1C526.1,476.8,526,476.8,525.9,476.8z"/>
					</defs>
          <clipPath id="SVGID_00000092447991781220480970000003420026174827265936_">
						<use xlink:href="#SVGID_00000042725338237357358330000006146199930772278955_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000092447991781220480970000003420026174827265936_);enable-background:new    ;">
						<path class="st644" d="M525.9,476.8l5.3-1.8c0,0,0,0,0,0L525.9,476.8C525.9,476.8,525.9,476.8,525.9,476.8"/>
            <path class="st645" d="M525.9,476.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C526,476.8,526,476.8,525.9,476.8"/>
            <path class="st646" d="M526.1,476.8l5.3-1.8c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l-5.3,1.8C526.2,476.8,526.2,476.8,526.1,476.8
							C526.1,476.8,526.1,476.8,526.1,476.8"/>
            <path class="st647" d="M526.2,476.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C526.3,476.8,526.2,476.8,526.2,476.8"/>
            <path class="st648"
                  d="M526.3,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.3,476.8C526.4,476.8,526.4,476.8,526.3,476.8"/>
            <path class="st649"
                  d="M526.4,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.4,476.8C526.5,476.8,526.4,476.8,526.4,476.8"/>
            <path class="st650"
                  d="M526.5,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.5,476.8C526.6,476.8,526.5,476.8,526.5,476.8"/>
            <path class="st651" d="M526.6,476.8l5.3-1.8c0,0,0,0,0.1,0L526.6,476.8C526.6,476.8,526.6,476.8,526.6,476.8"/>
            <path class="st652" d="M526.7,476.8l5.3-1.8c0,0,0,0,0.1,0L526.7,476.8C526.7,476.8,526.7,476.8,526.7,476.8"/>
            <path class="st653" d="M526.7,476.8l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L526.7,476.8C526.8,476.8,526.8,476.8,526.7,476.8
							C526.7,476.8,526.7,476.8,526.7,476.8"/>
            <path class="st654" d="M526.8,476.8l5.3-1.8c0,0,0,0,0.1,0L526.8,476.8C526.8,476.9,526.8,476.9,526.8,476.8"/>
            <path class="st655" d="M526.9,476.9l5.3-1.8c0,0,0,0,0.1,0L526.9,476.9C526.9,476.9,526.9,476.9,526.9,476.9"/>
            <path class="st656" d="M526.9,476.9l5.3-1.8c0,0,0,0,0.1,0L526.9,476.9C527,476.9,527,476.9,526.9,476.9"/>
            <path class="st657" d="M527,476.9l5.3-1.8c0,0,0,0,0.1,0L527,476.9C527,477,527,477,527,476.9"/>
            <path class="st658" d="M527.1,477l5.3-1.8c0,0,0,0,0.1,0L527.1,477C527.1,477,527.1,477,527.1,477"/>
            <path class="st659" d="M527.1,477l5.3-1.8c0,0,0,0,0.1,0.1L527.1,477C527.2,477.1,527.2,477,527.1,477"/>
            <path class="st660"
                  d="M527.2,477.1l5.3-1.8c0,0,0.1,0,0.1,0.1L527.2,477.1C527.3,477.1,527.2,477.1,527.2,477.1"/>
            <path class="st661"
                  d="M527.3,477.1l5.3-1.8c0,0,0.1,0,0.1,0.1L527.3,477.1C527.3,477.2,527.3,477.2,527.3,477.1"/>
            <path class="st662"
                  d="M527.4,477.2l5.3-1.8c0,0,0,0,0.1,0.1L527.4,477.2C527.4,477.2,527.4,477.2,527.4,477.2"/>
					</g>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000111172380530580441230000011070782546736905619_" class="st417" d="M527.7,484.4l-5.3,1.8
							c1.7-0.6,3.1-1.6,4.3-3.2c0.6-0.7,1.1-1.6,1.5-2.6c0.2-0.5,0.2-1,0.1-1.6c-0.2-0.6-0.4-1.1-0.9-1.5l5.3-1.8
							c0.4,0.4,0.7,0.9,0.9,1.5c0.2,0.6,0.1,1.2-0.1,1.6c-0.5,1-1,1.9-1.5,2.6C530.8,482.8,529.3,483.8,527.7,484.4z"/>
					</defs>
          <clipPath id="SVGID_00000129187038480459213060000005934990463279750559_">
						<use xlink:href="#SVGID_00000111172380530580441230000011070782546736905619_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000129187038480459213060000005934990463279750559_);enable-background:new    ;">
						<path class="st662" d="M527.4,477.3l5.3-1.8c0,0,0,0,0,0L527.4,477.3C527.5,477.3,527.5,477.3,527.4,477.3"/>
            <path class="st663"
                  d="M527.5,477.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1L527.5,477.3C527.5,477.4,527.5,477.3,527.5,477.3"/>
            <path class="st664"
                  d="M527.6,477.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C527.6,477.5,527.6,477.4,527.6,477.4"/>
            <path class="st665"
                  d="M527.7,477.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C527.7,477.6,527.7,477.5,527.7,477.5"/>
            <path class="st666"
                  d="M527.8,477.6l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C527.9,477.7,527.8,477.7,527.8,477.6"/>
            <path class="st667"
                  d="M527.9,477.8l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C528.1,478.2,528,478,527.9,477.8"/>
            <path class="st666"
                  d="M528.2,478.4l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C528.2,478.5,528.2,478.5,528.2,478.4"/>
            <path class="st665" d="M528.3,478.6l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1
							C528.3,478.7,528.3,478.7,528.3,478.6"/>
            <path class="st664" d="M528.3,478.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.3,478.9,528.3,478.9,528.3,478.8"/>
            <path class="st663" d="M528.3,479l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479,528.3,479,528.3,479"/>
            <path class="st662" d="M528.4,479.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479.2,528.4,479.1,528.4,479.1"/>
            <path class="st661" d="M528.4,479.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479.3,528.4,479.2,528.4,479.2"/>
            <path class="st660"
                  d="M528.4,479.3l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.3C528.4,479.4,528.4,479.3,528.4,479.3"/>
            <path class="st659"
                  d="M528.4,479.4l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.4C528.4,479.5,528.4,479.4,528.4,479.4"/>
            <path class="st658"
                  d="M528.4,479.5l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.5C528.4,479.6,528.4,479.5,528.4,479.5"/>
            <path class="st657"
                  d="M528.4,479.6l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.6C528.4,479.6,528.4,479.6,528.4,479.6"/>
            <path class="st656"
                  d="M528.4,479.7l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.7C528.4,479.7,528.4,479.7,528.4,479.7"/>
            <path class="st655"
                  d="M528.4,479.7l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.7C528.4,479.8,528.4,479.8,528.4,479.7"/>
            <path class="st654"
                  d="M528.4,479.8l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.8C528.4,479.9,528.4,479.9,528.4,479.8"/>
            <path class="st653" d="M528.4,479.9l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.9C528.3,480,528.3,479.9,528.4,479.9"/>
            <path class="st652" d="M528.3,480l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480C528.3,480.1,528.3,480,528.3,480"/>
            <path class="st651"
                  d="M528.3,480.1l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.1C528.3,480.1,528.3,480.1,528.3,480.1"/>
            <path class="st650"
                  d="M528.3,480.2l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.2C528.3,480.2,528.3,480.2,528.3,480.2"/>
            <path class="st649"
                  d="M528.3,480.3l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.3C528.2,480.3,528.3,480.3,528.3,480.3"/>
            <path class="st648" d="M528.2,480.3l5.3-1.8c0,0,0,0,0,0c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8
							C528.1,480.7,528.1,480.5,528.2,480.3C528.2,480.4,528.2,480.4,528.2,480.3"/>
            <path class="st647"
                  d="M528,480.9l5.3-1.8c-0.1,0.3-0.3,0.5-0.4,0.8l-5.3,1.8C527.7,481.4,527.9,481.1,528,480.9"/>
            <path class="st646"
                  d="M527.6,481.7l5.3-1.8c-0.1,0.3-0.3,0.5-0.5,0.8l-5.3,1.8C527.3,482.2,527.4,481.9,527.6,481.7"/>
            <path class="st645" d="M527.1,482.4l5.3-1.8c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.3l-5.3,1.8
							c0.1-0.1,0.2-0.2,0.3-0.3C526.8,482.8,527,482.6,527.1,482.4"/>
            <path class="st644"
                  d="M526.4,483.3l5.3-1.8c-1.2,1.4-2.5,2.3-4,2.8l-5.3,1.8C523.9,485.6,525.3,484.7,526.4,483.3"/>
					</g>
				</g>
        <g>
					<polygon class="st655" points="512.4,463.9 517.7,462.2 530.9,466.5 525.6,468.2 					"/>
				</g>
        <g>
					<path class="st671" d="M517.4,453.8c1.6,0.5,3,1.3,4.4,2.5c1.4,1.1,2.6,2.5,3.7,4c1.1,1.5,2,3.3,2.7,5.2
						c0.7,1.9,1.2,3.9,1.3,5.9c0.1,0.6-0.1,1.1-0.3,1.5c-0.3,0.4-0.6,0.6-1.1,0.5c-1-0.3-1.8-0.6-2.6-0.8c-0.8-0.2-1.6-0.5-2.6-0.8
						c-1-0.3-1.9-0.6-2.9-1l-7.6-2.5l-2-0.6l0.1-4.4l1.7,0.5l0.4,0.1l13.2,4.3c-0.6-2.4-1.7-4.6-3.2-6.5c-1.5-1.9-3.2-3.1-5.2-3.8
						c-1.6-0.5-3.1-0.5-4.5,0c-1.4,0.5-2.6,1.5-3.5,2.9c-0.7,1.1-1.2,2.5-1.5,4.1c0,0.3-0.1,0.6-0.1,0.9c0,0.3-0.1,0.6-0.1,1
						c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.4,0.5,2.8,0.5,4.2,0.1
						c1.3-0.4,2.5-1.2,3.4-2.4c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.7,0.5-1c0.2-0.5,0.5-0.7,1-0.8c0.2,0,0.4,0,0.6,0.1
						c0.2,0.1,0.5,0.2,0.7,0.4c0.4,0.4,0.7,0.9,0.9,1.5c0.2,0.6,0.1,1.2-0.1,1.6c-0.5,1-1,1.9-1.5,2.6c-1.3,1.6-2.8,2.7-4.6,3.2
						c-1.8,0.5-3.7,0.5-5.7-0.2c-1.7-0.6-3.4-1.5-4.9-2.9c-1.5-1.3-2.8-2.9-3.9-4.8c-1.1-1.8-1.9-3.8-2.5-6
						c-0.6-2.2-0.9-4.4-0.8-6.6c0-0.9,0.1-1.7,0.2-2.6c0.2-1.1,0.4-2,0.7-3c0.3-0.9,0.7-1.7,1.2-2.5c1.2-2,2.8-3.3,4.7-4
						C513.1,453.1,515.2,453.1,517.4,453.8z"/>
				</g>
        <g class="st417">
					<defs>
						<path id="SVGID_00000057111293615324530660000013253676923883689135_" class="st417" d="M533.8,471.5l-5.3,1.8
							c0.2-0.1,0.4-0.2,0.6-0.5c0.3-0.4,0.4-0.9,0.3-1.5c-0.2-2-0.6-4-1.3-5.9c-0.7-1.9-1.6-3.6-2.7-5.2c-1.1-1.5-2.3-2.9-3.7-4
							c-1.4-1.1-2.9-1.9-4.4-2.5l5.3-1.8c1.6,0.5,3,1.3,4.4,2.5c1.4,1.1,2.6,2.5,3.7,4c1.1,1.5,2,3.3,2.7,5.2
							c0.7,1.9,1.2,3.9,1.3,5.9c0.1,0.6-0.1,1.1-0.3,1.5C534.2,471.3,534,471.4,533.8,471.5z"/>
					</defs>
          <clipPath id="SVGID_00000125595634162739010630000003208118875178097824_">
						<use xlink:href="#SVGID_00000057111293615324530660000013253676923883689135_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000125595634162739010630000003208118875178097824_);enable-background:new    ;">
						<path class="st653"
                  d="M517.4,453.8l5.3-1.8c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8C517.7,453.9,517.5,453.8,517.4,453.8"/>
            <path class="st654"
                  d="M517.8,453.9l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C518.2,454.1,518,454,517.8,453.9"/>
            <path class="st655"
                  d="M518.4,454.2l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2l-5.3,1.8C518.8,454.3,518.6,454.2,518.4,454.2"/>
            <path class="st656"
                  d="M518.9,454.4l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C519.3,454.6,519.1,454.5,518.9,454.4"/>
            <path class="st657"
                  d="M519.5,454.7l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3L520,455C519.8,454.9,519.7,454.8,519.5,454.7"/>
            <path class="st658" d="M520,455l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C520.4,455.2,520.2,455.1,520,455"/>
            <path class="st659"
                  d="M520.5,455.3l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.4l-5.3,1.8C520.9,455.6,520.7,455.4,520.5,455.3"/>
            <path class="st660"
                  d="M521.1,455.7l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C521.4,456,521.3,455.8,521.1,455.7"/>
            <path class="st661" d="M521.6,456.1l5.3-1.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.4l-5.3,1.8
							c-0.1-0.1-0.3-0.3-0.4-0.4C521.7,456.2,521.7,456.1,521.6,456.1"/>
            <path class="st662"
                  d="M522.2,456.6l5.3-1.8c0.2,0.2,0.4,0.4,0.6,0.6l-5.3,1.8C522.6,457,522.4,456.8,522.2,456.6"/>
            <path class="st663"
                  d="M522.9,457.2l5.3-1.8c0.2,0.2,0.4,0.4,0.7,0.7l-5.3,1.8C523.3,457.6,523.1,457.4,522.9,457.2"/>
            <path class="st664"
                  d="M523.5,457.8l5.3-1.8c0.2,0.2,0.5,0.5,0.7,0.8l-5.3,1.8C524,458.3,523.7,458.1,523.5,457.8"/>
            <path class="st665"
                  d="M524.2,458.6l5.3-1.8c0.3,0.3,0.5,0.6,0.8,0.9l-5.3,1.8C524.7,459.2,524.5,458.9,524.2,458.6"/>
            <path class="st666" d="M525,459.6l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.7c0.2,0.2,0.3,0.5,0.5,0.7l-5.3,1.8
							c-0.1-0.2-0.3-0.5-0.5-0.7C525.3,460,525.1,459.8,525,459.6"/>
            <path class="st667" d="M525.9,460.9l5.3-1.8c0.9,1.4,1.6,2.9,2.2,4.5c0,0.1,0.1,0.2,0.1,0.2l-5.3,1.8c0-0.1-0.1-0.2-0.1-0.2
							C527.5,463.8,526.8,462.3,525.9,460.9"/>
            <path class="st666"
                  d="M528.2,465.7l5.3-1.8c0.2,0.5,0.3,0.9,0.5,1.4l-5.3,1.8C528.5,466.6,528.4,466.1,528.2,465.7"/>
            <path class="st665"
                  d="M528.7,467.1l5.3-1.8c0.1,0.4,0.2,0.7,0.3,1.1l-5.3,1.8C528.9,467.8,528.8,467.4,528.7,467.1"/>
            <path class="st664"
                  d="M528.9,468.1l5.3-1.8c0.1,0.3,0.1,0.6,0.2,0.9l-5.3,1.8C529.1,468.8,529,468.5,528.9,468.1"/>
            <path class="st663"
                  d="M529.1,469.1l5.3-1.8c0.1,0.3,0.1,0.6,0.1,0.9l-5.3,1.8C529.3,469.7,529.2,469.4,529.1,469.1"/>
            <path class="st662"
                  d="M529.3,470l5.3-1.8c0,0.3,0.1,0.6,0.1,0.8l-5.3,1.8C529.4,470.5,529.3,470.3,529.3,470"/>
            <path class="st661" d="M529.4,470.8l5.3-1.8c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1
							C529.4,471.1,529.4,471,529.4,470.8"/>
            <path class="st660" d="M529.5,471.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C529.5,471.5,529.5,471.4,529.5,471.4"/>
            <path class="st659" d="M529.5,471.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C529.5,471.6,529.5,471.5,529.5,471.5"/>
            <path class="st658"
                  d="M529.5,471.6l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.6C529.5,471.7,529.5,471.6,529.5,471.6"/>
            <path class="st657"
                  d="M529.5,471.7l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.7C529.5,471.8,529.5,471.7,529.5,471.7"/>
            <path class="st656"
                  d="M529.5,471.8l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.8C529.5,471.9,529.5,471.8,529.5,471.8"/>
            <path class="st655"
                  d="M529.5,471.9l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.9C529.5,471.9,529.5,471.9,529.5,471.9"/>
            <path class="st654" d="M529.4,472l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472C529.4,472,529.4,472,529.4,472"/>
            <path class="st653" d="M529.4,472l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472C529.4,472.1,529.4,472.1,529.4,472"/>
            <path class="st652"
                  d="M529.4,472.1l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.1C529.4,472.2,529.4,472.2,529.4,472.1"/>
            <path class="st651"
                  d="M529.4,472.2l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.2C529.4,472.3,529.4,472.2,529.4,472.2"/>
            <path class="st650"
                  d="M529.4,472.3l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.3C529.4,472.4,529.4,472.3,529.4,472.3"/>
            <path class="st649"
                  d="M529.3,472.4l5.3-1.8c0,0,0,0.1,0,0.1L529.3,472.4C529.3,472.4,529.3,472.4,529.3,472.4"/>
            <path class="st648"
                  d="M529.3,472.5l5.3-1.8c0,0,0,0.1,0,0.1L529.3,472.5C529.3,472.5,529.3,472.5,529.3,472.5"/>
            <path class="st647"
                  d="M529.3,472.6l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C529.2,472.6,529.3,472.6,529.3,472.6"/>
            <path class="st646"
                  d="M529.2,472.7l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C529.2,472.7,529.2,472.7,529.2,472.7"/>
            <path class="st645" d="M529.1,472.8l5.3-1.8c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C529.1,472.9,529.1,472.9,529.1,472.8
							C529.1,472.8,529.1,472.8,529.1,472.8"/>
            <path class="st644"
                  d="M529,472.9l5.3-1.8c-0.1,0.2-0.3,0.3-0.5,0.4l-5.3,1.8C528.7,473.2,528.9,473.1,529,472.9"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
            <g>
	<path class="st404" d="M175.1,962.1c1.7,0.1,3.4,0.1,5.2,0.4c2.4,0.1,10.8,0.8,16,6.9c2.2,2.4,5.4,7.6,5.4,16.1
		c0,1.8-0.1,4.9-1.1,9.1c-0.9,3.4-2.7,10-9.8,15.2c-8.1,5.8-17.1,5.7-20.5,5.7c-3.3,0-6.5-0.3-9.9-0.6l-4.8-15.2
		c3.5,0.4,7.1,0.8,10.6,0.8c0.7,0,3.7,0,6.1-0.7c5.9-1.7,10.6-6.8,10.6-13c0-1-0.1-3.5-1.4-5.7c-2.4-4-6.4-4.4-15.7-4.1h-12.2
		c-0.9,15.8-1.8,31.7-2.4,47.4c-0.4,9.6-0.7,19.1-0.8,28.6H130c0.6-4.7,1.1-9.5,1.4-14.1c0.6-7.1,0.8-14.1,1.1-21.3
		c0.6-8.7,1-17.3,1.3-26c0.3-9.9,0.4-19.6,0.7-29.5L175.1,962.1L175.1,962.1z"/>
              <path class="st404" d="M588,979.9c-13-2.7-17.3-3.5-30.4-4.1c-2.1,0.1-9.1,0.3-15.3,2.7c-7.4,2.8-18.9,11.7-18.9,31.3
		c0,3.5,0.4,13.4,7.2,21.2c1.4,1.6,4.8,5.1,10.4,7.1c4.1,1.4,7.9,1.6,12.3,1.8c10-0.4,12-0.9,17.8-2.2l1-21.6h-15.2l0.8-15.4h33.9
		c-0.9,11.3-2,22.5-2.4,33.8l-0.4,17.5c-2.4,0.4-20.8,3.4-34.6,3.4c-4.1,0-6.6-0.1-14-1c-10.2-2.2-17.3-4.1-24.7-12
		c-4.3-4.5-11.3-14.1-11.3-30c0-4.7,0.7-9.1,1.3-13.6c0.4-2.1,0.9-4,1.4-6.1c0.6-1.4,0.9-2.8,1.4-4.3c2-4.5,3.1-6.6,4.4-8.7
		c8.6-13.4,21.8-16.4,26.9-17.7c3.8-0.8,9.3-2,18.7-2c6.9,0,14.1,0.6,28.1,2.2L588,979.9z"/>
              <path class="st693" d="M256.6,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7
		c-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7h-21.2c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12
		c-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6
		c-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3H207c0.9-7.4,1.5-14.8,2-22.3
		c0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L256.6,984L256.6,984z"/>
              <path class="st693" d="M306.3,983.9c-1,11.7-2,23.5-2.7,35.3c-0.7,11.2-1.3,22.6-1.9,33.8h-19.3c1.3-11.9,2.4-23.7,3.2-35.6
		c0.6-11.2,0.9-22.3,1.3-33.6L306.3,983.9z"/>
              <path class="st693" d="M385.4,996.8c-9.3-1.6-11.9-2.1-21.3-2.6c-10.9,0.3-19.9,1-26.7,8.1c-2.7,2.9-7.3,9-7.3,18.1
		c0,9.5,5.6,17.1,17.2,20.3c2.9,0.8,5.6,1.2,11.8,1.6c10.9,0,13.6-0.4,23.8-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.5,1.3
		c-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.5-0.6c-6.6-1.2-12-2.1-17.7-5.2c-9.9-5.4-13.3-12.8-14.4-15.9c-1.4-3.9-1.7-8.3-1.9-9.5
		c0-8.5,0.6-10,1.9-14.5c1.6-4.2,2.7-6.4,3.9-8.2c4.5-7.1,12.6-13.2,22.2-15.9c4.4-1.2,8-1.6,12.6-2.1c10.4-0.4,14.4-0.7,32,1.2
		L385.4,996.8z"/>
              <path class="st693" d="M459,983.7l-0.5,12.4c-7.8-0.4-15.5-0.7-23.4-0.7c-7.6,0-15.3,0.2-23,0.4l-0.7,15.7l40.5-0.3l-0.7,12.5
		c-7.2-0.2-14.4-0.5-21.5-0.5c-6.4,0-12.6,0.1-18.9,0.3l-1,17.6c8.8,0.1,17.7,0.3,26.4,0.1c6.8-0.2,13.4-0.5,20.2-0.9v12.5h-66.4
		c0.5-3.9,1-7.6,1.4-11.5c0.5-5.7,0.7-11.5,1-17.1c0.5-7.8,1-15.7,1.3-23.5c0.3-5.7,0.3-11.4,0.4-17.1L459,983.7L459,983.7z"/>
              <path class="st693" d="M625.4,983.9c-0.9,6.2-1.7,12.5-2.3,18.8c-0.7,8.3-1.3,16.7-1.6,25.1c0.1,3.9,0.5,5.4,1.6,7.2
		c4.4,7.4,16.9,7.4,19.1,7.4c3.2,0,15.8-0.1,20.3-8.4c1.3-2.4,1.5-4.9,1.6-5.7c0.6-9.8,1.4-19.7,1.7-29.4c0.1-5,0.1-10.1,0.3-15.1
		l19.5,0.1c-0.7,6.4-1.5,12.8-1.9,19.5c-0.5,5.9-0.6,12-1,17.9c-0.3,3.9-0.6,7.8-1,11.7c-0.1,0.3-1,4.1-2.1,6.4
		c-1.6,3.4-5.7,10-17.2,13c-2.4,0.7-5.6,1.2-8,1.5c-4.3,0.4-8.4,0.7-12.5,0.7c-4,0-7.9-0.3-11.9-0.7c-1.4-0.2-2.7-0.4-4.2-0.7
		c-6.2-1.1-11.2-2.9-15.5-6.6c-1.3-1.1-3.7-3.2-5.3-6.5c-1.1-2.6-1.5-6.7-1.5-7.2c0-2.6,0-5.4,0.1-8c0.4-4.7,1-9.5,1.3-14.3
		c0.6-8.9,0.6-17.8,0.9-26.8H625.4z"/>
              <path class="st693" d="M754.3,983.7c2.1,5.2,4.4,10.3,6.8,15.4c3.3,6.7,6.6,13.5,9.9,20.2c5.4,11.2,10.8,22.4,16.2,33.7h-20.8
		c-2.9-8.6-3.9-12-11.4-26.3h-33.6c-3.4,4.9-6.9,9.8-10.2,14.8c-2.4,3.7-4.6,7.6-6.8,11.5h-19.7l45.9-69.3L754.3,983.7L754.3,983.7z
		 M727.2,1015.9h23.5l-9.9-21.4L727.2,1015.9z"/>
              <path class="st693" d="M840.4,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7
		c-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7H838c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12
		c-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6
		c-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3h-19.3c0.9-7.4,1.5-14.8,2-22.3
		c0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L840.4,984L840.4,984z"/>
              <path class="st693" d="M887.1,983.7c5.5-0.1,11-0.3,16.4-0.3c5.6,0,11.2,0.2,16.7,0.4c8,1,13.4,1.9,19.3,6.4c3.9,2.9,6,6.4,6.8,7.7
		c3.9,6.9,3.7,13.3,3.5,21c-0.7,6.8-1.1,8.3-3.6,14.8c-0.4,0.8-0.7,1.6-1.3,2.4c-1.5,2.7-5.2,9-14.2,13c-3.7,1.6-6.8,2.4-14.9,3.3
		c-6.8,0.3-13.4,0.6-20.3,0.6c-3.7,0-7.6-0.1-11.4-0.1c-5.7,0-11.5,0-17.2,0.1c0.6-5.9,1.4-11.9,1.7-17.8c0.3-4.9,0.4-9.7,0.7-14.5
		c0.4-6.8,0.9-13.8,1.1-20.6c0.3-5.4,0.3-10.9,0.4-16.3h16.2L887.1,983.7L887.1,983.7z M885.9,1041.2c5.7,0,11.6,0.1,17.2-0.2
		l6.4-0.3c0.4-0.1,4-0.5,6.3-1.2c2.1-0.6,6.8-2.1,10.2-6.3c3.9-4.7,6-12.2,6-17.8c0-2.9-0.4-14.8-13.9-18.5c-3.1-0.9-5.7-1-9-1.2
		h-20.5L885.9,1041.2z"/>
</g>
</svg>
        </div>
      </template>
      <span>Price Guard</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component PriceGuardButton
 * Home button component that redirects to Price Guard page
 */
export default {
  name: 'PriceGuardButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToPriceGuardPage() {
      this.$router.push('/price-guard');
    }
  }
}
</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000160888709754594643080000014277589255412729761_);
}

.st1 {
  clip-path: url(#SVGID_00000106857659776277544540000004711865562879763377_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000003099173429567172090000017483058066361454726_);
}

.st3 {
  clip-path: url(#SVGID_00000034072361219953500810000003117787341882669708_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000107577188916218388190000015260054969031091865_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000176012588409979540630000014543245760562753684_);
}

.st7 {
  clip-path: url(#SVGID_00000157308851002828124250000005829938871760253106_);
}

.st8 {
  clip-path: url(#SVGID_00000172423931875076578030000014139324158887206313_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000029047887219055618370000004256587630522876599_);
}

.st10 {
  clip-path: url(#SVGID_00000160152811251454742710000012073944471327732355_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000082356767384776165910000012832886995502341021_);
}

.st12 {
  clip-path: url(#SVGID_00000065066208134348893740000008390854245416826507_);
}

.st13 {
  clip-path: url(#SVGID_00000016039341561234203680000013396578647152705718_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000024712456860662262170000013350019746431577224_);
}

.st15 {
  clip-path: url(#SVGID_00000033370262218324079710000004468381518466361733_);
}

.st16 {
  clip-path: url(#SVGID_00000001654247979013103790000012641064192219397263_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000174575471044024974110000012629596164556888711_);
}

.st18 {
  clip-path: url(#SVGID_00000065796110213768264110000012547909419687166360_);
}

.st19 {
  clip-path: url(#SVGID_00000052084629253687611750000010877528021676109723_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000126288875215988312070000006900493253840769720_);
}

.st21 {
  clip-path: url(#SVGID_00000005247243817582832900000013771774002573643907_);
}

.st22 {
  clip-path: url(#SVGID_00000034058969425249894860000002541374869046640291_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000096759893304229538930000015626722162482012585_);
}

.st24 {
  clip-path: url(#SVGID_00000177464248338368385710000005772902798937130902_);
}

.st25 {
  clip-path: url(#SVGID_00000010270368151543926700000007378558452006819519_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000082340219327179076590000007062364284514472602_);
}

.st27 {
  clip-path: url(#SVGID_00000124119372536089506740000003268281476740159644_);
}

.st28 {
  clip-path: url(#SVGID_00000077291682180773666480000000531648393802329238_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000101076857822930004680000013974437744843307710_);
}

.st30 {
  clip-path: url(#SVGID_00000008829783246434296990000013191975231792979077_);
}

.st31 {
  clip-path: url(#SVGID_00000047759401711330593400000006244057730689256604_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000158733615530192667070000007157286783812286118_);
}

.st33 {
  clip-path: url(#SVGID_00000142142263366493135020000012699195468062435211_);
}

.st34 {
  clip-path: url(#SVGID_00000134249907414735825500000006985193408794092734_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000062881722476156429070000006970353503367589020_);
}

.st36 {
  clip-path: url(#SVGID_00000147179984003779530690000002540882456498444209_);
}

.st37 {
  clip-path: url(#SVGID_00000024688238402312357420000016799853789571049640_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000013168965212245702670000005456495205820401582_);
}

.st39 {
  clip-path: url(#SVGID_00000071552334220447395750000013741082864932091567_);
}

.st40 {
  clip-path: url(#SVGID_00000000928901054667040370000014013999297843886764_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000084487606915802352650000017087512050637339324_);
}

.st42 {
  clip-path: url(#SVGID_00000062894931718376229800000012865021261818465930_);
}

.st43 {
  clip-path: url(#SVGID_00000113320111069442875580000003900586502623286660_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000102517344179609241910000001746995995645144221_);
}

.st45 {
  clip-path: url(#SVGID_00000026875230746612689870000009689431209461148853_);
}

.st46 {
  clip-path: url(#SVGID_00000164477143679609249980000006798734767305451166_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000167376875641018860550000005103169383619377296_);
}

.st48 {
  clip-path: url(#SVGID_00000173148054949166322310000006757101658092610737_);
}

.st49 {
  clip-path: url(#SVGID_00000151537564456865642240000002151521401552681648_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000110448655849856446680000000408191067838853509_);
}

.st51 {
  clip-path: url(#SVGID_00000150825315611519742240000009805931114125481134_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000016057616805559746510000007334750092973909926_);
}

.st53 {
  clip-path: url(#SVGID_00000067200504568427637250000016547805948750962852_);
}

.st54 {
  clip-path: url(#SVGID_00000026860883971630303330000017840098631136861348_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000130632083013783428570000001819341931128990896_);
}

.st56 {
  clip-path: url(#SVGID_00000163043736577839009440000000882497081296421777_);
}

.st57 {
  clip-path: url(#SVGID_00000091014852849594417960000013841902747418654886_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000081644749857027423640000014390482953379720594_);
}

.st59 {
  clip-path: url(#SVGID_00000018943994831575816210000004358549734021752728_);
}

.st60 {
  clip-path: url(#SVGID_00000148633711728421751000000007528879264092009616_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000158723333214320614810000016928476047171349141_);
}

.st62 {
  clip-path: url(#SVGID_00000112625079621276055410000011242373695282510769_);
}

.st63 {
  clip-path: url(#SVGID_00000035510009542466885360000002794936466927985805_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000155121279821981807090000009291427632706131377_);
}

.st65 {
  clip-path: url(#SVGID_00000026871624863040594590000014757672916395121579_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000098215219539311886130000011377534570618761905_);
}

.st67 {
  clip-path: url(#SVGID_00000155852190241836847610000010067408044731399065_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000170237174608541290460000017982715481286019218_);
}

.st69 {
  clip-path: url(#SVGID_00000040546699931099986640000010436272764862918272_);
}

.st70 {
  clip-path: url(#SVGID_00000102519784397260914510000011911089508309292202_);
}

.st71 {
  clip-path: url(#SVGID_00000143582247121693467100000001099124652509594240_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000142145890824393730370000010522896585785716131_);
}

.st73 {
  clip-path: url(#SVGID_00000078757639798964881290000010321913066055331506_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000044138967446375626510000017348895254265277609_);
}

.st75 {
  clip-path: url(#SVGID_00000049203557300433027640000005791350990944220802_);
}

.st76 {
  clip-path: url(#SVGID_00000023256101446675369530000007595039889981711039_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000097486179006634102280000017405548751846650260_);
}

.st78 {
  clip-path: url(#SVGID_00000114065657786298178250000006652154497459998868_);
}

.st79 {
  clip-path: url(#SVGID_00000003823791051544106900000009819113710465754509_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000009582673694271639070000012803875648495132855_);
}

.st81 {
  clip-path: url(#SVGID_00000139269751815002620590000018076934072275411644_);
}

.st82 {
  clip-path: url(#SVGID_00000000913901781519230560000003838051371985366402_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000008117811798485032780000004580290584069589396_);
}

.st84 {
  clip-path: url(#SVGID_00000003075317327800718530000001978069046639388324_);
}

.st85 {
  clip-path: url(#SVGID_00000135674070485059033120000007942735867844001715_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000066477819616718345550000001728163340559761062_);
}

.st87 {
  clip-path: url(#SVGID_00000156583254986046667810000008491411181259774645_);
}

.st88 {
  clip-path: url(#SVGID_00000107551232882485540990000007052993382240020133_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000045584723567870869760000008538280008466457236_);
}

.st90 {
  clip-path: url(#SVGID_00000020363202248454952320000002460043108983107718_);
}

.st91 {
  clip-path: url(#SVGID_00000093168960024698333990000017432427466062310837_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000057856513590740788150000004078309445780528286_);
}

.st93 {
  clip-path: url(#SVGID_00000124841957633933822100000004459679955943803273_);
}

.st94 {
  clip-path: url(#SVGID_00000051367038333601709570000006568558017686019773_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000047035874544308118180000008500189542427250609_);
}

.st96 {
  clip-path: url(#SVGID_00000056417427201429666940000002586274944671913893_);
}

.st97 {
  clip-path: url(#SVGID_00000021091825828382755720000009160295434989026978_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000101816057075514215950000011975260750113779884_);
}

.st99 {
  clip-path: url(#SVGID_00000044863760103093656920000017310519755712282033_);
}

.st100 {
  clip-path: url(#SVGID_00000040548699538943915520000017409033910892399753_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000103223369829686856650000000329052028678688938_);
}

.st102 {
  clip-path: url(#SVGID_00000153675426686666384630000009123503078195687317_);
}

.st103 {
  clip-path: url(#SVGID_00000167367881649047890190000015400544833728565649_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000103964811061426887910000016954135625407950721_);
}

.st105 {
  clip-path: url(#SVGID_00000150820051801993144870000017404764001914489777_);
}

.st106 {
  clip-path: url(#SVGID_00000034778706040371011170000003118645384088281252_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000024693086889973884020000004225211904014669974_);
}

.st108 {
  clip-path: url(#SVGID_00000002367043989321567180000012889134979744911012_);
}

.st109 {
  clip-path: url(#SVGID_00000149350028154936856700000004941776635166028945_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000158713490496781439360000005900003441583926953_);
}

.st111 {
  clip-path: url(#SVGID_00000145049546215823299490000012855305178838227609_);
}

.st112 {
  clip-path: url(#SVGID_00000116193654271226622160000000538451501161498284_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000039126271892462141610000010294757962234156952_);
}

.st114 {
  clip-path: url(#SVGID_00000066517009807740272810000001619493854316204963_);
}

.st115 {
  clip-path: url(#SVGID_00000026873448638264806790000005321995349261585049_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000011728518595282943780000002630029697441428658_);
}

.st117 {
  clip-path: url(#SVGID_00000000908554371082775660000010696725608608787597_);
}

.st118 {
  clip-path: url(#SVGID_00000152981876544036827080000000865153068130480000_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000131357018645198697940000007195423004319521453_);
}

.st120 {
  clip-path: url(#SVGID_00000075884905368834056330000000464783525624786873_);
}

.st121 {
  clip-path: url(#SVGID_00000057858227776083609350000015307150734742467457_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000153687366421922738190000009375671075844132761_);
}

.st123 {
  clip-path: url(#SVGID_00000085967789144332117620000001431526051735235215_);
}

.st124 {
  clip-path: url(#SVGID_00000132057773839691346530000014074720988452231314_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000156553984685374508130000017263529379259728257_);
}

.st126 {
  clip-path: url(#SVGID_00000036252071089462393300000004564524714747551872_);
}

.st127 {
  clip-path: url(#SVGID_00000135679267748325970400000011812336645266134933_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000021832159285491468520000000308784364842236057_);
}

.st129 {
  clip-path: url(#SVGID_00000087376707185992672570000002486992061087102344_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000171707778174778616050000018157690911280643988_);
}

.st131 {
  clip-path: url(#SVGID_00000119802955853922060110000007378134376486159490_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000023965797020414880090000009923030141620118157_);
}

.st133 {
  clip-path: url(#SVGID_00000059302144535979615920000007713889410247419831_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000039848615539382967090000002671990774214324354_);
}

.st135 {
  clip-path: url(#SVGID_00000156575555447135677030000015056995537432110229_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000021824496431139928610000010095314536550567041_);
}

.st137 {
  clip-path: url(#SVGID_00000163790813368056265660000007981710275700026255_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000125599328406204077910000009332071614940549252_);
}

.st139 {
  clip-path: url(#SVGID_00000060028675355905357970000015476455154429015227_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000108269059745684202820000005677012983751813769_);
}

.st141 {
  clip-path: url(#SVGID_00000018936552017364640730000010135180715060140675_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000116220019794003374430000012977374309481851008_);
}

.st143 {
  clip-path: url(#SVGID_00000103952215736136957340000013186410052409380786_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000114055829229618659450000001224241949280012714_);
}

.st145 {
  clip-path: url(#SVGID_00000031167623924630501790000006423555534302696104_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000145756157895162759820000003788758870485575077_);
}

.st147 {
  clip-path: url(#SVGID_00000091717781824555704560000010504039124441158801_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000087370892585129596700000003383654756049882496_);
}

.st149 {
  clip-path: url(#SVGID_00000076588069437434869200000010011929353510983827_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000170274756466915173530000010210358914930203056_);
}

.st151 {
  clip-path: url(#SVGID_00000110460005135422891790000016988825988869842314_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000059283128755611085370000008787730521046083218_);
}

.st153 {
  clip-path: url(#SVGID_00000129885456812692416550000001424323839220239794_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000017511208085875145950000007307376251744995748_);
}

.st155 {
  clip-path: url(#SVGID_00000067220361467922787500000015983597456145405086_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000037690625762322129690000012373646016046287024_);
}

.st157 {
  clip-path: url(#SVGID_00000098195281521231800570000012061940582913028247_);
}

.st158 {
  clip-path: url(#SVGID_00000152244469407722893860000002617307857515703959_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000041277041807226711200000017265411216599431587_);
}

.st160 {
  clip-path: url(#SVGID_00000106864881398366075650000001059668257472589969_);
}

.st161 {
  clip-path: url(#SVGID_00000053503393096796142640000006681365731219055523_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000106841079232568178920000002222434717745705364_);
}

.st163 {
  clip-path: url(#SVGID_00000001634154137969329180000013777675935448681857_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000028322144715853459160000003959019604426717326_);
}

.st165 {
  clip-path: url(#SVGID_00000166668803282767030830000011400072472216114856_);
}

.st166 {
  clip-path: url(#SVGID_00000052820356898520663660000011035563898986905222_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000128474348800191738240000015149253781252008598_);
}

.st168 {
  clip-path: url(#SVGID_00000112609381701418656880000011045140879157716377_);
}

.st169 {
  clip-path: url(#SVGID_00000144335391019171163700000016353868407453289624_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000111150990051779425270000010243666273429867908_);
}

.st171 {
  clip-path: url(#SVGID_00000124131722174356800690000003942667380451073172_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000118371932271567808790000009242784593459909260_);
}

.st173 {
  clip-path: url(#SVGID_00000022522610318590466230000011999759313206351511_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000122701640639472250420000004210119341329531273_);
}

.st175 {
  clip-path: url(#SVGID_00000165212238865616775870000014338878884893553554_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000041263518427473882940000016266454687250244271_);
}

.st177 {
  clip-path: url(#SVGID_00000155869492987264746050000001355874265295259806_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000179611675568395732030000007357846801895214243_);
}

.st179 {
  clip-path: url(#SVGID_00000086677239937884155830000015167902678008315272_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000092438849059200705880000005686123551699345035_);
}

.st181 {
  clip-path: url(#SVGID_00000060023788721779265590000011275434839547899272_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000069386190703703829530000000154585618090443709_);
}

.st183 {
  clip-path: url(#SVGID_00000149371382939948175960000005939372546861812140_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000173161078938587002540000000264298100539802240_);
}

.st185 {
  clip-path: url(#SVGID_00000134968771420732087310000016932859784482160529_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000181058589149100004970000018210707210444482234_);
}

.st187 {
  clip-path: url(#SVGID_00000149340820361690710750000006286511489231003310_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000084513118559795709610000007275393558155074215_);
}

.st189 {
  clip-path: url(#SVGID_00000104695635968171231340000015944475199055502729_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000101065291623308889900000015626657287631448509_);
}

.st191 {
  clip-path: url(#SVGID_00000173867792334969501590000010599540932903210656_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000080896999591277673110000000052337835622645654_);
}

.st193 {
  clip-path: url(#SVGID_00000138564361218894605540000009262331276701632646_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000169553957917770224150000006229997513660373393_);
}

.st195 {
  clip-path: url(#SVGID_00000073680803052037663140000007852954052725217174_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000055677604401586757800000009492240353697664650_);
}

.st197 {
  clip-path: url(#SVGID_00000004542042084160853130000013217875658822148262_);
}

.st198 {
  clip-path: url(#SVGID_00000034788435359971040380000017087861236016682666_);
}

.st199 {
  clip-path: url(#SVGID_00000164475027526830198590000010535531360262855579_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000142171153620665346510000003895860590604648586_);
}

.st201 {
  clip-path: url(#SVGID_00000039135926586301985880000009305943052913397181_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000127722455947341679310000015876643626684884391_);
}

.st203 {
  clip-path: url(#SVGID_00000005961294103905530230000001874707293891808905_);
}

.st204 {
  clip-path: url(#SVGID_00000018220033868236967930000015459990417251018421_);
}

.st205 {
  clip-path: url(#SVGID_00000145030753309731107680000015783965229141631678_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000011011320150864103110000003344866250739768968_);
}

.st207 {
  clip-path: url(#SVGID_00000018956215203317652450000012675251912583775390_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000050624405837613066630000011792708133405619116_);
}

.st209 {
  clip-path: url(#SVGID_00000081608025495800431700000017681549330793146549_);
}

.st210 {
  clip-path: url(#SVGID_00000182517875869456218110000016353983071615138455_);
}

.st211 {
  clip-path: url(#SVGID_00000048477242056548215090000010232119157709699457_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000060740433028457402400000008881787037662984339_);
}

.st213 {
  clip-path: url(#SVGID_00000154423761055586897280000015445901103721191604_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000151528399435129337950000011419923047366010501_);
}

.st215 {
  clip-path: url(#SVGID_00000072997097949551510870000005334141947796621498_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000168077826152931106960000001490179620461433987_);
}

.st217 {
  clip-path: url(#SVGID_00000144321513371836504320000001643251776763430056_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000172436565827724515750000012428719628982881159_);
}

.st219 {
  clip-path: url(#SVGID_00000168825512091322988320000003744103699421859979_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000040537197583632750100000007079144314872699549_);
}

.st221 {
  clip-path: url(#SVGID_00000095305431920786292550000003352637673123113916_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000129177316342593083520000017589336957186482055_);
}

.st223 {
  clip-path: url(#SVGID_00000164485882850742516210000007109659174574185126_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000094612599397201154700000000134672306485542843_);
}

.st225 {
  clip-path: url(#SVGID_00000137117805065321858300000006515433839550134440_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000180360829630440704210000006186120284189394318_);
}

.st227 {
  clip-path: url(#SVGID_00000177443532197886759610000003060628462947663025_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000155825023916459631660000012745965548066882446_);
}

.st229 {
  clip-path: url(#SVGID_00000129199453710533427390000011422815554275306385_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000074419893270700874150000018203176043651446414_);
}

.st231 {
  clip-path: url(#SVGID_00000020401011681112587370000014014586636158935460_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000059308585980994268040000000484398881826008236_);
}

.st233 {
  clip-path: url(#SVGID_00000082367355773040629560000011174210933247152783_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000164475816950403756750000014057673350975193998_);
}

.st235 {
  clip-path: url(#SVGID_00000146472630499629386230000016645404698779277203_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000099660170122261092970000012380300611157471932_);
}

.st237 {
  clip-path: url(#SVGID_00000092431269436385014460000000700885425066584705_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000181068845431301803220000001194994460455805605_);
}

.st239 {
  clip-path: url(#SVGID_00000145052335572770860390000005197789669428537231_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000135648746174006550720000011583302416390061986_);
}

.st241 {
  clip-path: url(#SVGID_00000007405644849891744720000004081733209953808572_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000157299912968742021140000002364039360175783336_);
}

.st243 {
  clip-path: url(#SVGID_00000104708586498147351340000016589517545663450754_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000016758435172144864780000007220088931756500395_);
}

.st245 {
  clip-path: url(#SVGID_00000147941489298477489190000005444741750096964516_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000083089338569087577590000016431604277131498130_);
}

.st247 {
  clip-path: url(#SVGID_00000149370160048321947090000007272925107492053130_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000020399260873991615480000006125328009890998156_);
}

.st249 {
  clip-path: url(#SVGID_00000116935293258885656330000002335911041212566920_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000038373092746315406830000004341588688768703931_);
}

.st251 {
  clip-path: url(#SVGID_00000090995048924653272280000005616473395441772466_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000034054888540955673940000000273697343712146325_);
}

.st253 {
  clip-path: url(#SVGID_00000018213268980218136690000003929816655551681453_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000079467615589593395030000003904719951681771915_);
}

.st255 {
  clip-path: url(#SVGID_00000098214044118558020720000012104129838082181778_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000161627226122526696860000002371300275088957607_);
}

.st257 {
  clip-path: url(#SVGID_00000120541374901208827400000014020587877566371514_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000110445259026949657860000006891121996776126099_);
}

.st259 {
  clip-path: url(#SVGID_00000015324082815164880470000004461009282196223163_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000066501051075724187480000007318783535797464716_);
}

.st261 {
  clip-path: url(#SVGID_00000006704613426205288470000018021522009315085980_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000146501281488458587180000000911639670693351553_);
}

.st263 {
  clip-path: url(#SVGID_00000178890215855420464680000010799910896922566067_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000125562202214372624350000011185200587622216605_);
}

.st265 {
  clip-path: url(#SVGID_00000026123644260021443010000016932075964870534332_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000142146703729182036550000002061535218119915709_);
}

.st267 {
  clip-path: url(#SVGID_00000031909372458473981590000011553008740735683209_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000034801353596433362470000003667746236723193472_);
}

.st269 {
  clip-path: url(#SVGID_00000075135471080958727330000006107043230375174841_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000146473398201930237810000004699884985580381366_);
}

.st271 {
  clip-path: url(#SVGID_00000065755273331957544630000000079059237901296528_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000065763786382379138830000011708207874957195953_);
}

.st273 {
  clip-path: url(#SVGID_00000022533300433412144730000010807965586097817266_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000175310543822007660640000004575183103087970983_);
}

.st275 {
  clip-path: url(#SVGID_00000176021687804781784310000005660339699657827224_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000166643609782438643490000000627793959276971910_);
}

.st277 {
  clip-path: url(#SVGID_00000035506454227806964420000012331791249584957572_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000153686114844827487910000000919006027455238055_);
}

.st279 {
  clip-path: url(#SVGID_00000070826230237434069200000013854946438011601595_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000178190051217102672060000010481991231869092782_);
}

.st281 {
  clip-path: url(#SVGID_00000127745724723275786060000006788515106591100061_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000023969743405307191520000014871973891502649520_);
}

.st283 {
  clip-path: url(#SVGID_00000169515568551014391980000004527497999929217436_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000145020618039282271020000005723638982292212154_);
}

.st285 {
  clip-path: url(#SVGID_00000147179577239598442720000005088134493712460173_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000134935032434746407150000016854546422281348027_);
}

.st287 {
  clip-path: url(#SVGID_00000072960015972181283680000002585986380122363787_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000141457568715390885750000009352961473838810258_);
}

.st289 {
  clip-path: url(#SVGID_00000151518696379836673600000014821540002453709710_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000103241668445751535400000010796784432437069203_);
}

.st291 {
  clip-path: url(#SVGID_00000008827978766868631560000001339040708470047926_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000092416839030716717960000000707624268071656839_);
}

.st293 {
  clip-path: url(#SVGID_00000002358690860455772470000006617871148048610234_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000116918251212364021120000011281344070824699787_);
}

.st295 {
  clip-path: url(#SVGID_00000089562042558531167710000001993773144927943044_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000008110937663673234740000008311560758589837757_);
}

.st297 {
  clip-path: url(#SVGID_00000006699414609973176210000009783127557501721764_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000104671495272455765680000007187509895028505224_);
}

.st299 {
  clip-path: url(#SVGID_00000011720196992218631140000012195321389733474750_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000069357544083065214800000011515991898873499780_);
}

.st301 {
  clip-path: url(#SVGID_00000073703737180739759550000002022675325677057471_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000172435703761963424600000005184714949875588520_);
}

.st303 {
  clip-path: url(#SVGID_00000134219213757018624250000000157400220629014444_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000146499086975715689590000001510245274031901106_);
}

.st305 {
  clip-path: url(#SVGID_00000034083844126611060680000013571424681870010284_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000003063040960686300260000004845915222000289961_);
}

.st307 {
  clip-path: url(#SVGID_00000030456724324442032250000011933244373389706929_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000125599388413928279800000008971012910651632781_);
}

.st309 {
  clip-path: url(#SVGID_00000171001614558917343670000017285067138995320199_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000084499187787477236540000010791586123278647689_);
}

.st311 {
  clip-path: url(#SVGID_00000014625164468183095560000004169640110212104609_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000178178568381382206810000000532940553164788402_);
}

.st313 {
  clip-path: url(#SVGID_00000000206316064161982150000018441066130913241495_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000025424238185268119900000003389968881530670740_);
}

.st315 {
  clip-path: url(#SVGID_00000056390685255192790740000001182563056168350880_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000127002907687492587470000004750769688615977371_);
}

.st317 {
  clip-path: url(#SVGID_00000108303505231044668870000016748171454213024173_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000125589791885165990740000011100935227355944110_);
}

.st319 {
  clip-path: url(#SVGID_00000067224273340050165030000001000566701108104369_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000057838991695677280590000008356654528201724830_);
}

.st321 {
  clip-path: url(#SVGID_00000096047030505711127120000005950114213658435241_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000134938724668912321070000015020986604486824837_);
}

.st323 {
  clip-path: url(#SVGID_00000117673941380395350500000015994353651744278919_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000011032354549375264910000017265504997770988183_);
}

.st325 {
  clip-path: url(#SVGID_00000026148371295438519020000000354564225917470627_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000173840034848113816820000010327423672430677638_);
}

.st327 {
  clip-path: url(#SVGID_00000123410898303967374510000001297326734253989283_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000124868811805900519100000005167730389376530847_);
}

.st329 {
  clip-path: url(#SVGID_00000029729345770891106200000001466789005967702938_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000087387735555996185230000017758181333379935887_);
}

.st331 {
  clip-path: url(#SVGID_00000062192837555151730120000009451694559065150097_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000003071064430813100290000007353639906025301147_);
}

.st333 {
  clip-path: url(#SVGID_00000089552186174443025660000006589412438185356165_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000106840366181194772780000008715510657034677409_);
}

.st335 {
  clip-path: url(#SVGID_00000064316564401376628480000006804438181775578545_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000166652183177729487920000000655183978028451243_);
}

.st337 {
  clip-path: url(#SVGID_00000036223904056962932350000004102970435863516319_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000039124465864326103970000002529808549556715431_);
}

.st339 {
  clip-path: url(#SVGID_00000151518366644456507430000017271029135695443098_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000163067231319577288320000014033739458185969343_);
}

.st341 {
  clip-path: url(#SVGID_00000080203161637222232610000017383309353297923493_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000174577805943006079760000006743933099270684346_);
}

.st343 {
  clip-path: url(#SVGID_00000140699677058980386480000015292437839457075383_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000168831927830091993620000011490474034847958952_);
}

.st345 {
  clip-path: url(#SVGID_00000065055103122332642570000005456177225528503437_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000038372917080900220750000009134062708753157529_);
}

.st347 {
  clip-path: url(#SVGID_00000123434005503214208410000005689196378351684515_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000158745402981331007890000000528020615674119337_);
}

.st349 {
  clip-path: url(#SVGID_00000016767649927029079770000005699375702422932869_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000094616770603502410700000007786085273424038804_);
}

.st351 {
  clip-path: url(#SVGID_00000016792321682424808680000001216875718907003270_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000160157232135120983920000000851705233843476391_);
}

.st353 {
  clip-path: url(#SVGID_00000044863205458173174920000003150553705048258224_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000088819391746729624620000008155538057736587682_);
}

.st355 {
  clip-path: url(#SVGID_00000164483998357866712290000012925155159602794384_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000078047302932161273190000012232660573389212351_);
}

.st357 {
  clip-path: url(#SVGID_00000166659798421977123400000000336171893755385239_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000016753967510557369640000011557992292209261982_);
}

.st359 {
  clip-path: url(#SVGID_00000039822709747225425310000017965774053832062613_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000021116708326036990260000008372082653801196965_);
}

.st361 {
  clip-path: url(#SVGID_00000171689527481482803120000014046359758827060927_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000049930218516994447240000015366856547919884471_);
}

.st363 {
  clip-path: url(#SVGID_00000088126543165737211200000005910433774790867614_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000016754087896139503460000002874189062711748495_);
}

.st365 {
  clip-path: url(#SVGID_00000147217538617752877910000012476394702347578033_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000000219512973939647970000000041567414311126689_);
}

.st367 {
  clip-path: url(#SVGID_00000085236262654410171260000013514164215696035723_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000152962647199027724450000017806860165716896950_);
}

.st369 {
  clip-path: url(#SVGID_00000101792344124870898220000008832907913695099281_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000036225585310351975900000014128228911490894511_);
}

.st371 {
  clip-path: url(#SVGID_00000173153832513913251950000007456954739471630508_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000139252047019640737290000012358602881214629552_);
}

.st373 {
  clip-path: url(#SVGID_00000147936869011886032820000002930298491515813300_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000067220453563324539690000014158630219038210233_);
}

.st375 {
  clip-path: url(#SVGID_00000121260131571027041880000014893325279316800158_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000150087957606794664950000008360262001503685563_);
}

.st377 {
  clip-path: url(#SVGID_00000093146181008857751820000015650579477796562075_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000182521607598049869310000009401576981705183383_);
}

.st379 {
  clip-path: url(#SVGID_00000067235991400690959790000017494273088201308064_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000015352346492176537520000009500002494347018662_);
}

.st381 {
  clip-path: url(#SVGID_00000179645359289522813420000014127062637721424258_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000028306054610016075730000001446622330233784744_);
}

.st383 {
  clip-path: url(#SVGID_00000142153452358129057950000013907670779516017538_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000035529409591567133350000009578201461526118584_);
}

.st386 {
  clip-path: url(#SVGID_00000163032373650686051170000011814862506697701786_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000056407159152995834030000005494235602708977056_);
}

.st388 {
  clip-path: url(#SVGID_00000039847606580886513980000011114016414635814540_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000038385748797685936240000008333268227263851415_);
}

.st390 {
  clip-path: url(#SVGID_00000170971452922192656260000008865970023102865068_);
}

.st391 {
  clip-path: url(#SVGID_00000104666067110944682220000018326850480299178643_);
}

.st392 {
  clip-path: url(#SVGID_00000161608068167316367890000015929701602963837321_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000033349726719760440380000008873595520952103297_);
}

.st394 {
  clip-path: url(#SVGID_00000137828950413505398390000004907680707793893802_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000157284077104033649120000004418420893739384231_);
}

.st396 {
  clip-path: url(#SVGID_00000082352006214136526180000016760939491698256049_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000070816575533395341370000002513933414144266889_);
}

.st398 {
  clip-path: url(#SVGID_00000111890059147378993050000005664743560579366794_);
}

.st399 {
  clip-path: url(#SVGID_00000040550393970376818740000017885155652485558677_);
}

.st400 {
  clip-path: url(#SVGID_00000106116004535648170590000000533940517425177518_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000009571328426410626650000017382103874668058790_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000157304248786539498380000006737686009498536325_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000147919056289655006310000009109033042386211003_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000106126395751646710800000011235176925488790158_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000147913732650112596840000013150354427587642025_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000021807402783608342310000013401596770517239178_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000005974548536538496260000002334843679208702875_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000036944947258165815980000009529565377467562676_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000023962593398892900430000013779443425145741974_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000000903710159347373000000002139297653550147464_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000129207989676201273570000002564810390989085329_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000048470147011939810440000001209772990504925619_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000129173441469279545670000017088903733083399820_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000098213154081652566530000001264964706715774094_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000124161720598314725260000004106272502370046632_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000034084507295877076920000013695140096621002407_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000161592579508775966860000014724997516904745094_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000109751281923629175700000001594813313939656087_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000128476150431995540630000000847695405789146287_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000140719539390294190500000013560204540267357829_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000179618728551643383260000004753944035843671227_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000114787058925790010760000001210947610517096866_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000017479544781846511840000002995305739094284461_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000095316571114168031920000001428534970610529700_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000116214158551660057070000005307259728692784516_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000165210874926041688970000015228558947251204994_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000094606957287691565370000005504948677637119926_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000135677017531783018880000009606564467918212764_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000173872122772416622730000018346518021699031198_);
}

.st477 {
  fill: url(#SVGID_00000029003678978786904100000005037829122185026977_);
}

.st478 {
  fill: url(#SVGID_00000053521148089530329660000003076090060966224570_);
}

.st479 {
  fill: url(#SVGID_00000094620485648782441050000003838448251498047933_);
}

.st480 {
  fill: url(#SVGID_00000093166483661970113400000007846557534138467510_);
}

.st481 {
  fill: url(#SVGID_00000053504677526174822680000011274286205660867724_);
}

.st482 {
  fill: url(#SVGID_00000048464188252811696850000008506796212472110248_);
}

.st483 {
  fill: url(#SVGID_00000099639463771856494170000003702001186199996039_);
}

.st484 {
  fill: url(#SVGID_00000000204371380818625910000008787001744278017182_);
}

.st485 {
  fill: url(#SVGID_00000181060210918891842210000011764402745642544823_);
}

.st486 {
  fill: url(#SVGID_00000156555928867373403040000003112487890351376541_);
}

.st487 {
  fill: url(#SVGID_00000062883072377999491740000003808503895603871881_);
}

.st488 {
  fill: url(#SVGID_00000040537731910715998140000011560637485615011464_);
}

.st489 {
  fill: url(#SVGID_00000111908853709647190000000017398457421689587599_);
}

.st490 {
  fill: url(#SVGID_00000016071455549273738480000004862210077221287864_);
}

.st491 {
  fill: url(#SVGID_00000134207642063413407860000018245334974884131499_);
}

.st492 {
  fill: url(#SVGID_00000008844203825554797160000011114802380270642835_);
}

.st493 {
  fill: url(#SVGID_00000133506541548170724500000003282528404645288584_);
}

.st494 {
  fill: url(#SVGID_00000127743528125181097600000015026483426357588883_);
}

.st495 {
  fill: url(#SVGID_00000127762244384643094470000007684211304255043990_);
}

.st496 {
  fill: url(#SVGID_00000028316413963061153870000009699735659340377269_);
}

.st497 {
  fill: url(#SVGID_00000035499891569361348720000013970910235230207903_);
}

.st498 {
  fill: url(#SVGID_00000109014281326303322060000007611093386582318014_);
}

.st499 {
  fill: url(#SVGID_00000010990392523886856980000011153930991032650371_);
}

.st500 {
  fill: url(#SVGID_00000096059225954010200160000005733086312292436877_);
}

.st501 {
  fill: url(#SVGID_00000002380313362347694490000013071257290920187571_);
}

.st502 {
  fill: url(#SVGID_00000067930011566859166600000011300338275657415819_);
}

.st503 {
  fill: url(#SVGID_00000171708477450372268480000000290190523315075201_);
}

.st504 {
  fill: url(#SVGID_00000003089289420365468510000013267497339384860067_);
}

.st505 {
  fill: url(#SVGID_00000121253836346674286980000010511189631531810736_);
}

.st506 {
  fill: url(#SVGID_00000181779162145488799350000018301859894823959740_);
}

.st507 {
  fill: url(#SVGID_00000000206273929239119700000000385102490197985956_);
}

.st508 {
  fill: url(#SVGID_00000004534122484951666350000018261830480099410834_);
}

.st509 {
  fill: url(#SVGID_00000165922403227562063540000013259964527950434212_);
}

.st510 {
  fill: url(#SVGID_00000103946668830767807330000002569924039114168708_);
}

.st511 {
  fill: url(#SVGID_00000088106953750956905810000003442708933311366288_);
}

.st512 {
  fill: url(#SVGID_00000158009732249042068060000002673214772346431394_);
}

.st513 {
  fill: url(#SVGID_00000173848471604643310400000014420616444713414798_);
}

.st514 {
  fill: url(#SVGID_00000181072193861854041470000006835738851060171141_);
}

.st515 {
  fill: url(#SVGID_00000177466754928286208550000009135047686558523277_);
}

.st516 {
  fill: url(#SVGID_00000121968510898680067270000016220785480622863524_);
}

.st517 {
  fill: url(#SVGID_00000136399926606373844810000010908617415273526678_);
}

.st518 {
  fill: url(#SVGID_00000129172834451846804470000005243460706277274265_);
}

.st519 {
  fill: url(#SVGID_00000023975222512690627400000015995161741233845378_);
}

.st520 {
  fill: url(#SVGID_00000013161052727942710360000018430166495023782306_);
}

.st521 {
  fill: url(#SVGID_00000150788039687608371700000001932596874209537445_);
}

.st522 {
  fill: url(#SVGID_00000088840419649088266960000016719654281572140459_);
}

.st523 {
  fill: url(#SVGID_00000075137199725577317590000010657088088619218329_);
}

.st524 {
  fill: url(#SVGID_00000105398022446632677960000016546096701754427069_);
}

.st525 {
  fill: url(#SVGID_00000058575059873444015020000015290302014678200205_);
}

.st526 {
  fill: url(#SVGID_00000167391389754395513530000009717184080206486943_);
}

.st527 {
  fill: url(#SVGID_00000166670426095775758140000000224721359742664620_);
}

.st528 {
  fill: url(#SVGID_00000069367109868868710900000013242174138941060540_);
}

.st529 {
  fill: url(#SVGID_00000091734291278271817520000014627396102352312758_);
}

.st530 {
  fill: url(#SVGID_00000093167591790731233910000007521113860519261352_);
}

.st531 {
  fill: url(#SVGID_00000173864503670404272510000003607459457478602677_);
}

.st532 {
  fill: url(#SVGID_00000052100305575380250850000016207287546995721349_);
}

.st533 {
  fill: url(#SVGID_00000129922042282641892050000013400370977988005811_);
}

.st534 {
  fill: url(#SVGID_00000108296416891336578340000014090815964359236018_);
}

.st535 {
  fill: url(#SVGID_00000096748108443121451010000006937978377882669233_);
}

.st536 {
  fill: url(#SVGID_00000094598054775007137520000006847990622642837156_);
}

.st537 {
  fill: url(#SVGID_00000027604033426745309660000017949232213994147970_);
}

.st538 {
  fill: url(#SVGID_00000088811425619443745260000005509824201292370109_);
}

.st539 {
  fill: url(#SVGID_00000148630167069627054300000003726729930311413120_);
}

.st540 {
  fill: url(#SVGID_00000035514990720323833390000001171697406268215690_);
}

.st541 {
  fill: url(#SVGID_00000125585540446003845710000008166613469729685685_);
}

.st542 {
  fill: url(#SVGID_00000106111050422605833850000008431767787933773751_);
}

.st543 {
  fill: url(#SVGID_00000127746354380397222910000000083973881104449667_);
}

.st544 {
  fill: url(#SVGID_00000015350444330682706400000007555969539915986064_);
}

.st545 {
  fill: url(#SVGID_00000153693302606501297870000009594898319650571413_);
}

.st546 {
  fill: url(#SVGID_00000150821830442478053730000017419222462298391440_);
}

.st547 {
  fill: url(#SVGID_00000078753972714079345540000002109088201614401668_);
}

.st548 {
  fill: url(#SVGID_00000010301233884234120470000000648039366006308006_);
}

.st549 {
  fill: url(#SVGID_00000016763627707177726590000012005551265197206692_);
}

.st550 {
  fill: url(#SVGID_00000070807624033262194370000009635160953406778248_);
}

.st551 {
  fill: url(#SVGID_00000103980650811843936120000008735323362146992313_);
}

.st552 {
  fill: url(#SVGID_00000173163390579715568210000006844863005737762445_);
}

.st553 {
  fill: url(#SVGID_00000147185936380429423280000008051953205810191507_);
}

.st554 {
  fill: url(#SVGID_00000041253655087512698860000003010666845161765794_);
}

.st555 {
  fill: url(#SVGID_00000084492155680782421770000002036120804080311429_);
}

.st556 {
  fill: url(#SVGID_00000044895848507951337710000011436146232964004509_);
}

.st557 {
  fill: url(#SVGID_00000183236961896330314220000008150981881184790678_);
}

.st558 {
  fill: url(#SVGID_00000044143632848725423990000010004380065204350133_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000024682927960601015370000011692185018196379834_);
}

.st571 {
  fill: url(#SVGID_00000142172534234693019560000010007496088806616465_);
}

.st572 {
  fill: url(#SVGID_00000101097845048605172040000017574197810453628859_);
}

.st573 {
  fill: url(#SVGID_00000178188190120660479880000013677274292462041238_);
}

.st574 {
  fill: url(#SVGID_00000114045592754358682270000011690478748027005104_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000182521969125193715520000002587158664060153493_);
}

.st577 {
  fill: url(#SVGID_00000001656173721567401960000014739472782274184884_);
}

.st578 {
  fill: url(#SVGID_00000093875451755755963150000003562034068489587842_);
}

.st579 {
  fill: url(#SVGID_00000092420280956142877350000018094413915986939522_);
}

.st580 {
  fill: url(#SVGID_00000108290165912334593480000008879262249535377057_);
}

.st581 {
  fill: url(#SVGID_00000064340505038167767800000010644873275141372590_);
}

.st582 {
  fill: url(#SVGID_00000021824741488482208500000017750700915039836593_);
}

.st583 {
  fill: url(#SVGID_00000183956482701600913830000007621925127609576070_);
}

.st584 {
  fill: url(#SVGID_00000078747841311988079840000009768947132279566225_);
}

.st585 {
  fill: url(#SVGID_00000091715352210930314990000014517596712145344139_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000017479644677871060270000011444279214462613680_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000093879111416197547400000011961718339494093200_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000032630165604067454250000010401497838102141625_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000068666973695449464860000011622306433371349136_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000026141540066196452190000009461958006236581817_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000150100964287651760200000005748202285981506475_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000124880394852712026570000009904390293263122594_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000060724450757940981050000007956537587975274648_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000180341308305049745960000012383848280692802694_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000058571414479781317630000014607289332739960730_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000069365294863190756740000015845657235519858616_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000181081673436965699020000008308107384784546731_);
}

.st599 {
  fill: url(#SVGID_00000155855018688775354770000015006752832508910995_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000071539422977627576990000011731418181698707097_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000011726957951820708010000002614312588455899567_);
}

.st602 {
  fill: url(#SVGID_00000029037922867484267360000005643073179129665966_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000183219733045799307770000004537569752850384549_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000023277476238740482240000006050117514911653783_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000111184584748268420610000002078768485310964358_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000092441276960187024940000010587399277677813900_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000057837205556811818550000004751156763780912284_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000063610151698571024140000016086158099171150756_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000141419820774789609970000008903116034218290838_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000144312946196160315550000007547669995639907734_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000047028012268246678120000000474245267080568255_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000171693031652022558970000004151748304364375443_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000145026466409099509730000014931078808869632657_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000018940013153266130910000001605342539466004139_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000144331278160564161520000007425340964415367094_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000001647962795493296700000014121037497233675704_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000073706515487100208570000012203009834855290018_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000115514702463468817420000007560045361641586334_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000005950574966386772200000004337266661664082052_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000013177713826393724780000002818041244963525006_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000081621422085986331050000012664880062949649033_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000045576561577731390330000010532167133246771853_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000110448871537335541280000000627373121969253047_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000168114716805372906950000016392358392842715293_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000128485393392913536100000013669725402723119250_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000022535219693967614620000016756118514601152676_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000131345855533617733370000006149671891951285159_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000125573845127137063030000011952394683166583959_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000142898286048099150070000000593088720815045257_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000145756382374210976730000017252996998627755142_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000044858162072849242410000007045894798525069483_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000145035002332440744150000016122397193685830018_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000126282906209474009000000018112049238596503479_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000036219048872409573440000013970755844925875855_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000060743530940827147930000016734040919814993581_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000119088655999491003100000007636218839006693763_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000168801327740558378020000010092450286774641598_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000178193831626227121240000002809140698907003320_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000120557800318750242710000017735872620082755721_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000008867417647271534660000005280045006007291554_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}
</style>